(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("classnames"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["classnames", "react", "lodash", "prop-types", "@fiverr/i18n/singleton", "@fiverr/gofor", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["SellerCard"] = factory(require("classnames"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else
		root["SellerCard"] = factory(root["classNames"], root["React"], root["_"], root["PropTypes"], root["i18n"], root["goforFactory"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_JgyH__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_PbPb__, __WEBPACK_EXTERNAL_MODULE_T9WB__, __WEBPACK_EXTERNAL_MODULE_h4G9__, __WEBPACK_EXTERNAL_MODULE_jPm4__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/seller_card/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "lVK7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/cOS":
/***/ (function(module, exports) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

function getDefaultWhiteList () {
  // 白名单值说明：
  // true: 允许该属性
  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
  // 除上面列出的值外均表示不允许
  var whiteList = {};

  whiteList['align-content'] = false; // default: auto
  whiteList['align-items'] = false; // default: auto
  whiteList['align-self'] = false; // default: auto
  whiteList['alignment-adjust'] = false; // default: auto
  whiteList['alignment-baseline'] = false; // default: baseline
  whiteList['all'] = false; // default: depending on individual properties
  whiteList['anchor-point'] = false; // default: none
  whiteList['animation'] = false; // default: depending on individual properties
  whiteList['animation-delay'] = false; // default: 0
  whiteList['animation-direction'] = false; // default: normal
  whiteList['animation-duration'] = false; // default: 0
  whiteList['animation-fill-mode'] = false; // default: none
  whiteList['animation-iteration-count'] = false; // default: 1
  whiteList['animation-name'] = false; // default: none
  whiteList['animation-play-state'] = false; // default: running
  whiteList['animation-timing-function'] = false; // default: ease
  whiteList['azimuth'] = false; // default: center
  whiteList['backface-visibility'] = false; // default: visible
  whiteList['background'] = true; // default: depending on individual properties
  whiteList['background-attachment'] = true; // default: scroll
  whiteList['background-clip'] = true; // default: border-box
  whiteList['background-color'] = true; // default: transparent
  whiteList['background-image'] = true; // default: none
  whiteList['background-origin'] = true; // default: padding-box
  whiteList['background-position'] = true; // default: 0% 0%
  whiteList['background-repeat'] = true; // default: repeat
  whiteList['background-size'] = true; // default: auto
  whiteList['baseline-shift'] = false; // default: baseline
  whiteList['binding'] = false; // default: none
  whiteList['bleed'] = false; // default: 6pt
  whiteList['bookmark-label'] = false; // default: content()
  whiteList['bookmark-level'] = false; // default: none
  whiteList['bookmark-state'] = false; // default: open
  whiteList['border'] = true; // default: depending on individual properties
  whiteList['border-bottom'] = true; // default: depending on individual properties
  whiteList['border-bottom-color'] = true; // default: current color
  whiteList['border-bottom-left-radius'] = true; // default: 0
  whiteList['border-bottom-right-radius'] = true; // default: 0
  whiteList['border-bottom-style'] = true; // default: none
  whiteList['border-bottom-width'] = true; // default: medium
  whiteList['border-collapse'] = true; // default: separate
  whiteList['border-color'] = true; // default: depending on individual properties
  whiteList['border-image'] = true; // default: none
  whiteList['border-image-outset'] = true; // default: 0
  whiteList['border-image-repeat'] = true; // default: stretch
  whiteList['border-image-slice'] = true; // default: 100%
  whiteList['border-image-source'] = true; // default: none
  whiteList['border-image-width'] = true; // default: 1
  whiteList['border-left'] = true; // default: depending on individual properties
  whiteList['border-left-color'] = true; // default: current color
  whiteList['border-left-style'] = true; // default: none
  whiteList['border-left-width'] = true; // default: medium
  whiteList['border-radius'] = true; // default: 0
  whiteList['border-right'] = true; // default: depending on individual properties
  whiteList['border-right-color'] = true; // default: current color
  whiteList['border-right-style'] = true; // default: none
  whiteList['border-right-width'] = true; // default: medium
  whiteList['border-spacing'] = true; // default: 0
  whiteList['border-style'] = true; // default: depending on individual properties
  whiteList['border-top'] = true; // default: depending on individual properties
  whiteList['border-top-color'] = true; // default: current color
  whiteList['border-top-left-radius'] = true; // default: 0
  whiteList['border-top-right-radius'] = true; // default: 0
  whiteList['border-top-style'] = true; // default: none
  whiteList['border-top-width'] = true; // default: medium
  whiteList['border-width'] = true; // default: depending on individual properties
  whiteList['bottom'] = false; // default: auto
  whiteList['box-decoration-break'] = true; // default: slice
  whiteList['box-shadow'] = true; // default: none
  whiteList['box-sizing'] = true; // default: content-box
  whiteList['box-snap'] = true; // default: none
  whiteList['box-suppress'] = true; // default: show
  whiteList['break-after'] = true; // default: auto
  whiteList['break-before'] = true; // default: auto
  whiteList['break-inside'] = true; // default: auto
  whiteList['caption-side'] = false; // default: top
  whiteList['chains'] = false; // default: none
  whiteList['clear'] = true; // default: none
  whiteList['clip'] = false; // default: auto
  whiteList['clip-path'] = false; // default: none
  whiteList['clip-rule'] = false; // default: nonzero
  whiteList['color'] = true; // default: implementation dependent
  whiteList['color-interpolation-filters'] = true; // default: auto
  whiteList['column-count'] = false; // default: auto
  whiteList['column-fill'] = false; // default: balance
  whiteList['column-gap'] = false; // default: normal
  whiteList['column-rule'] = false; // default: depending on individual properties
  whiteList['column-rule-color'] = false; // default: current color
  whiteList['column-rule-style'] = false; // default: medium
  whiteList['column-rule-width'] = false; // default: medium
  whiteList['column-span'] = false; // default: none
  whiteList['column-width'] = false; // default: auto
  whiteList['columns'] = false; // default: depending on individual properties
  whiteList['contain'] = false; // default: none
  whiteList['content'] = false; // default: normal
  whiteList['counter-increment'] = false; // default: none
  whiteList['counter-reset'] = false; // default: none
  whiteList['counter-set'] = false; // default: none
  whiteList['crop'] = false; // default: auto
  whiteList['cue'] = false; // default: depending on individual properties
  whiteList['cue-after'] = false; // default: none
  whiteList['cue-before'] = false; // default: none
  whiteList['cursor'] = false; // default: auto
  whiteList['direction'] = false; // default: ltr
  whiteList['display'] = true; // default: depending on individual properties
  whiteList['display-inside'] = true; // default: auto
  whiteList['display-list'] = true; // default: none
  whiteList['display-outside'] = true; // default: inline-level
  whiteList['dominant-baseline'] = false; // default: auto
  whiteList['elevation'] = false; // default: level
  whiteList['empty-cells'] = false; // default: show
  whiteList['filter'] = false; // default: none
  whiteList['flex'] = false; // default: depending on individual properties
  whiteList['flex-basis'] = false; // default: auto
  whiteList['flex-direction'] = false; // default: row
  whiteList['flex-flow'] = false; // default: depending on individual properties
  whiteList['flex-grow'] = false; // default: 0
  whiteList['flex-shrink'] = false; // default: 1
  whiteList['flex-wrap'] = false; // default: nowrap
  whiteList['float'] = false; // default: none
  whiteList['float-offset'] = false; // default: 0 0
  whiteList['flood-color'] = false; // default: black
  whiteList['flood-opacity'] = false; // default: 1
  whiteList['flow-from'] = false; // default: none
  whiteList['flow-into'] = false; // default: none
  whiteList['font'] = true; // default: depending on individual properties
  whiteList['font-family'] = true; // default: implementation dependent
  whiteList['font-feature-settings'] = true; // default: normal
  whiteList['font-kerning'] = true; // default: auto
  whiteList['font-language-override'] = true; // default: normal
  whiteList['font-size'] = true; // default: medium
  whiteList['font-size-adjust'] = true; // default: none
  whiteList['font-stretch'] = true; // default: normal
  whiteList['font-style'] = true; // default: normal
  whiteList['font-synthesis'] = true; // default: weight style
  whiteList['font-variant'] = true; // default: normal
  whiteList['font-variant-alternates'] = true; // default: normal
  whiteList['font-variant-caps'] = true; // default: normal
  whiteList['font-variant-east-asian'] = true; // default: normal
  whiteList['font-variant-ligatures'] = true; // default: normal
  whiteList['font-variant-numeric'] = true; // default: normal
  whiteList['font-variant-position'] = true; // default: normal
  whiteList['font-weight'] = true; // default: normal
  whiteList['grid'] = false; // default: depending on individual properties
  whiteList['grid-area'] = false; // default: depending on individual properties
  whiteList['grid-auto-columns'] = false; // default: auto
  whiteList['grid-auto-flow'] = false; // default: none
  whiteList['grid-auto-rows'] = false; // default: auto
  whiteList['grid-column'] = false; // default: depending on individual properties
  whiteList['grid-column-end'] = false; // default: auto
  whiteList['grid-column-start'] = false; // default: auto
  whiteList['grid-row'] = false; // default: depending on individual properties
  whiteList['grid-row-end'] = false; // default: auto
  whiteList['grid-row-start'] = false; // default: auto
  whiteList['grid-template'] = false; // default: depending on individual properties
  whiteList['grid-template-areas'] = false; // default: none
  whiteList['grid-template-columns'] = false; // default: none
  whiteList['grid-template-rows'] = false; // default: none
  whiteList['hanging-punctuation'] = false; // default: none
  whiteList['height'] = true; // default: auto
  whiteList['hyphens'] = false; // default: manual
  whiteList['icon'] = false; // default: auto
  whiteList['image-orientation'] = false; // default: auto
  whiteList['image-resolution'] = false; // default: normal
  whiteList['ime-mode'] = false; // default: auto
  whiteList['initial-letters'] = false; // default: normal
  whiteList['inline-box-align'] = false; // default: last
  whiteList['justify-content'] = false; // default: auto
  whiteList['justify-items'] = false; // default: auto
  whiteList['justify-self'] = false; // default: auto
  whiteList['left'] = false; // default: auto
  whiteList['letter-spacing'] = true; // default: normal
  whiteList['lighting-color'] = true; // default: white
  whiteList['line-box-contain'] = false; // default: block inline replaced
  whiteList['line-break'] = false; // default: auto
  whiteList['line-grid'] = false; // default: match-parent
  whiteList['line-height'] = false; // default: normal
  whiteList['line-snap'] = false; // default: none
  whiteList['line-stacking'] = false; // default: depending on individual properties
  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
  whiteList['line-stacking-shift'] = false; // default: consider-shifts
  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
  whiteList['list-style'] = true; // default: depending on individual properties
  whiteList['list-style-image'] = true; // default: none
  whiteList['list-style-position'] = true; // default: outside
  whiteList['list-style-type'] = true; // default: disc
  whiteList['margin'] = true; // default: depending on individual properties
  whiteList['margin-bottom'] = true; // default: 0
  whiteList['margin-left'] = true; // default: 0
  whiteList['margin-right'] = true; // default: 0
  whiteList['margin-top'] = true; // default: 0
  whiteList['marker-offset'] = false; // default: auto
  whiteList['marker-side'] = false; // default: list-item
  whiteList['marks'] = false; // default: none
  whiteList['mask'] = false; // default: border-box
  whiteList['mask-box'] = false; // default: see individual properties
  whiteList['mask-box-outset'] = false; // default: 0
  whiteList['mask-box-repeat'] = false; // default: stretch
  whiteList['mask-box-slice'] = false; // default: 0 fill
  whiteList['mask-box-source'] = false; // default: none
  whiteList['mask-box-width'] = false; // default: auto
  whiteList['mask-clip'] = false; // default: border-box
  whiteList['mask-image'] = false; // default: none
  whiteList['mask-origin'] = false; // default: border-box
  whiteList['mask-position'] = false; // default: center
  whiteList['mask-repeat'] = false; // default: no-repeat
  whiteList['mask-size'] = false; // default: border-box
  whiteList['mask-source-type'] = false; // default: auto
  whiteList['mask-type'] = false; // default: luminance
  whiteList['max-height'] = true; // default: none
  whiteList['max-lines'] = false; // default: none
  whiteList['max-width'] = true; // default: none
  whiteList['min-height'] = true; // default: 0
  whiteList['min-width'] = true; // default: 0
  whiteList['move-to'] = false; // default: normal
  whiteList['nav-down'] = false; // default: auto
  whiteList['nav-index'] = false; // default: auto
  whiteList['nav-left'] = false; // default: auto
  whiteList['nav-right'] = false; // default: auto
  whiteList['nav-up'] = false; // default: auto
  whiteList['object-fit'] = false; // default: fill
  whiteList['object-position'] = false; // default: 50% 50%
  whiteList['opacity'] = false; // default: 1
  whiteList['order'] = false; // default: 0
  whiteList['orphans'] = false; // default: 2
  whiteList['outline'] = false; // default: depending on individual properties
  whiteList['outline-color'] = false; // default: invert
  whiteList['outline-offset'] = false; // default: 0
  whiteList['outline-style'] = false; // default: none
  whiteList['outline-width'] = false; // default: medium
  whiteList['overflow'] = false; // default: depending on individual properties
  whiteList['overflow-wrap'] = false; // default: normal
  whiteList['overflow-x'] = false; // default: visible
  whiteList['overflow-y'] = false; // default: visible
  whiteList['padding'] = true; // default: depending on individual properties
  whiteList['padding-bottom'] = true; // default: 0
  whiteList['padding-left'] = true; // default: 0
  whiteList['padding-right'] = true; // default: 0
  whiteList['padding-top'] = true; // default: 0
  whiteList['page'] = false; // default: auto
  whiteList['page-break-after'] = false; // default: auto
  whiteList['page-break-before'] = false; // default: auto
  whiteList['page-break-inside'] = false; // default: auto
  whiteList['page-policy'] = false; // default: start
  whiteList['pause'] = false; // default: implementation dependent
  whiteList['pause-after'] = false; // default: implementation dependent
  whiteList['pause-before'] = false; // default: implementation dependent
  whiteList['perspective'] = false; // default: none
  whiteList['perspective-origin'] = false; // default: 50% 50%
  whiteList['pitch'] = false; // default: medium
  whiteList['pitch-range'] = false; // default: 50
  whiteList['play-during'] = false; // default: auto
  whiteList['position'] = false; // default: static
  whiteList['presentation-level'] = false; // default: 0
  whiteList['quotes'] = false; // default: text
  whiteList['region-fragment'] = false; // default: auto
  whiteList['resize'] = false; // default: none
  whiteList['rest'] = false; // default: depending on individual properties
  whiteList['rest-after'] = false; // default: none
  whiteList['rest-before'] = false; // default: none
  whiteList['richness'] = false; // default: 50
  whiteList['right'] = false; // default: auto
  whiteList['rotation'] = false; // default: 0
  whiteList['rotation-point'] = false; // default: 50% 50%
  whiteList['ruby-align'] = false; // default: auto
  whiteList['ruby-merge'] = false; // default: separate
  whiteList['ruby-position'] = false; // default: before
  whiteList['shape-image-threshold'] = false; // default: 0.0
  whiteList['shape-outside'] = false; // default: none
  whiteList['shape-margin'] = false; // default: 0
  whiteList['size'] = false; // default: auto
  whiteList['speak'] = false; // default: auto
  whiteList['speak-as'] = false; // default: normal
  whiteList['speak-header'] = false; // default: once
  whiteList['speak-numeral'] = false; // default: continuous
  whiteList['speak-punctuation'] = false; // default: none
  whiteList['speech-rate'] = false; // default: medium
  whiteList['stress'] = false; // default: 50
  whiteList['string-set'] = false; // default: none
  whiteList['tab-size'] = false; // default: 8
  whiteList['table-layout'] = false; // default: auto
  whiteList['text-align'] = true; // default: start
  whiteList['text-align-last'] = true; // default: auto
  whiteList['text-combine-upright'] = true; // default: none
  whiteList['text-decoration'] = true; // default: none
  whiteList['text-decoration-color'] = true; // default: currentColor
  whiteList['text-decoration-line'] = true; // default: none
  whiteList['text-decoration-skip'] = true; // default: objects
  whiteList['text-decoration-style'] = true; // default: solid
  whiteList['text-emphasis'] = true; // default: depending on individual properties
  whiteList['text-emphasis-color'] = true; // default: currentColor
  whiteList['text-emphasis-position'] = true; // default: over right
  whiteList['text-emphasis-style'] = true; // default: none
  whiteList['text-height'] = true; // default: auto
  whiteList['text-indent'] = true; // default: 0
  whiteList['text-justify'] = true; // default: auto
  whiteList['text-orientation'] = true; // default: mixed
  whiteList['text-overflow'] = true; // default: clip
  whiteList['text-shadow'] = true; // default: none
  whiteList['text-space-collapse'] = true; // default: collapse
  whiteList['text-transform'] = true; // default: none
  whiteList['text-underline-position'] = true; // default: auto
  whiteList['text-wrap'] = true; // default: normal
  whiteList['top'] = false; // default: auto
  whiteList['transform'] = false; // default: none
  whiteList['transform-origin'] = false; // default: 50% 50% 0
  whiteList['transform-style'] = false; // default: flat
  whiteList['transition'] = false; // default: depending on individual properties
  whiteList['transition-delay'] = false; // default: 0s
  whiteList['transition-duration'] = false; // default: 0s
  whiteList['transition-property'] = false; // default: all
  whiteList['transition-timing-function'] = false; // default: ease
  whiteList['unicode-bidi'] = false; // default: normal
  whiteList['vertical-align'] = false; // default: baseline
  whiteList['visibility'] = false; // default: visible
  whiteList['voice-balance'] = false; // default: center
  whiteList['voice-duration'] = false; // default: auto
  whiteList['voice-family'] = false; // default: implementation dependent
  whiteList['voice-pitch'] = false; // default: medium
  whiteList['voice-range'] = false; // default: medium
  whiteList['voice-rate'] = false; // default: normal
  whiteList['voice-stress'] = false; // default: normal
  whiteList['voice-volume'] = false; // default: medium
  whiteList['volume'] = false; // default: medium
  whiteList['white-space'] = false; // default: normal
  whiteList['widows'] = false; // default: 2
  whiteList['width'] = true; // default: auto
  whiteList['will-change'] = false; // default: auto
  whiteList['word-break'] = true; // default: normal
  whiteList['word-spacing'] = true; // default: normal
  whiteList['word-wrap'] = true; // default: normal
  whiteList['wrap-flow'] = false; // default: auto
  whiteList['wrap-through'] = false; // default: wrap
  whiteList['writing-mode'] = false; // default: horizontal-tb
  whiteList['z-index'] = false; // default: auto

  return whiteList;
}


/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onAttr (name, value, options) {
  // do nothing
}

/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onIgnoreAttr (name, value, options) {
  // do nothing
}

var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;

/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function safeAttrValue(name, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
  return value;
}


exports.whiteList = getDefaultWhiteList();
exports.getDefaultWhiteList = getDefaultWhiteList;
exports.onAttr = onAttr;
exports.onIgnoreAttr = onIgnoreAttr;
exports.safeAttrValue = safeAttrValue;


/***/ }),

/***/ "027T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Qmd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Zbq":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("/cOS");
var FilterCSS = __webpack_require__("huvo");


/**
 * XSS过滤
 *
 * @param {String} css 要过滤的CSS代码
 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
 * @return {String}
 */
function filterCSS (html, options) {
  var xss = new FilterCSS(options);
  return xss.process(html);
}


// 输出
exports = module.exports = filterCSS;
exports.FilterCSS = FilterCSS;
for (var i in DEFAULT) exports[i] = DEFAULT[i];

// 在浏览器端使用
if (typeof window !== 'undefined') {
  window.filterCSS = module.exports;
}


/***/ }),

/***/ "0cES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1fVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3XGG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5CFU":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__("JgyH"),__webpack_require__("Jmof"),__webpack_require__("T9WB"),__webpack_require__("wLXD")):"function"===typeof define&&define.amd?define(["classnames","react","prop-types","react-dom"],t):"object"===typeof exports?exports.Modal=t(require("classnames"),require("react"),require("prop-types"),require("react-dom")):e.Modal=t(e.classNames,e.React,e.PropTypes,e.ReactDOM)}("undefined"!==typeof self?self:this,function(e,t,n,o){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/modal/",t(t.s="lVK7")}({"2KtJ":function(e,t){},"5BCh":function(e,t,n){!function(t,o){e.exports=o(n("Jmof"))}("undefined"!==typeof self&&self,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/ui_toggle/",t(t.s="lVK7")}({Jmof:function(t,n){t.exports=e},lVK7:function(e,t,n){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function i(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return"function"===typeof e}Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"CLASS_NO_MODAL_CLICK",function(){return u});var s=n("Jmof"),l=(n.n(s),"function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}),c=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),u="modal-no-click",p=function(e){function t(e){o(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.CLASS_NO_MODAL_CLICK=u,n.notPropagatingElements=new Set,n.open=function(){var e=function(){n.setState({isOpen:!0},function(){n.bindClickListener(),a(n.togglerDidOpen)&&n.togglerDidOpen()})};if(a(n.togglerWillOpen)){if(n.togglerWillOpen(e),!n.togglerWillOpen.length)return e()}else e()},n.close=function(){var e=function(){n.setState({isOpen:!1},function(){n.removeClickListener(),a(n.togglerDidClose)&&n.togglerDidClose()})};if(a(n.togglerWillClose)){if(n.togglerWillClose(e),!n.togglerWillClose.length)return e()}else e()},n.toggle=function(){return n.state.isOpen?n.close():n.open()},n.bindClickListener=function(){!1!==n.props.bindBodyClickListener&&document.body.addEventListener("click",n.onBodyClick)},n.removeClickListener=function(){return document.body.removeEventListener("click",n.onBodyClick)},n.shouldPreventPropagationByClassName=function(e){return!(!e||!e.classList)&&e.classList.contains(n.CLASS_NO_MODAL_CLICK)},n.shouldPreventPropagationByElement=function(e){if(!e)return!1;if(!e.contains)return!1;if(!n.notPropagatingElements.size)return!1;if(n.notPropagatingElements.has(e))return!0;var t=!0,o=!1,r=void 0;try{for(var i,a=n.notPropagatingElements[Symbol.iterator]();!(t=(i=a.next()).done);t=!0){var s=i.value;if(s.contains&&s.contains(e))return!0}}catch(e){o=!0,r=e}finally{try{!t&&a.return&&a.return()}finally{if(o)throw r}}return!1},n.preventCloseAction=function(e){if(e)return n.notPropagatingElements.has(e)?null:void n.notPropagatingElements.add(e)},n.onBodyClick=n.onBodyClick.bind(n),n.state={isOpen:e.defaultOpen||!1},n}return i(t,e),c(t,[{key:"componentWillMount",value:function(){this.state.isOpen&&this.bindClickListener()}},{key:"componentWillUnmount",value:function(){this.removeClickListener()}},{key:"onBodyClick",value:function(e){var t=e.target;return this.state.isOpen?a(this.shouldPreventCloseAction)&&!0===this.shouldPreventCloseAction(t)?null:this.shouldPreventPropagationByClassName(t)||this.shouldPreventPropagationByElement(t)?null:void this.close():null}},{key:"render",value:function(){var e=this.props.children,t="undefined"===typeof e?"undefined":l(e);if("undefined"!==t&&"function"!==t)throw new TypeError("Toggler: `children` must be a function");var n=this.close,o=this.open,r=this.toggle,i=this.CLASS_NO_MODAL_CLICK,a=this.preventCloseAction,s=this.state.isOpen,c=this.toggleContent?this.toggleContent:e;return c?c({isOpen:s,close:n,open:o,toggle:r,CLASS_NO_MODAL_CLICK:i,preventCloseAction:a}):null}}]),t}(s.Component);p.defaultProps={defaultOpen:!1},t.default=p}})})},JgyH:function(t,n){t.exports=e},Jmof:function(e,n){e.exports=t},Qwgx:function(e,t){},T9WB:function(e,t){e.exports=n},f2ea:function(e,t){},ixLB:function(e,t){},lVK7:function(e,t,n){"use strict";function o(e){return"function"===typeof e}function r(e,t){return void 0===e||null===e?null:o(e)?e(t):e}function i(e,t){var n={};for(var o in e)t.indexOf(o)>=0||Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function l(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function c(e){var t=e.children,n=e.hasCloseBtn,o=e.close;return y.a.createElement("header",{className:"MODAL__modal-content-header"},y.a.createElement("h2",{className:"MODAL__modal-content-header-body"},t),n&&y.a.createElement(A,{onClick:o}))}function u(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function p(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function f(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var d=n("Jmof"),y=n.n(d),h=n("wLXD"),v=n.n(h),g=n("T9WB"),m=n.n(g),b=n("JgyH"),O=n.n(b),_=n("5BCh"),C=n.n(_),w=(n("zr3G"),function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}()),E=function e(t,n,o){null===t&&(t=Function.prototype);var r=Object.getOwnPropertyDescriptor(t,n);if(void 0===r){var i=Object.getPrototypeOf(t);return null===i?void 0:e(i,n,o)}if("value"in r)return r.value;var a=r.get;if(void 0!==a)return a.call(o)},k=function(e){function t(e){a(this,t);var n=s(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.__view=n.__view.bind(n),n.draw=n.draw.bind(n),n.onEscape=n.onEscape.bind(n),n}return l(t,e),w(t,[{key:"componentDidUpdate",value:function(){this.draw()}},{key:"componentWillUnmount",value:function(){E(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"componentWillUnmount",this).call(this),this.close()}},{key:"onEscape",value:function(e){27!==e.keyCode&&27!==e.which&&"Escape"!==e.code&&"Escape"!==e.key||this.close()}},{key:"togglerWillOpen",value:function(){this.target||(this.target=document.createElement("div"),this.target.className=this.targetClassName,document.body.appendChild(this.target),this.props.closeOnEscape&&window.addEventListener("keyup",this.onEscape),this.draw())}},{key:"togglerDidOpen",value:function(){var e=this;setTimeout(function(){return e.target.classList.add("shown")},0),o(this.props.onOpen)&&this.props.onOpen()}},{key:"togglerWillClose",value:function(e){var t=this;this.target&&(this.target.classList.remove("shown"),this.target.addEventListener("transitionend",function(){v.a.unmountComponentAtNode(t.target),document.body.removeChild(t.target),t.target=void 0,e()},{once:!0}),window.removeEventListener("keyup",this.onEscape))}},{key:"togglerDidClose",value:function(){o(this.props.onClose)&&this.props.onClose()}},{key:"__view",value:function(e){return this.props.children(e)}},{key:"draw",value:function(){this.target&&v.a.unstable_renderSubtreeIntoContainer(this,this.__view(this.modalProps),this.target)}},{key:"render",value:function(){return r(this.props.trigger,this.modalProps)}},{key:"targetClassName",get:function(){return O()("MODAL__modal",this.props.name)}},{key:"modalProps",get:function(){var e=this.open,t=this.close,n=this.toggle,o=this.preventCloseAction,r=this.state.isOpen,a=this.props,s=(a.trigger,a.children,i(a,["trigger","children"]));return Object.assign({},{open:e,close:t,toggle:n,preventCloseAction:o,isOpen:r},s)}}]),t}(C.a);k.propTypes={onOpen:m.a.func,onClose:m.a.func,closeOnEscape:m.a.bool,bindBodyClickListener:m.a.bool,trigger:m.a.func},k.defaultProps={closeOnEscape:!0,bindBodyClickListener:!0};var P=k,L=(n("m+lv"),function(e){var t=e.children,n=e.preventCloseAction;return e.isOpen?y.a.createElement("div",{className:"MODAL__modal-content",ref:n},t):null});L.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired};var j=L,x=(n("2KtJ"),function(e){var t=e.onClick;return y.a.createElement("button",{className:"MODAL__modal-content-close",onClick:t},y.a.createElement("span",null,"\xd7"))});x.propTypes={onClick:m.a.func.isRequired};var A=x;n("Qwgx");c.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired},c.defaultProps={hasCloseBtn:!0};var B=c,D=(n("f2ea"),function(e){var t=e.children;return y.a.createElement("section",{className:"MODAL__modal-content-body"},t)});D.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired};var S=D,T=(n("zvIh"),function(e){var t=e.children;return y.a.createElement("footer",{className:"MODAL__modal-content-footer"},t)});T.propTypes={children:m.a.oneOfType([m.a.arrayOf(m.a.node),m.a.node]).isRequired};var M=T,N=(n("ixLB"),function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}()),W=function(e){function t(){return u(this,t),p(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return f(t,e),N(t,[{key:"__view",value:function(e){var t=this.props,n=t.header,o=t.footer,i=t.children,a=t.hasCloseBtn;return y.a.createElement(j,e,n&&y.a.createElement(B,{hasCloseBtn:a,close:e.close},r(n,e)),i&&y.a.createElement(S,null,r(i,e)),o&&y.a.createElement(M,null,r(o,e)))}}]),t}(P);W.propTypes={header:m.a.any,footer:m.a.any,children:m.a.any,hasCloseBtn:m.a.bool};var q=W;n.d(t,"Base",function(){return q});t.default=P},"m+lv":function(e,t){},wLXD:function(e,t){e.exports=o},zr3G:function(e,t){},zvIh:function(e,t){}})});
//# sourceMappingURL=index.d131d2f715612f7c3082.js.map

/***/ }),

/***/ "Bdlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cgq4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FVwl":
/***/ (function(module, exports, __webpack_require__) {

/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = __webpack_require__("0Zbq").FilterCSS;
var DEFAULT = __webpack_require__("oz9r");
var parser = __webpack_require__("krhF");
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = __webpack_require__("noAI");

/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull(obj) {
  return obj === undefined || obj === null;
}

/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */
function getAttrs(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/"
    };
  }
  html = _.trim(html.slice(i + 1, -1));
  var isClosing = html[html.length - 1] === "/";
  if (isClosing) html = _.trim(html.slice(0, -1));
  return {
    html: html,
    closing: isClosing
  };
}

/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList, onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */
function FilterXSS(options) {
  options = shallowCopyObject(options || {});

  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
  }

  options.whiteList = options.whiteList || DEFAULT.whiteList;
  options.onTag = options.onTag || DEFAULT.onTag;
  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
  this.options = options;

  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS(options.css);
  }
}

/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */
FilterXSS.prototype.process = function(html) {
  // compatible with the input
  html = html || "";
  html = html.toString();
  if (!html) return "";

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag = options.onTag;
  var onIgnoreTag = options.onIgnoreTag;
  var onTagAttr = options.onTagAttr;
  var onIgnoreTagAttr = options.onIgnoreTagAttr;
  var safeAttrValue = options.safeAttrValue;
  var escapeHtml = options.escapeHtml;
  var cssFilter = me.cssFilter;

  // remove invisible characters
  if (options.stripBlankChar) {
    html = DEFAULT.stripBlankChar(html);
  }

  // remove html comments
  if (!options.allowCommentTag) {
    html = DEFAULT.stripCommentTag(html);
  }

  // if enable stripIgnoreTagBody
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    var stripIgnoreTagBody = DEFAULT.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag
    );
    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
  }

  var retHtml = parseTag(
    html,
    function(sourcePosition, position, tag, html, isClosing) {
      var info = {
        sourcePosition: sourcePosition,
        position: position,
        isClosing: isClosing,
        isWhite: whiteList.hasOwnProperty(tag)
      };

      // call `onTag()`
      var ret = onTag(tag, html, info);
      if (!isNull(ret)) return ret;

      if (info.isWhite) {
        if (info.isClosing) {
          return "</" + tag + ">";
        }

        var attrs = getAttrs(html);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr(attrs.html, function(name, value) {
          // call `onTagAttr()`
          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
          var ret = onTagAttr(tag, name, value, isWhiteAttr);
          if (!isNull(ret)) return ret;

          if (isWhiteAttr) {
            // call `safeAttrValue()`
            value = safeAttrValue(tag, name, value, cssFilter);
            if (value) {
              return name + '="' + value + '"';
            } else {
              return name;
            }
          } else {
            // call `onIgnoreTagAttr()`
            var ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
            if (!isNull(ret)) return ret;
            return;
          }
        });

        // build new tag html
        var html = "<" + tag;
        if (attrsHtml) html += " " + attrsHtml;
        if (attrs.closing) html += " /";
        html += ">";
        return html;
      } else {
        // call `onIgnoreTag()`
        var ret = onIgnoreTag(tag, html, info);
        if (!isNull(ret)) return ret;
        return escapeHtml(html);
      }
    },
    escapeHtml
  );

  // if enable stripIgnoreTagBody
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }

  return retHtml;
};

module.exports = FilterXSS;


/***/ }),

/***/ "I3Iz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I9N9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JgyH":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_JgyH__;

/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "NG4M":
/***/ (function(module, exports, __webpack_require__) {

/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("oz9r");
var parser = __webpack_require__("krhF");
var FilterXSS = __webpack_require__("FVwl");

/**
 * filter xss function
 *
 * @param {String} html
 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
 * @return {String}
 */
function filterXSS(html, options) {
  var xss = new FilterXSS(options);
  return xss.process(html);
}

exports = module.exports = filterXSS;
exports.FilterXSS = FilterXSS;
for (var i in DEFAULT) exports[i] = DEFAULT[i];
for (var i in parser) exports[i] = parser[i];

// using `xss` on the browser, output `filterXSS` to the globals
if (typeof window !== "undefined") {
  window.filterXSS = module.exports;
}

// using `xss` on the WebWorker, output `filterXSS` to the globals
function isWorkerEnv() {
  return typeof self !== 'undefined' && typeof DedicatedWorkerGlobalScope !== 'undefined' && self instanceof DedicatedWorkerGlobalScope;
}
if (isWorkerEnv()) {
  self.filterXSS = module.exports;
}


/***/ }),

/***/ "PbPb":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_PbPb__;

/***/ }),

/***/ "R5aA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIUQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T9WB":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_T9WB__;

/***/ }),

/***/ "TIrB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uo+f":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var _ = __webpack_require__("jCb9");


/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */
function parseStyle (css, onAttr) {
  css = _.trimRight(css);
  if (css[css.length - 1] !== ';') css += ';';
  var cssLength = css.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i = 0;
  var retCSS = '';

  function addNewAttr () {
    // 如果没有正常的闭合圆括号，则直接忽略当前属性
    if (!isParenthesisOpen) {
      var source = _.trim(css.slice(lastPos, i));
      var j = source.indexOf(':');
      if (j !== -1) {
        var name = _.trim(source.slice(0, j));
        var value = _.trim(source.slice(j + 1));
        // 必须有属性名称
        if (name) {
          var ret = onAttr(lastPos, retCSS.length, name, value, source);
          if (ret) retCSS += ret + '; ';
        }
      }
    }
    lastPos = i + 1;
  }

  for (; i < cssLength; i++) {
    var c = css[i];
    if (c === '/' && css[i + 1] === '*') {
      // 备注开始
      var j = css.indexOf('*/', i + 2);
      // 如果没有正常的备注结束，则后面的部分全部跳过
      if (j === -1) break;
      // 直接将当前位置调到备注结尾，并且初始化状态
      i = j + 1;
      lastPos = i + 1;
      isParenthesisOpen = false;
    } else if (c === '(') {
      isParenthesisOpen = true;
    } else if (c === ')') {
      isParenthesisOpen = false;
    } else if (c === ';') {
      if (isParenthesisOpen) {
        // 在圆括号里面，忽略
      } else {
        addNewAttr();
      }
    } else if (c === '\n') {
      addNewAttr();
    }
  }

  return _.trim(retCSS);
}

module.exports = parseStyle;


/***/ }),

/***/ "V7wu":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__("JgyH"),__webpack_require__("Jmof"),__webpack_require__("PbPb"),__webpack_require__("T9WB"),__webpack_require__("h4G9"),__webpack_require__("jPm4"),__webpack_require__("wLXD")):"function"===typeof define&&define.amd?define(["classnames","react","lodash","prop-types","@fiverr/i18n/singleton","@fiverr/gofor","react-dom"],t):"object"===typeof exports?exports.ProfileImage=t(require("classnames"),require("react"),require("lodash"),require("prop-types"),require("@fiverr/i18n/singleton"),require("@fiverr/gofor"),require("react-dom")):e.ProfileImage=t(e.classNames,e.React,e._,e.PropTypes,e.i18n,e.goforFactory,e.ReactDOM)}("undefined"!==typeof self?self:this,function(e,t,n,r,o,i,a){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/profile_image/",t(t.s="lVK7")}({"2pqD":function(e,t){},JgyH:function(t,n){t.exports=e},Jmof:function(e,n){e.exports=t},PbPb:function(e,t){e.exports=n},T9WB:function(e,t){e.exports=r},Tiji:function(e,t){},UwmQ:function(e,t){},ZMEE:function(e,t,n){!function(t,r){e.exports=r(n("PbPb"),n("h4G9"),n("jPm4"))}("undefined"!==typeof self&&self,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/filerr_uploader/",t(t.s="lVK7")}({PbPb:function(t,n){t.exports=e},h4G9:function(e,n){e.exports=t},jPm4:function(e,t){e.exports=n},lVK7:function(e,t,n){"use strict";function r(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new Date,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.prefix,r=void 0===n?ne:n,o=Date.now(),i=o-e;return Number.isNaN(i)?"":i<J&&re(r,"just_now")||i<$&&re(r,"minutes_ago",i/J)||i<K&&re(r,"hours_ago",i/$)||i<Y&&re(r,"days_ago",i/K)||i<Q&&re(r,"weeks_ago",i/Y)||i<Z&&re(r,"months_ago",i/Q)||re(r,"years_ago",i/Z)}function o(e){function t(e,t){return n[e]=n.hasOwnProperty(e)?n[e]:t()}for(var n={},r=arguments.length,o=Array(r>1?r-1:0),a=1;a<r;a++)o[a-1]=arguments[a];o.forEach(function(n){return i.call(e,n,t)})}function i(e,t){var n=this,r=Object.getOwnPropertyDescriptor(this.constructor.prototype,e),o=le.reduce(function(o,i){switch(ue(r[i])){case"undefined":break;case"function":ce.includes(i)?o[i]=function(){return t(e+"$"+i,r[i].bind(n))}:o[i]=r[i];break;default:o[i]=r[i]}return o},{});Object.defineProperty(this,e,o)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e){var t=e.getBoundingClientRect(),n=t.width,r=t.height;if(0!==n||0!==r)return null;for(;e;){if(e===document.body)return null;if("none"===window.getComputedStyle(e).display)return e;e=e.parentElement}return e}function u(e){if(e instanceof Window||e instanceof HTMLDocument)return{left:0,top:0,right:window.innerWidth,bottom:window.innerHeight,width:window.innerWidth,height:window.innerHeight};var t=e.getBoundingClientRect();return{left:t.left,top:t.top,right:t.right,bottom:t.bottom,width:t.width,height:t.height}}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.container,r=void 0===n?window:n,o=t.percent,i=void 0===o?50:o,a=u(e),s=u(r),l=i/100,c=function(e){var t=me(e,3),n=t[0],r=t[1];return(0,t[2])(a[n],s[n])+a[r]>=a[r]*l};return!["width","height"].some(function(e){return 0===a[e]})&&[["top","height",ve],["left","width",ve],["right","width",be],["bottom","height",be]].every(c)}function c(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function f(e){try{return JSON.parse(JSON.stringify(e))}catch(e){throw new SyntaxError("Data was expected to be valid for JSON. Got error: "+e)}}function h(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function p(){var e=Te.get(xe);e&&(Oe.apply(void 0,h(e)),Te.set(xe,[]))}function d(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function y(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function m(){var e=new Headers;e.append("X-Requested-With","XMLHttpRequest"),e.append("Content-Type","application/json; charset=utf-8"),e.append("Accept","application/json");try{e.append("X-CSRF-Token",document.AUTH_TOKEN)}catch(e){}return e}function v(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return!1},n={};for(var r in e)t(r,e[r])&&(n[r]=e[r]);return n}function b(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=(""+Math.random()).slice(-8)+(""+Date.now()).slice(8);return(e?e+"_":"")+t}function g(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function w(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function P(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function _(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function k(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function O(e){var t=e.split("="),n=Xe(t,2),r=n[0],o=n[1];return""===r?{}:k({},r,ze(o))}function j(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function S(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function E(e,t){return function(n){var r=n.match(e);return r&&r[t]||""}}function T(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function A(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function N(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function x(e,t,n){return!(arguments.length>3&&void 0!==arguments[3]&&arguments[3])&&e.store.hasOwnProperty(t)||(e[et]=Object.freeze(Object.assign({},e.store,N({},t,n())))),e}function I(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return e[et]=Object.freeze(Object.assign.apply(Object,A([{href:[e.path,e.hasQueryParams()?"?"+Je(e.queryParams):"",e.hasHashParams()?"#"+Je(e.hashParams):""].join("")}].concat(n.map(function(t){return N({},t,e.store[t])}))))),e}function q(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function L(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function C(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function D(e){return new Promise(function(t){t(e.type)})}function U(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)})}function R(e){return!e||e.split(".").length<2?"":e.split(".").pop()}function F(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function M(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function H(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function G(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function B(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function z(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function X(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function V(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function W(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var J=("function"===typeof Symbol&&Symbol.iterator,6e4),$=36e5,K=864e5,Y=6048e5,Q=2592e6,Z=31536e6,ee=n("h4G9"),te=n.n(ee),ne="general.how_long_ago.",re=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;return te.a.t(""+e+t,{count:Math.floor(n)})};Object.assign(r,{MINUTE_IN_MS:J,HOUR_IN_MS:$,DAY_IN_MS:K,WEEK_IN_MS:Y,MONTH_IN_MS:Q,YEAR_IN_MS:Z});var oe=("function"===typeof Symbol&&Symbol.iterator,"function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}),ie="object"===("undefined"===typeof window?"undefined":oe(window))&&window.window===window&&window||"object"===("undefined"===typeof GLOBAL?"undefined":oe(GLOBAL))&&GLOBAL.GLOBAL===GLOBAL&&GLOBAL||"object"===("undefined"===typeof self?"undefined":oe(self))&&self.self===self&&self,ae="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},se=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ie;return e.split(".").reduce(function(e,t){return"object"===("undefined"===typeof e?"undefined":ae(e))?e[t]:e},t)},ue="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},le=["get","value","set","configurable","enumerable","writable"],ce=["get","value"],fe="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},he=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),pe=function(){function e(){a(this,e),o(this,"node","browser","development","production","testing","jest","plike","toString")}return he(e,[{key:"toString",value:function(){return(se(this.browser?"app.environment":"process.env.NODE_ENV")||"").toLowerCase()}},{key:"node",get:function(){return"[object process]"===Object.prototype.toString.call("undefined"!==typeof ie.process?ie.process:0)}},{key:"browser",get:function(){return this.jest||!this.node&&["undefined"===typeof document?"undefined":fe(document),"undefined"===typeof window?"undefined":fe(window)].every(function(e){return"undefined"!==e})}},{key:"development",get:function(){return this.toString().includes("dev")}},{key:"dev",get:function(){return this.development}},{key:"production",get:function(){return this.toString().includes("prod")}},{key:"prod",get:function(){return this.production}},{key:"testing",get:function(){return this.toString().includes("test")}},{key:"test",get:function(){return this.testing}},{key:"jest",get:function(){return(se("process.env.npm_lifecycle_script")||"").toString().includes("jest")}},{key:"plike",get:function(){return this.toString().includes("like")}}]),e}(),de=new pe,ye=function(e){return new Promise(function(t,n){de.browser||n("emerge can not be triggered from a non browser environment");var r=s(e);if(null===r)return void t(e);if("undefined"===typeof MutationObserver)return void t(e);var o=new MutationObserver(function(){null===s(e)&&(t(e),o.disconnect())});o.observe(r,{attributes:!0})})},me=function(){function e(e,t){var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=e[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!t||n.length!==t);r=!0);}catch(e){o=!0,i=e}finally{try{!r&&s.return&&s.return()}finally{if(o)throw i}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),ve=function(e,t){return e-t},be=function(e,t){return t-e},ge=n("PbPb"),we=n.n(ge),Pe="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},_e=function(e){return"object"===("undefined"===typeof Fiverr?"undefined":Pe(Fiverr))&&"function"===typeof Fiverr[e]||void 0},ke=function(e){return function(){var t;return _e(e)&&(t=Fiverr)[e].apply(t,arguments)}},Oe=ke("sendClientEvents"),je=ke("_logEventToGraphite"),Se=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),Ee=function(){function e(t){var n=this;c(this,e),o(this,"available"),this.storage=de.browser&&window[t],["get","set"].forEach(function(e){return n[e]=n[e].bind(n)})}return Se(e,[{key:"get",value:function(e){if(this.available){var t=this.storage.getItem(e);try{return JSON.parse(t)}catch(e){return t}}}},{key:"set",value:function(e,t){var n=this;return this.available?new Promise(function(r,o){try{n.storage.setItem(e,JSON.stringify(t)),r()}catch(e){o(e)}}):new Promise(function(e){return e})}},{key:"remove",value:function(e){this.available&&this.storage.removeItem(e)}},{key:"size",value:function(){for(var e=this,t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];var o=!n.length,i=0;o&&(n=Array.from(Array(this.storage.length)).map(function(t,n){return e.storage.key(n)}));var a=n.reduce(function(t,n){var r=(n+e.storage.getItem(n)).length;return t[n]=r,o&&(i+=r),t},{});return o&&Object.assign(a,{total:i}),a}},{key:"available",get:function(){if(!de.browser)return!1;var e=Math.random().toString(36).substring(2);try{return this.storage.setItem(e,!0),this.storage.removeItem(e),!0}catch(e){return!1}}}]),e}(),Te=new Ee("localStorage"),Ae=(new Ee("sessionStorage"),200),Ne={capture:!1,once:!1,passive:!1},xe="impressionable_events",Ie=["load","resize","scroll","touchmove"];try{p.throttled=we.a.throttle(p,500,{leading:!1}),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",p,{once:!0}):p(),window.addEventListener("beforeunload",p,{once:!0})}catch(e){}var qe="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},Le=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),Ce={data:[],container:"undefined"!==typeof window?window:null,DOMAttribute:"id",dataIdentifier:"id"},De=(function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(y(this,e),!de.browser)throw new Error("Impressionable can not be instantiated from a non browser environment");this.options=Object.assign({},Ce,t),this.options.DOMSelector=this.options.DOMSelector||"["+this.options.DOMAttribute+"]";var n=this.options,r=n.data,o=n.container,i=n.DOMSelector,a=n.dataProperty,s=n.dataIdentifier;if(!Array.isArray(r))throw new TypeError('Impressionable must receive a "data" array argument. Got '+("undefined"===typeof r?"undefined":qe(r)));var u=o===window?document.body:o;if(!u)throw new Error("Impressionable container (when passed) expects a DOM element. Got a "+("undefined"===typeof o?"undefined":qe(o)));var l=u.querySelectorAll(i);Object.assign(this,{container:o,impressed:[],unimpressed:[].slice.call(l)}),this.data=this.options.data.reduce(function(e,t,n){return t.hasOwnProperty(s)&&(e[t[s]]=Object.assign({$index:n},f(a?we.a.get(t,a):t))),e},{}),this.collect=we.a.throttle(this.collect.bind(this),Ae,{leading:!1}),this.live()}Le(e,[{key:"collect",value:function(){for(var e=this.container,t=e===window||l(e,{percent:100}),n=[],r=this.unimpressed.length;r--;){var o=this.unimpressed[r];if(l(o,{container:e})&&(t||l(o))){var i=this.getImpressionData(o);i?(n.push(i),o.setAttribute("data-impression-collected","true")):o.setAttribute("data-impression-collected","error"),this.impress(r)}}return n.length&&(this.storeImpressions.apply(this,n),p.throttled()),this}},{key:"impress",value:function(e){var t;(t=this.impressed).push.apply(t,d(this.unimpressed.splice(e,1))),this.unimpressed.length||this.retire()}},{key:"getImpressionData",value:function(e){var t=e.getAttribute(this.options.DOMAttribute),n=this.data[t];if("function"===typeof this.options.enrich){var r=this.options.enrich(n,e);"object"!==("undefined"===typeof r?"undefined":qe(r))&&!1!==r||(n=r)}return n}},{key:"storeImpressions",value:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];if(!Te.available)return void Oe.apply(void 0,t);this.stored=t}},{key:"live",value:function(){var e=this;this.containerEvents.forEach(function(t){return e.container.addEventListener(t,e.collect,Ne)}),Ie.forEach(function(t){return window.addEventListener(t,e.collect,Ne)}),ye(this.container).then(this.collect).catch(function(e){throw e})}},{key:"die",value:function(){var e=this;this.containerEvents.forEach(function(t){return e.container.removeEventListener(t,e.collect,Ne)}),Ie.forEach(function(t){return window.removeEventListener(t,e.collect,Ne)})}},{key:"retire",value:function(){this.retired||Object.assign(this,{impressed:[],unimpressed:[],data:{},options:{},retired:!0}).die()}},{key:"stored",get:function(){return Te.get(xe)||[]},set:function(e){var t=this.stored;t.push.apply(t,d(e)),Te.set(xe,t).catch(function(){Oe.apply(void 0,d(t)),Te.remove(xe),je({label:"fe_events.error.impressionable.localstorage",timing:Te.size(xe)[xe],percentage:100})})}},{key:"containerEvents",get:function(){var e=["collect-impressions"];return this.container!==window&&e.push("scroll","touchmove"),e}}],[{key:"CUSTOM_EVENT",get:function(){return"collect-impressions"}}])}(),n("jPm4")),Ue=n.n(De),Re=function(){return{credentials:"same-origin",headers:m()}},Fe=Ue()(Re),Me=("function"===typeof Symbol&&Symbol.iterator,{uid:b}),He=/[|\\{}()[\]^$+*?.]/g,Ge=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return e.replace(He,t)},Be=(function(e){function t(){var e;g(this,t);for(var n=arguments.length,r=Array(n),o=0;o<n;o++)r[o]=arguments[o];return"string"===typeof r[0]&&(r[0]=Ge(r[0])),w(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r)))}P(t,e)}(RegExp),ke("_logErrorToServer"),"function"===typeof Symbol&&Symbol.iterator,Object.seal(["string","number"]),function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}()),ze=(function(){function e(){if(_(this,e),!de.browser)throw new Error("[fUtile][Tab][Constructor] Module should only be used in the browser");this.uid=Me.uid("TAB"),this.setActiveTab=this.setActiveTab.bind(this),this.whenActive=new Set,this.focusHandlers=new Map,this.setActiveTab(),this.onFocus(this.setActiveTab)}Be(e,[{key:"setActiveTab",value:function(){this.isActive||(Te.set("VdOMGFYWmxYM1JoWWc",this.uid),this.whenActive.forEach(function(e){return e()}))}},{key:"onSetActive",value:function(e){"function"===typeof e&&this.whenActive.add(e)}},{key:"focusSubscribe",value:function(e){if("function"!==typeof e)return null;var t=Me.uid();return this.onFocus(e),this.focusHandlers.set(t,e),t}},{key:"focusUnsubscribe",value:function(e){window.removeEventListener("focus",this.focusHandlers.get(e))}},{key:"onFocus",value:function(e){window.addEventListener("focus",e)}},{key:"activeTab",get:function(){return Te.get("VdOMGFYWmxYM1JoWWc")}},{key:"isActive",get:function(){return this.activeTab===this.uid}}])}(),function(e){return void 0===e||decodeURIComponent(e)}),Xe=function(){function e(e,t){var n=[],r=!0,o=!1,i=void 0;try{for(var a,s=e[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!t||n.length!==t);r=!0);}catch(e){o=!0,i=e}finally{try{!r&&s.return&&s.return()}finally{if(o)throw i}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),Ve=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";return Object.assign.apply(Object,j(e.split("&").map(O)))},We=("function"===typeof Symbol&&Symbol.iterator,"function"===typeof Symbol&&Symbol.iterator,function(e){return!0===e?"":"="+encodeURIComponent(e)}),Je=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return Object.keys(e).map(function(t){return t+We(e[t])}).join("&")},$e=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),Ke={},Ye=function(){function e(){S(this,e)}return $e(e,[{key:"hash",get:function(){return Ke.hash=Ke.hash||E(/^.*[\#\!|\#](.*)/,1)}},{key:"query",get:function(){return Ke.query=Ke.query||E(/^.*\?(.*(?=#)|(.*(?=$)))/,1)}},{key:"host",get:function(){return Ke.host=Ke.host||E(/^(.*:[\/]{2}|[\/]{2})?([\w|-|\.]*).*$/,2)}},{key:"top",get:function(){return Ke.top=Ke.top||E(/localhost$|[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/,0)}},{key:"protocol",get:function(){return Ke.protocol=Ke.protocol||E(/^(.*:)[\/]{2}|[\/]{2}?.*$/,1)}},{key:"path",get:function(){return Ke.path=Ke.path||function(e){return e.replace(/[\?|#].*$/,"")}}},{key:"pathname",get:function(){return Ke.pathname=Ke.pathname||function(e,t){return t?e.replace(new RegExp(".*"+t),""):e}}}]),e}(),Qe=new Ye,Ze=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),et="function"===typeof Symbol?Symbol():"_store",tt={"#!":"hashParams","#":"hashParams","?":"queryParams"},nt=(function(){function e(t){T(this,e),this[et]=Object.freeze({href:t})}Ze(e,[{key:"toString",value:function(){return this.href}},{key:"hasQueryParams",value:function(){return Object.keys(this.queryParams).length>0}},{key:"hasHashParams",value:function(){return Object.keys(this.hashParams).length>0}},{key:"addParams",value:function(e,t){return this.params,this[tt[t]||"params"]=e,this}},{key:"hasParams",value:function(){return Object.keys(this.params).length>0}},{key:"removeParams",value:function(){for(var e=this,t=arguments.length,n=Array(t),r=0;r<t;r++)n[r]=arguments[r];return this.params,n.length?this[et]=Object.freeze(Object.assign.apply(Object,A([{},this.store].concat(["hashParams","queryParams"].map(function(t){return N({},t,v(e[t],function(e){return!~n.indexOf(e)}))}))))):this[et]=Object.freeze(Object.assign.apply(Object,[{},this.store,{hashParams:{},queryParams:{}}])),I(this,"queryParams","hashParams")}},{key:"store",get:function(){return this[et]}},{key:"href",get:function(){return this.store.href}},{key:"path",get:function(){var e=this;return x(this,"path",function(){return Qe.path(e.href)}).store.path}},{key:"pathname",get:function(){var e=this;return this.path,this.host,x(this,"pathname",function(){return Qe.pathname(e.path,e.host)}).store.pathname}},{key:"host",get:function(){var e=this;return this.path,x(this,"host",function(){return Qe.host(e.path)}).store.host}},{key:"top",get:function(){var e=this;return this.host,x(this,"top",function(){return Qe.top(e.host)}).store.top}},{key:"protocol",get:function(){var e=this;return this.path,x(this,"protocol",function(){return Qe.protocol(e.path)}).store.protocol}},{key:"query",get:function(){var e=this;return x(this,"query",function(){return Qe.query(e.href)}).store.query}},{key:"queryParams",get:function(){var e=this;return this.query,x(this,"queryParams",function(){return Object.freeze(Ve(e.query))}).store.queryParams},set:function(e){var t=this;this.queryParams,I(x(this,"queryParams",function(){return Object.assign({},t.queryParams,e)},!0),"queryParams")}},{key:"hash",get:function(){var e=this;return x(this,"hash",function(){return Qe.hash(e.href)}).store.hash}},{key:"hashParams",get:function(){var e=this;return this.hash,x(this,"hashParams",function(){return Object.freeze(Ve(e.hash))}).store.hashParams},set:function(e){var t=this;this.hashParams,I(x(this,"hashParams",function(){return Object.assign({},t.hashParams,e)},!0),"hashParams")}},{key:"params",get:function(){return this.queryParams,this.hashParams,Object.assign({},this.queryParams,this.hashParams)},set:function(e){this.params,this[(!this.hasQueryParams()&&this.hasHashParams()?"hash":"query")+"Params"]=e}}])}(),{GET_POLICY:"GetPolicy",UPLOAD_FILE:"UploadFile",CREATE_PENDING_ATTACHMENT:"CreatePendingAttachment"}),rt=function(e){function t(e,n,r){q(this,t);var o=L(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,n));return o.type=r,o.status=e,o}return C(t,e),t}(function(e){function t(){var t=Reflect.construct(e,Array.from(arguments));return Object.setPrototypeOf(t,Object.getPrototypeOf(this)),t}return t.prototype=Object.create(e.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e,t}(Error)),ot=rt,it=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),at=/[&$+,\/:;=?@<>[\]{}|\\^~%#]/g,st=function(){function e(t,n){var r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];F(this,e),this.filename=t,this.key=n,this.shouldBeRenamed=r}return it(e,[{key:"generateGuidFilename",value:function(){return U()+"."+R(this.filename)}},{key:"replaceInvalidCharacters",value:function(){return this.filename.replace(at,"_")}},{key:"handle",value:function(){var e=this.shouldBeRenamed?this.generateGuidFilename():this.replaceInvalidCharacters();return e!==this.filename?""+this.key.slice(0,this.key.lastIndexOf("/")+1)+e:this.key}}]),e}(),ut=st,lt=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),ct=function(){function e(t,n,r,o,i,a,s,u){M(this,e),this.objectName=t,this.attachmentName=n,this.policyData=r,this.fileType=o,this.retryAttempts=i,this.file=a,this.onProgress=s,this.shouldRenamed=u}return lt(e,[{key:"abort",value:function(){this.uploadXhrRequest&&this.uploadXhrRequest.abort()}},{key:"prepareDataForUpload",value:function(){var e=this.policyData.policy.s3_policy,t=this.fileType,n=Math.floor(26*Math.random())+Date.now(),r=e.guid+e.client_uniq_id_prefix+n,o=e.key.replace(e.guid,r),i=new FormData,a=new ut(this.file.name,o,this.shouldRenamed);return i.append("acl",e.acl),i.append("AWSAccessKeyId",e.AWSAccessKeyId),i.append("success_action_status",e.success_action_status),i.append("key",a.handle()),i.append("policy",e.policy),i.append("signature",e.signature),i.append("content-type",t),i.append("file",this.file),{formData:i,s3Policy:e}}},{key:"uploadToS3",value:function(e){var t=this;return new Promise(function(n,r){!function o(i){t.uploadXhrRequest=new XMLHttpRequest,t.uploadXhrRequest.upload.onprogress=function(e){var n=100*e.loaded/e.total;t.onProgress({progressEvent:e,percentage:n})},t.uploadXhrRequest.onload=function(){t.uploadXhrRequest.status>=200&&t.uploadXhrRequest.status<300?n(t.uploadXhrRequest.response):(i&&o(i-1),!i&&r(new ot(t.uploadXhrRequest.status,t.uploadXhrRequest.statusText,nt.UPLOAD_FILE)))},t.uploadXhrRequest.onerror=function(){i&&o(i-1),!i&&r(new ot(t.uploadXhrRequest.status,t.uploadXhrRequest.statusText,nt.UPLOAD_FILE))},t.uploadXhrRequest.open("POST",e.s3Policy.action_url),t.uploadXhrRequest.send(e.formData)}(t.retryAttempts)})}},{key:"logUploadTime",value:function(e){je({label:this.objectName+".filerr."+this.attachmentName+".s3_direct_upload",timing:Date.now()-e})}},{key:"parseS3UploadedData",value:function(e){var t=document.createRange().createContextualFragment(e);return{key:t.querySelector("Key").firstChild.nodeValue,bucketName:t.querySelector("Bucket").firstChild.nodeValue}}},{key:"handleUploadLogic",value:function(){var e=this,t=this.prepareDataForUpload(),n=Date.now();return this.uploadToS3(t).then(function(t){return e.logUploadTime(n),e.parseS3UploadedData(t)})}}]),e}(),ft=ct,ht=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),pt=function(){function e(t,n,r,o,i){H(this,e),this.objectName=t,this.attachmentName=n,this.createPendingAttachmentIdUrl=r,this.s3ParsedData=o,this.file=i}return ht(e,[{key:"createPendingAttachment",value:function(){return Fe(this.createPendingAttachmentIdUrl,{method:"POST",body:JSON.stringify({file_path:this.s3ParsedData.key,bucket_name:this.s3ParsedData.bucketName,attachment_name:this.attachmentName,file_data:{file_path:this.s3ParsedData.key,bucket_name:this.s3ParsedData.bucketName,attachment_name:this.attachmentName,file_size:this.file.size,content_type:this.file.type}})})}},{key:"logCreatePendingAttachmentTime",value:function(e){je({label:this.objectName+".filerr."+this.attachmentName+".pending_attachment_creation",timing:Date.now()-e})}},{key:"handleCreatePendingAttachmentIdLogic",value:function(){var e=this;if(!this.createPendingAttachmentIdUrl)return this.s3ParsedData;var t=Date.now();return this.createPendingAttachment().then(function(n){if(!n.ok)throw new ot(n.status,n.statusText,nt.CREATE_PENDING_ATTACHMENT);return e.logCreatePendingAttachmentTime(t),n.json()}).catch(function(e){throw new ot(e.code,e.message,nt.CREATE_PENDING_ATTACHMENT)}).then(function(t){return Object.assign(e.s3ParsedData,{pendingAttachmentData:t})})}}]),e}(),dt=pt,yt=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),mt=function(){function e(t,n,r,o,i,a,s){G(this,e),this.objectName=t,this.attachmentName=n,this.getPolicyUrl=r,this.createPendingAttachmentIdUrl=o,this.file=i,this.policyHandler=a,this.shouldBeRenamed=s,this.handleCreatePendingAttachmentIdLogic=this.handleCreatePendingAttachmentIdLogic.bind(this)}return yt(e,[{key:"abort",value:function(){this.uploadHandler&&this.uploadHandler.abort()}},{key:"upload",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return{}},n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){return{}},o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:5;this.handlePolicyLogic().then(function(e){var t=e.policyData,i=e.fileType;return n.handleUploadLogic(t,i,r,o)}).then(this.handleCreatePendingAttachmentIdLogic).then(e).catch(t)}},{key:"handlePolicyLogic",value:function(){return this.policyHandler.validatePolicy(this.file)}},{key:"handleUploadLogic",value:function(e,t,n,r){return this.uploadHandler=new ft(this.objectName,this.attachmentName,e,t,r,this.file,n,this.shouldBeRenamed),this.uploadHandler.handleUploadLogic()}},{key:"handleCreatePendingAttachmentIdLogic",value:function(e){return new dt(this.objectName,this.attachmentName,this.createPendingAttachmentIdUrl,e,this.file).handleCreatePendingAttachmentIdLogic()}}]),e}(),vt=mt,bt=function(e){function t(e,n){B(this,t);var r=z(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.info=n,r}return X(t,e),t}(function(e){function t(){var t=Reflect.construct(e,Array.from(arguments));return Object.setPrototypeOf(t,Object.getPrototypeOf(this)),t}return t.prototype=Object.create(e.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e,t}(Error)),gt=bt,wt=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),Pt=function(){function e(t,n,r){V(this,e),this.getPolicyUrl=t,this.objectName=n,this.attachmentName=r}return wt(e,[{key:"validatePolicy",value:function(e){var t=this;return this.getPolicy().then(function(n){return t.appendFileType(n,e)}).then(function(n){var r=n.policyData,o=n.fileType;return t.fiverrPolicyValidation(r.policy.fiverr_policy,o,e),{policyData:r,fileType:o}})}},{key:"getPolicy",value:function(){var e=this,t=Date.now();return this.policyPromise||(this.policyPromise=Fe(this.getPolicyUrl,{method:"POST",body:JSON.stringify({object_name:this.objectName,attachment_name:this.attachmentName})}).then(function(n){if(!n.ok)throw new ot(n.status,n.statusText,nt.GET_POLICY);return e.logPolicyFetchTime(t),n.json()}).catch(function(e){throw new ot(e.code,e.message,nt.GET_POLICY)})),this.policyPromise}},{key:"logPolicyFetchTime",value:function(e){je({label:this.objectName+".filerr."+this.attachmentName+".s3_policy",timing:Date.now()-e})}},{key:"appendFileType",value:function(e,t){return D(t).then(function(t){return{policyData:e,fileType:t}})}},{key:"fiverrPolicyValidation",value:function(e,t,n){!function(){if(e.supported_file_types&&e.supported_file_types.length&&-1===e.supported_file_types.indexOf(t))throw new gt("Unsupported file type: "+t,"supported types are: "+e.supported_file_types);if(e.unsupported_file_types&&e.unsupported_file_types.length&&-1!==e.unsupported_file_types.indexOf(t))throw new gt("Unsupported file type: "+t,"unsupported types are: "+e.unsupported_file_types)}(),function(){if(e.max_file_size&&e.max_file_size<n.size)throw new gt("Unsupported file size: "+n.size,"supported size is: "+e.max_file_size)}()}}]),e}(),_t=Pt;n.d(t,"FilerrUploader",function(){return Ot}),n.d(t,"RemoteActionError",function(){return ot}),n.d(t,"PolicyValidationError",function(){return gt});var kt=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),Ot=function(){function e(t){W(this,e),e.validateConstructor(t),this.objectName=t.objectName,this.attachmentName=t.attachmentName,this.getPolicyUrl=t.getPolicyUrl,this.createPendingAttachmentIdUrl=t.createPendingAttachmentIdUrl,this.shouldBeRenamed=t.shouldBeRenamed,this.policyHandler=new _t(this.getPolicyUrl,this.objectName,this.attachmentName)}return kt(e,[{key:"upload",value:function(t){e.validateUpload(t);var n=t.file,r=t.onSuccess,o=t.onError,i=t.onProgress,a=t.retryAttempts,s=new vt(this.objectName,this.attachmentName,this.getPolicyUrl,this.createPendingAttachmentIdUrl,n,this.policyHandler,this.shouldBeRenamed);return s.upload(r,o,i,a),s}}],[{key:"validateConstructor",value:function(e){if(!e)throw new Error("Options weren't provided, expecting: objectName, attachmentName, getPolicyUrl, [createPendingAttachmentIdUrl]");var t=e.objectName,n=e.attachmentName,r=e.getPolicyUrl,o=e.createPendingAttachmentIdUrl,i="Some required fields were'nt provided: ";if(t||(i+=" objectName, "),n||(i+=" attachmentName, "),r||(i+=" getPolicyUrl, "),"Some required fields were'nt provided: "!==i)throw new Error(i.slice(0,i.length-2));if(i="should be of type: String","string"!==typeof t&&(i=" ,objectName "+i),"string"!==typeof n&&(i=" ,attachmentName "+i),"string"!==typeof r&&(i=" ,getPolicyUrl "+i),o&&"string"!==typeof o&&(i=" ,createPendingAttachmentIdUrl "+i),"should be of type: String"!==i)throw new TypeError(i.slice(2))}},{key:"validateUpload",value:function(e){var t=e.file,n=e.onSuccess,r=e.onError,o=e.onProgress,i=e.retryAttempts,a="Some required fields were'nt provided: ";if(t||(a+=" file, "),n||(a+=" onSuccess, "),"Some required fields were'nt provided: "!==a)throw new Error(a.slice(0,a.length-2));if(!(t instanceof File))throw new TypeError("file should be of type: File");if(a="should be of type: Function","function"!==typeof n&&(a=" ,onSuccess "+a),r&&"function"!==typeof r&&(a=" ,onError "+a),o&&"function"!==typeof o&&(a=" ,onProgress "+a),"should be of type: Function"!==a)throw new TypeError(a.slice(2));if(i&&!(i instanceof Number))throw new TypeError("retryAttempts should be of type: Number")}}]),e}()}})})},eIBB:function(e,t){e.exports={"seller-levels":{"level-one-seller":"Level 1 Seller","level-one-seller-tooltip":"Completed at least 10 orders on time with a minimum 4.8 rating","level-two-seller":"Level 2 Seller","level-two-seller-tooltip":"Completed at least 50 orders on time with a minimum 4.8 rating","top-rated-seller":"Top Rated Seller","top-rated-seller-tooltip":"Vetted by Fiverr and completed at least 100 orders on time with a minimum 4.8 rating","new-pro":"New Pro Seller","new-seller":"New Arrival","pro-spotlight-seller":"Pro Spotlight Seller","pro-spotlight-seller-tooltip":"Leaders and experts in their fields, these sellers are featured on Fiverr for a limited time."}}},h4G9:function(e,t){e.exports=o},jPm4:function(e,t){e.exports=i},lVK7:function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function i(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function u(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=n("Jmof"),c=n.n(l),f=n("wLXD"),h=n.n(f),p=n("T9WB"),d=n.n(p),y=n("eIBB"),m=n.n(y),v=n("ZMEE"),b=(n("h4G9"),n("2pqD"),n("UwmQ"),function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}()),g=function(e){var t=e.userName;return c.a.createElement("b",{className:"seller-link"},t)};g.propTypes={userName:d.a.string.isRequired};var w=function(e){function t(e){r(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.onAnchorClick=n.onAnchorClick.bind(n),n}return i(t,e),b(t,[{key:"onAnchorClick",value:function(e){e.preventDefault(),document.getElementById(this.props.anchorLink).scrollIntoView({behavior:"smooth",block:"start"})}},{key:"render",value:function(){var e=this.props,t=e.userName,n=e.link,r=e.anchorLink;return c.a.createElement("a",{href:r?"#"+r:n,className:"seller-link",rel:"nofollow,noindex",onClick:r?this.onAnchorClick:null},t)}}]),t}(c.a.Component);w.propTypes={userName:d.a.string.isRequired,link:d.a.string.isRequired};var P=function(e){var t=e.userName,n=e.link,r=e.noLink,o=e.anchorLink;return r?c.a.createElement(g,{userName:t}):c.a.createElement(w,{userName:t,link:n||"https://www.fiverr.com/"+t,anchorLink:o})};P.propTypes={userName:d.a.string.isRequired,link:d.a.string,noLink:d.a.bool,anchorLink:d.a.string},P.defaultProps={noLink:!1};var _=P,k=n("JgyH"),O=n.n(k),j=(n("Tiji"),{0:"no-level-seller",1:"level-one-seller",2:"level-two-seller",5:"top-rated-seller"}),S={50:"tiny",110:"sml-alt",150:"med"},E={"no-level-seller":0,"level-one-seller":1,"level-two-seller":2,"top-rated-seller":5},T=function(e){return j[e]||""},A=function(e){return S[e]||""},N=function(e,t,n,r){var o="",i="",a="";switch(e){case 1:case 2:case 5:o=j[e],a=i18n.t("seller-levels."+j[e]+"-tooltip");break;default:t?o="new-pro":r&&(o="new-seller")}return n&&(o="pro-spotlight-seller",a=i18n.t("seller-levels."+o+"-tooltip")),""===o?{sellerLevelText:i,sellerLevelTooltip:a}:(i=i18n.t("seller-levels."+o),{sellerLevelText:i,sellerLevelTooltip:a})},x=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},I=function(e){var t=e.level,n=e.isPro,r=e.isLimitedEdition,o=e.isNewSeller,i=N(t,n,r,o),a=i.sellerLevelText,s=i.sellerLevelTooltip,u={},l=O()("gig-seller-tooltip",{"badge-hint js-badge-hint":!!t});return t&&(u["data-hint"]=s),a?c.a.createElement("div",x({},u,{className:l}),c.a.createElement("span",{className:"seller-level"},t===E["top-rated-seller"]?c.a.createElement("em",null,a):a)):null};I.propTypes={level:d.a.number,isPro:d.a.bool,isLimitedEdition:d.a.bool,isNewSeller:d.a.bool},I.defaultProps={isPro:!1,isLimitedEdition:!1,isNewSeller:!1};var q=I,L=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),C=function(e){function t(e){a(this,t);var n=s(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return i18n.add(m.a),n.state={file:null,saving:!1,newImage:""},n.onInputChange=n.onInputChange.bind(n),n.displayImage=n.displayImage.bind(n),n}return u(t,e),L(t,[{key:"onInputChange",value:function(e){var t=this,n=e.target.files[0];n&&this.setState({file:n,saving:!0},function(){t.directUploadFile()})}},{key:"displayImage",value:function(e){this.setState({file:null,saving:!1,newImage:e})}},{key:"saveImage",value:function(e){var t=e.key,n=e.bucketName,r=Date.now(),o=new FormData;return o.append("authenticity_token",this.props.authToken),o.append("s3_file_path",t),o.append("bucket_name",n),o.append("file_data[file_path]",t),o.append("file_data[bucket_name]",n),o.append("file_data[file_size]",this.state.file.size),o.append("file_data[content_type]",this.state.file.type),o.append("user_id",this.props.user.user_id),fetch(this.props.uploadPhotoPath,{method:"POST",body:o,headers:new Headers({Accept:"application/json","X-Requested-With":"XMLHttpRequest","X-CSRF-Token":this.props.authToken}),credentials:"same-origin"}).then(function(e){return e.json()}).then(function(e){return window.Fiverr&&Fiverr._broadcastLogEvents&&Fiverr._broadcastLogEvents({facility:"graphite",type:"timing",label:"profile.filerr.seller_page.update_photo",value:Date.now()-r}),e}).catch(function(e){window.Fiverr&&Fiverr._logEventToGraphite&&Fiverr._logEventToGraphite({label:"profile.filerr.seller_page.ajax.s3_upload.error",percentage:100}),Fiverr._logErrorToServer("seller_card_package","Seller Filerr photo","[s3_direct_upload] "+e.responseText+", status:"+e.status)})}},{key:"directUploadFile",value:function(){var e=this;if(!this.filerrUploader){var t={objectName:"profile",attachmentName:"photo",getPolicyUrl:this.props.fetchPolicyPath,shouldBeRenamed:!0};this.filerrUploader=new v.FilerrUploader(t)}var n={file:this.state.file,onSuccess:function(t){e.saveImage(t).then(function(t){e.displayImage(t.url)})},onError:function(t){t instanceof v.PolicyValidationError&&e.setState({file:null,saving:!1,newImage:""})}};this.filerrUploader.upload(n)}},{key:"render",value:function(){var e=this.props,t=e.user,n=e.allowEditing,r=e.profileImageSize,o=e.isNewSeller,i=e.showUserDescription,a=e.isUserOnline,s=e.basePath,u=e.trackingSource,l=e.anchorLink,f=!!(t.is_seller&&t.achievement&&t.achievement>0),h=A(r),p=T(t.achievement),d=this.state.newImage,y=t.has_profile_photo||d,m=t.username?t.username.substring(0,1):"x",v=""===u?""+s+t.username:""+s+t.username+"?source="+u,b=void 0,g="";return n&&!this.state.saving?g="editable":this.state.saving&&(g="loading"),b=y?c.a.createElement("img",{src:d||t.profile_photo,className:"user-pict-img",alt:t.username}):c.a.createElement("span",{className:"missing-image-user"},m),c.a.createElement("div",{className:"user-profile-image"},c.a.createElement("label",{className:"user-pict user-pict-"+r+" "+g,htmlFor:"profile_image"},n&&c.a.createElement("input",{accept:"image/png,image/jpeg",className:"hidden",onChange:this.onInputChange,id:"profile_image",name:"profile[image]",type:"file"}),b,f&&c.a.createElement("a",{href:s+"levels",className:"user-badge-round user-badge-round-"+h+" "+p})),i&&c.a.createElement("div",{className:"user-description"},c.a.createElement("span",{className:"user-status"},c.a.createElement(_,{userName:t.username,noLink:!1,link:v,anchorLink:l}),a&&c.a.createElement("i",{className:"user-online-circle"})),c.a.createElement(q,{level:t.achievement,isPro:t.is_pro,isLimitedEdition:!1,isNewSeller:o})))}}]),t}(l.PureComponent);C.propTypes={user:d.a.object.isRequired,allowEditing:d.a.bool.isRequired,authToken:d.a.string.isRequired,uploadPhotoPath:d.a.string.isRequired,fetchPolicyPath:d.a.string.isRequired,profileImageSize:d.a.number,isNewSeller:d.a.bool,showUserDescription:d.a.bool,isUserOnline:d.a.bool,basePath:d.a.string,trackingSource:d.a.string,anchorLink:d.a.string},C.defaultProps={profileImageSize:150,isNewSeller:!1,showUserDescription:!1,isUserOnline:!1,basePath:"https://www.fiverr.com/",trackingSource:"",anchorLink:""};var D=C,U="undefined"!==typeof document&&document.getElementById("ProfileImage-component");if(U){var R=window.initialData.ProfileImage;h.a.render(c.a.createElement(D,R),U)}t.default=D},wLXD:function(e,t){e.exports=a}})});
//# sourceMappingURL=index.1e67a9f49b794d84dfc0.js.map

/***/ }),

/***/ "YBeT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZUpz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"seller_card":{"badge_now":"NOW","contact_me":"Contact Me","custom_order":"Custom Order","member_since":"Member since","from":"From","num_reviews":{"one":"%{count} review","other":"%{count} reviews"},"block_user":{"open_text":"Block","title":"Block Buyer","description":"You have control over who can buy your Gigs and services. If you've experienced an issue with a buyer, you may choose to block them.","question":"What is your reason for blocking %{userName}?","options":{"other":"Other","negative":"Previous negative work experience","provide":"I don't provide the requested service","abusive":"Abusive and/or inappropriate behavior"},"cancel":"Cancel","submit":"Submit","learn_more":"Learn More","learn_more_text":"https://sellers.fiverr.com/en/article/blocking-certain-buyers"},"oneliner":{"placeholder":"What's your story in one line?","error_oneliner_short":"Text is too short - must be at least 3 characters.","error_oneliner_long":"Text is too long - must be 70 characters or less.","error_oneliner_invalid":"Text must contain only letters, numbers and (,!:')."},"read_more_text":{"more":"+ See More","less":"- See Less"},"recent_delivery":"Recent Delivery","response_time":"Avg. Response Time","response_time_hours":{"one":"1 hour","other":"${count} hours"},"response_time_days":{"one":"1 day","other":"${count} days"},"out_of_office":"Out of Office","pro":{"tooltip_seller":"Pro sellers are pre-vetted and hand selected professionals, verified by Fiverr","verified_by":"Verified by Fiverr in"},"view_as_buyer":"Preview Public Mode","view_as_seller":"Edit Profile Mode","general_info":"General Info","about_me":"About me","returning_buyers_seller":{"title":"%{userName} is a hot pick for our buyers","text":"They have more returning buyers than the average seller"}}}

/***/ }),

/***/ "h4G9":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_h4G9__;

/***/ }),

/***/ "huvo":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("/cOS");
var parseStyle = __webpack_require__("Uo+f");
var _ = __webpack_require__("jCb9");


/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull (obj) {
  return (obj === undefined || obj === null);
}

/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject (obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */
function FilterCSS (options) {
  options = shallowCopyObject(options || {});
  options.whiteList = options.whiteList || DEFAULT.whiteList;
  options.onAttr = options.onAttr || DEFAULT.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  this.options = options;
}

FilterCSS.prototype.process = function (css) {
  // 兼容各种奇葩输入
  css = css || '';
  css = css.toString();
  if (!css) return '';

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr = options.onAttr;
  var onIgnoreAttr = options.onIgnoreAttr;
  var safeAttrValue = options.safeAttrValue;

  var retCSS = parseStyle(css, function (sourcePosition, position, name, value, source) {

    var check = whiteList[name];
    var isWhite = false;
    if (check === true) isWhite = check;
    else if (typeof check === 'function') isWhite = check(value);
    else if (check instanceof RegExp) isWhite = check.test(value);
    if (isWhite !== true) isWhite = false;

    // 如果过滤后 value 为空则直接忽略
    value = safeAttrValue(name, value);
    if (!value) return;

    var opts = {
      position: position,
      sourcePosition: sourcePosition,
      source: source,
      isWhite: isWhite
    };

    if (isWhite) {

      var ret = onAttr(name, value, opts);
      if (isNull(ret)) {
        return name + ':' + value;
      } else {
        return ret;
      }

    } else {

      var ret = onIgnoreAttr(name, value, opts);
      if (!isNull(ret)) {
        return ret;
      }

    }
  });

  return retCSS;
};


module.exports = FilterCSS;


/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "itU2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jCb9":
/***/ (function(module, exports) {

module.exports = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, '');
  },
  trimRight: function (str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, '');
  }
};


/***/ }),

/***/ "jPm4":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_jPm4__;

/***/ }),

/***/ "krhF":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var _ = __webpack_require__("noAI");

/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */
function getTagName(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    var tagName = html.slice(1, -1);
  } else {
    var tagName = html.slice(1, i + 1);
  }
  tagName = _.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
  return tagName;
}

/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */
function isClosing(html) {
  return html.slice(0, 2) === "</";
}

/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */
function parseTag(html, onTag, escapeHtml) {
  "user strict";

  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";

  for (currentPos = 0; currentPos < len; currentPos++) {
    var c = html.charAt(currentPos);
    if (tagStart === false) {
      if (c === "<") {
        tagStart = currentPos;
        continue;
      }
    } else {
      if (quoteStart === false) {
        if (c === "<") {
          rethtml += escapeHtml(html.slice(lastPos, currentPos));
          tagStart = currentPos;
          lastPos = currentPos;
          continue;
        }
        if (c === ">") {
          rethtml += escapeHtml(html.slice(lastPos, tagStart));
          currentHtml = html.slice(tagStart, currentPos + 1);
          currentTagName = getTagName(currentHtml);
          rethtml += onTag(
            tagStart,
            rethtml.length,
            currentTagName,
            currentHtml,
            isClosing(currentHtml)
          );
          lastPos = currentPos + 1;
          tagStart = false;
          continue;
        }
        if ((c === '"' || c === "'") && html.charAt(currentPos - 1) === "=") {
          quoteStart = c;
          continue;
        }
      } else {
        if (c === quoteStart) {
          quoteStart = false;
          continue;
        }
      }
    }
  }
  if (lastPos < html.length) {
    rethtml += escapeHtml(html.substr(lastPos));
  }

  return rethtml;
}

var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9_:\.\-]/gim;

/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */
function parseAttr(html, onAttr) {
  "user strict";

  var lastPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;

  function addAttr(name, value) {
    name = _.trim(name);
    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name.length < 1) return;
    var ret = onAttr(name, value || "");
    if (ret) retAttrs.push(ret);
  }

  // 逐个分析字符
  for (var i = 0; i < len; i++) {
    var c = html.charAt(i);
    var v, j;
    if (tmpName === false && c === "=") {
      tmpName = html.slice(lastPos, i);
      lastPos = i + 1;
      continue;
    }
    if (tmpName !== false) {
      if (
        i === lastPos &&
        (c === '"' || c === "'") &&
        html.charAt(i - 1) === "="
      ) {
        j = html.indexOf(c, i + 1);
        if (j === -1) {
          break;
        } else {
          v = _.trim(html.slice(lastPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i = j;
          lastPos = i + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i);
        if (j === -1) {
          v = _.trim(html.slice(lastPos, i));
          addAttr(v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          i = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i - 1);
        if (j === -1) {
          v = _.trim(html.slice(lastPos, i));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }

  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(_.trim(html.slice(lastPos))));
    }
  }

  return _.trim(retAttrs.join(" "));
}

function findNextEqual(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function findBeforeEqual(str, i) {
  for (; i > 0; i--) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function isQuoteWrapString(text) {
  if (
    (text[0] === '"' && text[text.length - 1] === '"') ||
    (text[0] === "'" && text[text.length - 1] === "'")
  ) {
    return true;
  } else {
    return false;
  }
}

function stripQuoteWrap(text) {
  if (isQuoteWrapString(text)) {
    return text.substr(1, text.length - 2);
  } else {
    return text;
  }
}

exports.parseTag = parseTag;
exports.parseAttr = parseAttr;


/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__);

// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM","var":"ReactDOM"}
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__ = __webpack_require__("wLXD");
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__);

// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes","var":"PropTypes"}
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__ = __webpack_require__("T9WB");
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__);

// EXTERNAL MODULE: ./src/components/status/style.scss
var style = __webpack_require__("I9N9");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/components/status/index.js




/**
 * @function
 * @name Status
 * @param {Boolean} isOnline - whether the user is online
 * @param {Integer} userId - the user's id
 * @param {Boolean} isOnVacation - whether the user is out of office
 * Returns the markup of the online indicator
 */

var status_Status = function Status(_ref) {
    var isOnline = _ref.isOnline,
        userId = _ref.userId,
        isOnVacation = _ref.isOnVacation;

    if (!isOnVacation) {
        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'div',
            { className: 'user-online-indicator ' + (isOnline ? 'is-online ' : ''), 'data-user-id': userId },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'fa fa-circle' }),
            i18n.t('general.online')
        );
    }

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'user-ooo-indicator', 'data-user-id': userId },
        i18n.t('seller_card.out_of_office')
    );
};

status_Status.propTypes = {
    isOnVacation: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    isOnline: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number
};

status_Status.defaultProps = {
    isOnline: false
};

/* harmony default export */ var components_status = (status_Status);
// EXTERNAL MODULE: ./src/components/badges/style.scss
var badges_style = __webpack_require__("itU2");
var badges_style_default = /*#__PURE__*/__webpack_require__.n(badges_style);

// CONCATENATED MODULE: ./src/components/badges/index.js




/**
 * @function
 * @name Badges
 * @param {String} userName - the user's name
 * @param {Boolean} showAmbassador - should show the ambassador badge
 * @param {Boolean} showNow - should show the now badge
 * Returns the markup of the seller card badges
 */

var badges_Badges = function Badges(_ref) {
    var userName = _ref.userName,
        showAmbassador = _ref.showAmbassador,
        showNow = _ref.showNow;


    // now & ambassador badges take up the same space, so the now badge
    // takes precedence

    if (showNow) {

        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'aside',
            { className: 'now-badge' },
            i18n.t('seller_card.badge_now'),
            ' ',
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'span',
                { className: 'beta-badge' },
                i18n.t('general.beta')
            )
        );
    } else if (showAmbassador) {

        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'a',
            { href: 'https://www.fiverr.com/ambassadors/' + userName, className: 'ambassadors-badge' },
            i18n.t('general.ambassador')
        );
    }
};

badges_Badges.propTypes = {
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    showAmbassador: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    showNow: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired
};

/* harmony default export */ var badges = (badges_Badges);
// EXTERNAL MODULE: ./node_modules/@fiverr/profile_image/dist/index.js
var dist = __webpack_require__("V7wu");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/@fiverr/profile_image/dist/index.css
var profile_image_dist = __webpack_require__("0cES");
var profile_image_dist_default = /*#__PURE__*/__webpack_require__.n(profile_image_dist);

// EXTERNAL MODULE: ./node_modules/@fiverr-private/report_user/dist/index.js
var report_user_dist = __webpack_require__("nl6y");
var report_user_dist_default = /*#__PURE__*/__webpack_require__.n(report_user_dist);

// EXTERNAL MODULE: ./node_modules/@fiverr-private/report_user/dist/index.css
var _fiverr_private_report_user_dist = __webpack_require__("Cgq4");
var _fiverr_private_report_user_dist_default = /*#__PURE__*/__webpack_require__.n(_fiverr_private_report_user_dist);

// EXTERNAL MODULE: ./src/components/profile_link/style.scss
var profile_link_style = __webpack_require__("I3Iz");
var profile_link_style_default = /*#__PURE__*/__webpack_require__.n(profile_link_style);

// CONCATENATED MODULE: ./src/components/profile_link/index.js




var profile_link_RenderName = function RenderName(_ref) {
    var userName = _ref.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'b',
        { className: 'seller-link' },
        userName
    );
};

var profile_link_RenderNameWithLink = function RenderNameWithLink(_ref2) {
    var userName = _ref2.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'a',
        { href: '/' + userName, className: 'seller-link', rel: 'nofollow,noindex' },
        userName
    );
};

/**
 * @function
 * @name ProfileLink
 * @param {String} userName - the user's name
 * @param {Boolean} noLink - text only, don't make it a link
 * Returns the markup of the user profile link
 */

var profile_link_ProfileLink = function ProfileLink(_ref3) {
    var userName = _ref3.userName,
        noLink = _ref3.noLink;
    return noLink ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(profile_link_RenderName, { userName: userName }) : external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(profile_link_RenderNameWithLink, { userName: userName });
};

profile_link_ProfileLink.propTypes = {
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    noLink: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

/* harmony default export */ var profile_link = (profile_link_ProfileLink);
// CONCATENATED MODULE: ./src/utils.js
/**
 * @name hasOneliner
 * @param {String} oneLiner - seller's oneliner text
 * @return {Boolean} Does this seller have a valid oneliner text?
 */
function hasOneliner(oneLiner) {
    return oneLiner && oneLiner.length > 0 && oneLiner !== i18n.t('seller_card.oneliner.placeholder');
}

/**
 * @name showResponseTime
 * @param {String} sellerResponsiveness - seller's responsive time
 * @return {Boolean} Does this seller have a valid responsive time?
 */
function showResponseTime(sellerResponsiveness) {
    return parseInt(sellerResponsiveness, 10) > 0;
}

/**
 * @name formatHoursAsDays
 * @param {Integer} hours - the hours that should be formatted
 * @return {String} A translated string with either hours or days
 */
function formatHoursAsDays(hours) {

    var output = void 0;

    if (hours < 24) {
        output = i18n.t('seller_card.response_time_hours', { count: hours });
    } else {
        var days = Math.round(hours / 24);
        output = i18n.t('seller_card.response_time_days', { count: days });
    }

    return output;
}

/**
 * Replace break tags with something else
 * @param  {String} string
 * @param  {String} [replacer='\r\n']
 * @return {String}
 */
var replaceBreakTags = function replaceBreakTags(string) {
    var replacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\r\n';
    return string.replace(/\s?(<br\s?\/?>)\s?/g, replacer);
}; // eslint-disable-line no-control-regex
// EXTERNAL MODULE: ./src/components/oneliner/style.scss
var oneliner_style = __webpack_require__("1fVw");
var oneliner_style_default = /*#__PURE__*/__webpack_require__.n(oneliner_style);

// CONCATENATED MODULE: ./src/components/oneliner/index.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * @class
 * @name Oneliner
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {String} authToken - Fiverr authentication token
 * Returns the markup of the user oneliner & ratings
 */

var oneliner_Oneliner = function (_Component) {
    _inherits(Oneliner, _Component);

    function Oneliner(props) {
        _classCallCheck(this, Oneliner);

        var _this = _possibleConstructorReturn(this, (Oneliner.__proto__ || Object.getPrototypeOf(Oneliner)).call(this, props));

        _this.state = {
            mode: 'view', // view, edit, error
            oneliner: '',
            initialOneliner: '',
            errorText: ''
        };

        _this.onEditIconClick = _this.onEditIconClick.bind(_this);
        _this.onSaveClick = _this.onSaveClick.bind(_this);
        _this.onCancelClick = _this.onCancelClick.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onInputKeyPress = _this.onInputKeyPress.bind(_this);
        return _this;
    }

    _createClass(Oneliner, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var onelinerText = '';

            if (hasOneliner(this.props.user.one_liner)) {
                onelinerText = this.props.user.one_liner;
            } else if (this.props.allowEditing) {
                onelinerText = i18n.t('seller_card.oneliner.placeholder');
            }

            this.setState({
                oneliner: onelinerText,
                initialOneliner: onelinerText
            });
        }
    }, {
        key: 'onEditIconClick',
        value: function onEditIconClick() {
            this.setState({
                mode: 'edit'
            });
        }
    }, {
        key: 'onSaveClick',
        value: function onSaveClick(e) {
            e.preventDefault();

            var check = this.checkForValid();
            if (check.isValid) {

                if (typeof fetch !== 'undefined' && this.state.oneliner !== this.state.initialOneliner) {

                    fetch('/users/' + this.props.user.username, {
                        method: 'PATCH',
                        body: encodeURI('user[profile_attributes][one_liner]=' + this.state.oneliner),
                        headers: new Headers({
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-CSRF-Token': this.props.authToken
                        }),
                        credentials: 'same-origin'
                    }).catch(function (err) {
                        console.log('There was an error when trying to update the oneliner: ', err.message); // eslint-disable-line
                    });
                }

                this.setState({
                    mode: 'view',
                    initialOneliner: this.state.oneliner,
                    errorText: ''
                });
            } else {

                this.setState({
                    mode: 'error',
                    errorText: check.errorText
                });
            }
        }
    }, {
        key: 'onCancelClick',
        value: function onCancelClick(e) {
            e.preventDefault();
            this.setState({
                mode: 'view',
                oneliner: this.state.initialOneliner,
                errorText: ''
            });
        }
    }, {
        key: 'onInputChange',
        value: function onInputChange(e) {
            this.setState({
                oneliner: e.target.value,
                errorText: ''
            });
        }
    }, {
        key: 'onInputKeyPress',
        value: function onInputKeyPress(e) {
            if (e.key === 'Enter') {
                this.onSaveClick(e);
            }
        }
    }, {
        key: 'checkForValid',
        value: function checkForValid() {

            var value = this.state.oneliner;

            var isValid = true,
                errorText = '';

            // validate oneliner
            if (value === '' || value.length < 3) {
                // blank text, text too short
                isValid = false;
                errorText = i18n.t('seller_card.oneliner.error_oneliner_short');
            } else if (value.length > 70) {
                // text too long
                isValid = false;
                errorText = i18n.t('seller_card.oneliner.error_oneliner_long');
            } else if (value === this.state.initialOneliner) {
                // text hasn't changed, do nothing
            } else if (value.trim() === i18n.t('seller_card.oneliner.placeholder')) {
                // text is the default placeholder, do nothing
            } else {
                if (/^[a-zA-Z0-9\s\,\?\:\'\"\!]+$/.test(value)) {// eslint-disable-line
                    // text has changed & is valid
                } else {
                    // text has changed, but is invalid
                    isValid = false;
                    errorText = i18n.t('seller_card.oneliner.error_oneliner_invalid');
                }
            }

            return {
                isValid: isValid,
                errorText: errorText
            };
        }
    }, {
        key: 'renderEditIcon',
        value: function renderEditIcon() {
            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'fa fa-pencil icn-edit', onClick: this.onEditIconClick });
        }
    }, {
        key: 'renderEditForm',
        value: function renderEditForm() {
            var _this2 = this;

            var showError = this.state.mode === 'error' && this.state.errorText !== '';

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'form',
                null,
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { type: 'text', name: 'user[profile_attributes][one_liner]', autoFocus: 'autofocus', maxLength: '70', ref: function ref(inp) {
                        return inp && inp.focus();
                    }, value: this.state.oneliner, autoComplete: 'off', onChange: function onChange(e) {
                        return _this2.onInputChange(e);
                    }, onKeyPress: function onKeyPress(e) {
                        return _this2.onInputKeyPress(e);
                    } }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'button',
                    { className: 'btn-lrg-standard btn-white m-r-20', onClick: this.onCancelClick },
                    i18n.t('general.cancel')
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'button',
                    { className: 'btn-lrg-standard', onClick: this.onSaveClick },
                    i18n.t('general.update')
                ),
                showError && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'error-container' },
                    this.state.errorText
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing;


            var showOneliner = hasOneliner(user.one_liner) || allowEditing,
                userRatingsCount = parseInt(user.ratings_count, 10),
                showRating = user.is_seller && user.ratings_count > 0,
                showError = this.state.mode === 'error' && this.state.errorText !== '',
                showEdit = this.state.mode === 'edit' || this.state.mode === 'error';

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'oneliner-wrapper' + (showEdit ? ' edit-mode' : '') + (showError ? ' error-mode' : '') + (!showRating ? ' no-rating' : '') },
                showOneliner && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'small',
                    { className: 'oneliner' },
                    this.state.oneliner
                ),
                allowEditing && this.renderEditIcon(),
                showEdit && this.renderEditForm(),
                showRating && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'ratings-wrapper' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'star-rating-s15 rate-' + Math.round(user.rating * 2), 'data-user-rating': user.rating, 'data-user-ratings-count': user.ratings_count }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'p',
                        { className: 'rating-text' },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'strong',
                            null,
                            user.rating.toFixed(1)
                        ),
                        ' ',
                        '(' + i18n.t('seller_card.num_reviews', { count: userRatingsCount < 1000 ? userRatingsCount : '1k+' }) + ')'
                    )
                )
            );
        }
    }]);

    return Oneliner;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

oneliner_Oneliner.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    authToken: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired
};

/* harmony default export */ var oneliner = (oneliner_Oneliner);
// EXTERNAL MODULE: external {"commonjs":"classnames","commonjs2":"classnames","amd":"classnames","root":"classNames","var":"classNames"}
var external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames__ = __webpack_require__("JgyH");
var external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames__);

// EXTERNAL MODULE: ./src/components/buttons/style.scss
var buttons_style = __webpack_require__("Bdlu");
var buttons_style_default = /*#__PURE__*/__webpack_require__.n(buttons_style);

// CONCATENATED MODULE: ./src/components/buttons/index.js
var buttons__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function buttons__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function buttons__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function buttons__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var VIEW_AS_BUYER_QUERY = 'view_as_buyer',
    VIEW_AS_SELLER_QUERY = 'view_as_seller';

/**
 * @class
 * @name Buttons
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} isMobileResponsive - mobile responsive or not
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {Boolean} viewingAsBuyer - whether the seller is viewing their page as a buyer
 * @param {Boolean} isLoggedIn - whether the user is currently logged in
 * @param {Boolean} showCustomOrder - whether we should show the custom order button (if applicable)
 * Container for rendering markup of the contact/custom order buttons
 */

var buttons_Buttons = function (_Component) {
    buttons__inherits(Buttons, _Component);

    function Buttons(props) {
        buttons__classCallCheck(this, Buttons);

        var _this = buttons__possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).call(this, props));

        _this.onContactClick = _this.onContactClick.bind(_this);
        _this.onViewAsClick = _this.onViewAsClick.bind(_this);
        return _this;
    }

    buttons__createClass(Buttons, [{
        key: 'onContactClick',
        value: function onContactClick() {
            // NOTE: MixpanelWrapper is instantiated in v2
            if (typeof MixpanelWrapper !== 'undefined') {
                MixpanelWrapper.bindLink(this.contactBtn, MixpanelWrapper.Events.ConversationEvents.CLICKED_CONTACT_ME);
            }
        }
    }, {
        key: 'onViewAsClick',
        value: function onViewAsClick(e) {
            e.preventDefault();
            var viewingAsBuyer = this.props.viewingAsBuyer;

            var queryType = viewingAsBuyer ? VIEW_AS_BUYER_QUERY : VIEW_AS_SELLER_QUERY,
                cleanLocation = window.location.href.split(/[?#]/)[0];
            window.location.href = cleanLocation + '?' + queryType + '=true';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                user = _props.user,
                isMobileResponsive = _props.isMobileResponsive,
                allowEditing = _props.allowEditing,
                viewingAsBuyer = _props.viewingAsBuyer,
                isLoggedIn = _props.isLoggedIn,
                showCustomOrder = _props.showCustomOrder,
                inWhitingContactButton = _props.inWhitingContactButton;


            var contactCls = void 0,
                orderCls = void 0,
                showContact = user.has_live_gigs && (!user.is_on_vacation || user.is_on_vacation && user.allow_contact),
                showCustomOrderValid = showCustomOrder && user.is_seller && user.custom_orders_allowed && !allowEditing;

            // if user is viewing their own page in the seller view,
            // we don't show the "contact me"-button

            if (allowEditing && !viewingAsBuyer) {
                showContact = false;
            }

            var contactLink = user.contact_path || '/conversations/' + user.username,
                orderLink = !isMobileResponsive ? '#!' : '/custom_orders/request/' + user.username + '/new',
                showViewAs = !isMobileResponsive && (allowEditing || viewingAsBuyer),
                viewAsString = i18n.t('seller_card.view_as_' + (viewingAsBuyer ? 'seller' : 'buyer'));

            if (user.is_spotlight) {
                showContact = false;
                showCustomOrderValid = false;
            }

            // if no buttons are shown, don't return the wrapper
            if (!showContact && !showCustomOrderValid && !showViewAs) {
                return null;
            }

            contactCls = external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default()('btn-lrg-standard btn-contact-me', {
                'btn-white': inWhitingContactButton
            });

            orderCls = 'btn-lrg-standard btn-white btn-custom-order';

            if (!isMobileResponsive) {
                // TODO: "js-contact-me" is referenced in v2 (inside "popup-first-message.js"), needs to be updated
                // NOTE: "js-open-popup-login", "js-open-popup-join", "js-request-custom-order-button" are all bound to v2 JS functions

                contactCls = external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default()(contactCls, 'js-contact-me', {
                    'js-open-popup-login': !isLoggedIn
                });
                orderCls = external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default()(orderCls, {
                    'js-request-custom-order-button': isLoggedIn,
                    'js-open-popup-join': !isLoggedIn
                });
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'buttons-wrapper' },
                showContact && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { href: contactLink, className: contactCls, onClick: this.onContactClick, ref: function ref(ele) {
                            _this2.contactBtn = ele;
                        }, rel: 'nofollow', 'data-user-id': user.username, 'data-redirect-url': contactLink },
                    i18n.t('seller_card.contact_me')
                ),
                showCustomOrderValid && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { href: orderLink, className: orderCls },
                    i18n.t('seller_card.custom_order')
                ),
                showViewAs && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { href: '#!', className: 'btn-lrg-standard btn-white btn-view-as', onClick: this.onViewAsClick },
                    viewAsString
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('div', { id: 'react-first-message-popup' })
            );
        }
    }]);

    return Buttons;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

buttons_Buttons.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    isMobileResponsive: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    viewingAsBuyer: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    isLoggedIn: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    showCustomOrder: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired
};

/* harmony default export */ var buttons = (buttons_Buttons);
// EXTERNAL MODULE: ./src/components/pro/style.scss
var pro_style = __webpack_require__("3XGG");
var pro_style_default = /*#__PURE__*/__webpack_require__.n(pro_style);

// CONCATENATED MODULE: ./src/components/pro/index.js




/**
 * @function
 * @name Pro
 * @param {Object} proCategories - the user's pro subcategories
 * Returns the markup of the user pro subcategories
 */

var pro_Pro = function Pro(_ref) {
    var proCategories = _ref.proCategories,
        proExp = _ref.proExp;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'pro-wrapper' },
        !proExp && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'p',
            null,
            i18n.t('seller_card.pro.verified_by')
        ),
        !proExp && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'label',
            { className: 'pro-badge hint--left', 'data-hint': i18n.t('seller_card.pro.tooltip_seller') },
            i18n.t('general.pro')
        ),
        proExp && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'label',
            { className: 'pro-verified' },
            i18n.t('seller_card.pro.verified_by')
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'ul',
            null,
            proCategories.map(function (subcategory, index) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'li',
                    { key: index },
                    subcategory.name
                );
            })
        )
    );
};

pro_Pro.propTypes = {
    proCategories: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array
};

/* harmony default export */ var pro = (pro_Pro);
// CONCATENATED MODULE: ./src/components/stats/ReturningBuyer.js



var ReturningBuyer_ReturningBuyer = function ReturningBuyer(_ref) {
    var userName = _ref.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'li',
        { className: 'returning-buyer-sc' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'h6',
            null,
            i18n.t('seller_card.returning_buyers_seller.title', { userName: userName })
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'p',
            null,
            i18n.t('seller_card.returning_buyers_seller.text')
        )
    );
};

ReturningBuyer_ReturningBuyer.propTypes = {
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired
};

/* harmony default export */ var stats_ReturningBuyer = (ReturningBuyer_ReturningBuyer);
// EXTERNAL MODULE: ./src/components/stats/style.scss
var stats_style = __webpack_require__("RIUQ");
var stats_style_default = /*#__PURE__*/__webpack_require__.n(stats_style);

// CONCATENATED MODULE: ./src/components/stats/index.js






/**
 * @function
 * @name Stats
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * Returns the markup of the seller stats
 */
var stats_Stats = function Stats(_ref) {
    var user = _ref.user,
        allowEditing = _ref.allowEditing,
        toggleVacation = _ref.toggleVacation,
        isOnVacation = _ref.isOnVacation;

    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var showCountry = user.country && user.country.length > 0,


    // showLastDelivery = parseInt(user.recent_delivery, 10) > 0, // this is the correct way
    showLastDelivery = user.recent_delivery && user.recent_delivery.length > 0,
        // this is getting the wrong value from v2
    memberSinceDate = new Date(user.member_since * 1000),
        memberSince = monthNames[memberSinceDate.getMonth()] + ' ' + memberSinceDate.getFullYear(),
        showVacation = allowEditing && user.is_seller,
        showReturningBuyer = user.sbss;

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'ul',
        { className: 'user-stats' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'h4',
            { className: 'inner-title' },
            i18n.t('seller_card.general_info')
        ),
        showCountry && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'location' },
            i18n.t('seller_card.from'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                user.country
            )
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'member-since' },
            i18n.t('seller_card.member_since'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                memberSince
            )
        ),
        showResponseTime(user.response_time) && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'response-time' },
            i18n.t('seller_card.response_time'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                formatHoursAsDays(user.response_time)
            )
        ),
        showLastDelivery && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'recent-delivery' },
            i18n.t('seller_card.recent_delivery'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                user.recent_delivery
            )
        ),
        showVacation && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'vacation' },
            i18n.t('seller_card.out_of_office'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'toggle-wrapper rf' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'label',
                    { onClick: toggleVacation, className: 'toggle-vacation' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { type: 'checkbox', value: 'vacation', className: isOnVacation ? 'sel' : '', checked: isOnVacation }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('div', { className: 'fake-toggle' })
                )
            )
        ),
        showReturningBuyer && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(stats_ReturningBuyer, { userName: user.username })
    );
};

stats_Stats.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired
};

/* harmony default export */ var stats = (stats_Stats);
// EXTERNAL MODULE: ./node_modules/@fiverr/modal/dist/index.js
var modal_dist = __webpack_require__("5CFU");
var modal_dist_default = /*#__PURE__*/__webpack_require__.n(modal_dist);

// EXTERNAL MODULE: ./src/components/block_user/ModalWrapper/BlockButton/style.scss
var BlockButton_style = __webpack_require__("TIrB");
var BlockButton_style_default = /*#__PURE__*/__webpack_require__.n(BlockButton_style);

// CONCATENATED MODULE: ./src/components/block_user/ModalWrapper/BlockButton/index.js




var BlockButton_BlockButton = function BlockButton(_ref) {
    var togglePopup = _ref.togglePopup;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'button',
        { className: 'block-user-button', onClick: togglePopup },
        i18n.t('seller_card.block_user.open_text')
    );
};

BlockButton_BlockButton.propTypes = {
    togglePopup: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

/* harmony default export */ var ModalWrapper_BlockButton = (BlockButton_BlockButton);
// EXTERNAL MODULE: ./src/components/block_user/ModalWrapper/ModalBody/RadioButton/style.scss
var RadioButton_style = __webpack_require__("YBeT");
var RadioButton_style_default = /*#__PURE__*/__webpack_require__.n(RadioButton_style);

// CONCATENATED MODULE: ./src/components/block_user/ModalWrapper/ModalBody/RadioButton/index.js




var RadioButton_RadioButton = function RadioButton(_ref) {
    var selectedValue = _ref.selectedValue,
        reason = _ref.reason,
        reasonText = _ref.reasonText,
        onChange = _ref.onChange;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'label',
        { className: 'block-reason-radio fake-radio-green radio-text' },
        reasonText,
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { type: 'radio',
            onChange: onChange,
            checked: selectedValue === reason,
            value: reason }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'radio-img' })
    );
};

RadioButton_RadioButton.PropTypes = {
    selectedValue: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    reasonText: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    onChange: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func,
    reason: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

RadioButton_RadioButton.defaultProps = {
    selectedValue: '',
    reasonText: '',
    reason: ''
};

/* harmony default export */ var ModalBody_RadioButton = (RadioButton_RadioButton);
// CONCATENATED MODULE: ./src/components/block_user/ModalWrapper/ModalBody/RadiosWrapper.js




var RadiosWrapper_RadiosWrapper = function RadiosWrapper(_ref) {
    var blockReasons = _ref.blockReasons,
        selectedReason = _ref.selectedReason,
        changeReason = _ref.changeReason;

    var OTHER = 'other';

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'ul',
        null,
        blockReasons.map(function (reason) {
            var reasonText = i18n.t('seller_card.block_user.options.' + reason);

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(ModalBody_RadioButton, { key: reason,
                selectedValue: selectedReason.reason,
                reason: reason,
                reasonText: reasonText,
                onChange: function onChange() {
                    return changeReason(reason, reasonText);
                } });
        }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(ModalBody_RadioButton, { selectedValue: selectedReason.reason,
            reason: OTHER,
            reasonText: i18n.t('seller_card.block_user.options.' + OTHER),
            onChange: function onChange() {
                return changeReason(OTHER, '');
            } }),
        selectedReason.reason === OTHER && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('textarea', { value: selectedReason.reasonText,
            onChange: function onChange(e) {
                return changeReason(OTHER, e.target.value);
            } })
    );
};

RadiosWrapper_RadiosWrapper.propTypes = {
    blockReasons: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    selectedReason: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    changeReason: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

RadiosWrapper_RadiosWrapper.defaultProps = {
    blockReasons: [],
    selectedReason: { reason: '', reasonText: '' }
};

/* harmony default export */ var ModalBody_RadiosWrapper = (RadiosWrapper_RadiosWrapper);
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/array/pluck/index.mjs
/**
 * @module pluck
 * @since 1.0.0
 */

/**
 * Pluck values of a certain key from array of objects
 *
 * @param  {Object[]}  objects Array of objects
 * @param  {String} key The key we want to pluck
 * @return {Array}  An array of the values stored in the specified key of each object
 *
 * @example pluck([{key_name: 1}, {key_name: 2}], 'key_name');
 * // [1, 2]
 */
var pluck = function pluck() {
  var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments[1];
  return objects.map(function (item) {
    return item[key];
  });
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/array/shuffle/index.mjs
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module shuffle
 * @since 1.0.0
 */

/**
 * Shuffle array
 *
 * @param  {Array}  array - An array
 * @param  {Boolean|true} mutate - whether to mutate the original array
 * @return {Array} The shuffled array
 *
 * @example
 * shuffle([1, 2, 3], false);
 * // [1, 3, 2] for example
 */
function shuffle() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var mutate = arguments[1];

    if (!Array.isArray(array)) {
        throw new TypeError("shuffle expects first argument to be an array, got a " + (typeof array === "undefined" ? "undefined" : _typeof(array)));
    }

    var index = array.length;

    // Don't mutate the original array
    if (mutate === false) {
        array = array.slice(0);
    }

    while (index) {
        var curry = Math.floor(Math.random() * index);
        var item = array[--index];
        array[index] = array[curry];
        array[curry] = item;
    }

    return array;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/array/index.mjs
/**
 * @namespace array
 * @since 2.0.0
 */




/**
 * array A collection of array related methods
 * @type     {Object}
 * @property {Function} pluck   @see <a href="identifiers.html#array-pluck">pluck</a>
 * @property {Function} shuffle @see <a href="identifiers.html#array-shuffle">shuffle</a>
 */
var array = {
  pluck: pluck,
  shuffle: shuffle
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/MINUTE_IN_MS/index.mjs
/**
 * How many milliseconds are in a minute
 * @type {Number}
 */
var MINUTE_IN_MS = 6e4;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/HOUR_IN_MS/index.mjs
/**
 * How many milliseconds are in an hour
 * @type {Number}
 */
var HOUR_IN_MS = 36e5;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/DAY_IN_MS/index.mjs
/**
 * How many milliseconds are in a day
 * @type {Number}
 */
var DAY_IN_MS = 864e5;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/WEEK_IN_MS/index.mjs
/**
 * How many milliseconds are in a week
 * @type {Number}
 */
var WEEK_IN_MS = 6048e5;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/MONTH_IN_MS/index.mjs
/**
 * How many milliseconds are in a month
 * @type {Number}
 */
var MONTH_IN_MS = 2592e6;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/YEAR_IN_MS/index.mjs
/**
 * How many milliseconds are in a year
 * @type {Number}
 */
var YEAR_IN_MS = 31536e6;
// EXTERNAL MODULE: external {"commonjs":"@fiverr/i18n/singleton","commonjs2":"@fiverr/i18n/singleton","amd":"@fiverr/i18n/singleton","root":"i18n","var":"i18n"}
var singleton___root___i18n___var___i18n__ = __webpack_require__("h4G9");
var singleton___root___i18n___var___i18n___default = /*#__PURE__*/__webpack_require__.n(singleton___root___i18n___var___i18n__);

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/howLongAgo/index.mjs
/**
 * @module howLongAgo
 * @since 2.0.0
 */





/**
 * Default translation prefix
 * @type {String}
 */
var DEFAULT_PREFIX = 'general.how_long_ago.';

/**
 * return the time that has passed since the current time
 * @param  {Date|Number|String} date Point in time to describe in words. Ticks can be accepted as a number or string
 * @param  {Object} options
 * @param  {String} [options.prefix='general.how_long_ago.'] The base string for the translation
 * @return {String}                                          Descriptive, relative time
 *
 * @property {Number} MINUTE_IN_MS Number of milliseconds in a minute
 * @property {Number} HOUR_IN_MS   Number of milliseconds in an hour
 * @property {Number} DAY_IN_MS    Number of milliseconds in a day
 * @property {Number} WEEK_IN_MS   Number of milliseconds in a week
 * @property {Number} MONTH_IN_MS  Number of milliseconds in a month
 * @property {Number} YEAR_IN_MS   Number of milliseconds in a year
 */
function howLongAgo() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === undefined ? DEFAULT_PREFIX : _ref$prefix;

  var now = Date.now();
  var t = now - date;

  /* eslint-disable no-multi-spaces */
  return Number.isNaN(t) ? '' : // invalid
  t < MINUTE_IN_MS && howLongAgo_txt(prefix, 'just_now') || // seconds
  t < HOUR_IN_MS && howLongAgo_txt(prefix, 'minutes_ago', t / MINUTE_IN_MS) || // minutes
  t < DAY_IN_MS && howLongAgo_txt(prefix, 'hours_ago', t / HOUR_IN_MS) || // hours
  t < WEEK_IN_MS && howLongAgo_txt(prefix, 'days_ago', t / DAY_IN_MS) || // days
  t < MONTH_IN_MS && howLongAgo_txt(prefix, 'weeks_ago', t / WEEK_IN_MS) || // weeks
  t < YEAR_IN_MS && howLongAgo_txt(prefix, 'months_ago', t / MONTH_IN_MS) || // months
  howLongAgo_txt(prefix, 'years_ago', t / YEAR_IN_MS); // years
  /* eslint-enable no-multi-spaces */
}

/**
 * Translate how long ago X
 * @private
 * @param  {String} prefix translation root (with trailing dot where applicable)
 * @param  {String} k      translation key
 * @param  {Number} [c=0]  count
 * @return {String}
 */
var howLongAgo_txt = function txt(prefix, k) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return singleton___root___i18n___var___i18n___default.a.t('' + prefix + k, { count: Math.floor(c) });
};

// Assign used consts to the function
Object.assign(howLongAgo, {
  MINUTE_IN_MS: MINUTE_IN_MS,
  HOUR_IN_MS: HOUR_IN_MS,
  DAY_IN_MS: DAY_IN_MS,
  WEEK_IN_MS: WEEK_IN_MS,
  MONTH_IN_MS: MONTH_IN_MS,
  YEAR_IN_MS: YEAR_IN_MS
});
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/setTime/index.mjs
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var setTime__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module datetime/setTime
 * @since 2.0.0
 */

/**
 * setTime - get a date according to provided time
 * @param  {Date}   date
 * @param  {String} time time string with the format of HH:MM:SS, units are omittable
 * @return {Date}
 *
 * @example setTime((new Date()), '10:30');
 */
function setTime(date, time) {
  if (typeof time !== 'string') {
    throw new TypeError('setTime expects "time" argument to be a string. Instead got a ' + (typeof string === 'undefined' ? 'undefined' : setTime__typeof(string)));
  }

  var _time$split = time.split(':'),
      _time$split2 = _slicedToArray(_time$split, 3),
      _time$split2$ = _time$split2[0],
      hours = _time$split2$ === undefined ? 0 : _time$split2$,
      _time$split2$2 = _time$split2[1],
      minutes = _time$split2$2 === undefined ? 0 : _time$split2$2,
      _time$split2$3 = _time$split2[2],
      seconds = _time$split2$3 === undefined ? 0 : _time$split2$3;

  date.setHours(parseInt(hours, 10));
  date.setMinutes(parseInt(minutes, 10));
  date.setSeconds(parseInt(seconds, 10));
  return date;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/inTimeRange/index.mjs
/**
 * @module datetime/inTimeRange
 * @since 2.0.0
 */



/**
 * inTimeRange - check if the date object provided is in the time range
 * @param  {Date}   date *can also be a date that represent a different timezone
 * @param  {String} from represent a starting time, example: 'HH:MM'
 * @param  {String} to   represent an ending time, example: 'HH:MM'
 * @return {Boolean}
 *
 * @example inTimeRange((new Date()), '10:30', '13:45')
 */
function inTimeRange(date, from, to) {
  var time = date.getTime();

  return setTime(new Date(time), from).getTime() <= time && setTime(new Date(time), to).getTime() >= time;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/remoteDate/index.mjs
/**
 * @module datetime/remoteDate
 * @since 2.0.0
 */



/**
 * getRemote - get a remote date object according to an offset
 * @param  {Number} offset represent the offset from UTC time minutes
 * @return {Date}
 *
 * @example getRemote(remoteOffset);
 */
function remoteDate(offset) {
  var date = new Date();
  var localOffset = date.getTimezoneOffset();
  var localTime = date.getTime();

  var localOffsetMsec = localOffset * MINUTE_IN_MS;
  var remoteOffsetMsec = offset * MINUTE_IN_MS;
  var remoteTime = localTime + localOffsetMsec - remoteOffsetMsec;

  return new Date(remoteTime);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/formatDate/index.mjs
/**
 * @module datetime/formatDate
 * @since 2.4.0
 */

var DEFAULT_YEAR_FORMAT = 'numeric';
var DEFAULT_MONTH_FORMAT = 'short';
var DEFAULT_DAY_FORMAT = 'numeric';
var DEFAULT_LOCALE = 'en';

/**
 * formatDate - get a date string according to formatting options
 * @param   {Date} datetime
 * @param   {Object} options
 * @param   {String} [options.year='numeric']
 * @param   {String} [options.month='short']
 * @param   {String} [options.day='short']
 * @param   {String} [options.locale='en']
 * @returns {String} representation of the date based on formatting options
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
 */
function formatDate(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$year = _ref.year,
      year = _ref$year === undefined ? DEFAULT_YEAR_FORMAT : _ref$year,
      _ref$month = _ref.month,
      month = _ref$month === undefined ? DEFAULT_MONTH_FORMAT : _ref$month,
      _ref$day = _ref.day,
      day = _ref$day === undefined ? DEFAULT_DAY_FORMAT : _ref$day,
      _ref$locale = _ref.locale,
      locale = _ref$locale === undefined ? DEFAULT_LOCALE : _ref$locale;

  if (!(date instanceof Date)) {
    throw new TypeError('formatDate expects \'date\' argument to be instance of Date');
  }

  var formatter = new Intl.DateTimeFormat(locale, { month: month, year: year, day: day });
  return formatter.format(date);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/datetime/index.mjs
/**
 * @namespace datetime
 * @since 2.0.0
 */













/**
 * datetime A collection of datetime related methods
 * @type     {Object}
 * @property {Number}   MINUTE_IN_MS @see <a href="identifiers.html#array-minute_in_ms">MINUTE_IN_MS</a>
 * @property {Number}   HOUR_IN_MS   @see <a href="identifiers.html#array-hour_in_ms">HOUR_IN_MS</a>
 * @property {Number}   DAY_IN_MS    @see <a href="identifiers.html#array-day_in_ms">DAY_IN_MS</a>
 * @property {Number}   WEEK_IN_MS   @see <a href="identifiers.html#array-week_in_ms">WEEK_IN_MS</a>
 * @property {Number}   MONTH_IN_MS  @see <a href="identifiers.html#array-month_in_ms">MONTH_IN_MS</a>
 * @property {Number}   YEAR_IN_MS   @see <a href="identifiers.html#array-year_in_ms">YEAR_IN_MS</a>
 * @property {Function} setTime      @see <a href="identifiers.html#array-settime">setTime</a>
 * @property {Function} remoteDate   @see <a href="identifiers.html#array-remotedate">remoteDate</a>
 * @property {Function} inTimeRange  @see <a href="identifiers.html#array-intimerange">inTimeRange</a>
 */

var datetime = {
    MINUTE_IN_MS: MINUTE_IN_MS,
    HOUR_IN_MS: HOUR_IN_MS,
    DAY_IN_MS: DAY_IN_MS,
    WEEK_IN_MS: WEEK_IN_MS,
    MONTH_IN_MS: MONTH_IN_MS,
    YEAR_IN_MS: YEAR_IN_MS,
    howLongAgo: howLongAgo,
    inTimeRange: inTimeRange,
    remoteDate: remoteDate,
    setTime: setTime,
    formatDate: formatDate
};


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/glob/index.mjs
var glob__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module glob
 * @since 2.0.0
 * @description exposes the global object (self | global | window)
 *
 * @example import {glob} from @fiverr/futile
 * if ('fetch' in glob) { ... }
 */
var glob = (typeof window === 'undefined' ? 'undefined' : glob__typeof(window)) === 'object' && window.window === window && window || (typeof GLOBAL === 'undefined' ? 'undefined' : glob__typeof(GLOBAL)) === 'object' && GLOBAL.GLOBAL === GLOBAL && GLOBAL || (typeof self === 'undefined' ? 'undefined' : glob__typeof(self)) === 'object' && self.self === self && self;
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/resolve/index.mjs
var resolve__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module resolve
 * @since 1.0.0
 */



/**
 * Resolve dot notation string.
 *
 * @param  {String} string    Dot notation representation
 * @param  {Object} [context] Object to start notation search (defaults to global scope)
 * @return {Any}    Whatever it finds / undefined
 *
 * @example
 * const data_object = {
 *   top_level: {
 *     nested: {
 *       value: 'My Value'
 *     }
 *   }
 * };
 *
 * resolve('top_level.nested.value', data_object);
 * // 'My Value'
 *
 * resolve('top_level.missing.value', data_object);
 * // undefined
 */
var resolve_resolve = function resolve() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : glob;
  return string.split('.').reduce(function (previous, current) {
    return (typeof previous === 'undefined' ? 'undefined' : resolve__typeof(previous)) === 'object' ? previous[current] : previous;
  }, context);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/mixin/memoizer/index.mjs
var memoizer__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module memoizer
 * @private
 * @since 2.0.0
 */

/**
 * @typedef ObjectProperty
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
 * @type     {Object}
 * @property {boolean}  [configurable=true]
 * @property {boolean}  [enumerable=true]
 * @property {boolean}  [writable=true]
 * @property {any}      [value=undefined]
 * @property {function} [get=undefined]
 * @property {function} [set=undefined]
 */

/**
 * OBJECT_PROPERTY_ATTRIBUTES attributes of an ObjectProperty
 * @type {Array}
 */
var OBJECT_PROPERTY_ATTRIBUTES = ['get', 'value', 'set', 'configurable', 'enumerable', 'writable'];

/**
 * Attributes to convert to memoised attributes
 * @type {Array}
 */
var SHOULD_MEMOISE = ['get', 'value'];

/**
 * gain optional memoisation for their respective functions and getter via static "memoised" getter
 * Call on seld
 * @param  {Object}   instance
 * @param  {String[]} props    Properties to wrap in memoizers
 * @return {Object}
 *
 * @example
 * class Klass {
 *   constructor(initial_value = 'nothing') {
 *      this.variable = initial_value;
 *      memoise(this, 'a_getter', 'a_function');
 *   }
 *
 *   // I will be memoised
 *   get a_getter() {
 *     return this.variable;
 *   }
 *
 *   // I will not be memoised
 *   get a_dynamic_getter() {
 *     return this.variable;
 *   }
 *
 *   // I will be memoised
 *   a_function() {
 *     return `The value is ${this.variable}`;
 *   }
 * }
 */
function memoizer(instance) {

    /**
     * Private memory store
     * @type {Object}
     */
    var memory = {};

    /**
     * memoize values of operations by key
     * @private
     * @param  {String}   item     Key of item to memoize
     * @param  {Function} retreive Operation to calculate the value
     * @return {Any}
     */
    function memoize(item, retreive) {
        return memory[item] = memory.hasOwnProperty(item) ? memory[item] : retreive();
    }

    for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
    }

    props.forEach(function (property) {
        return assignDescriptorProperties.call(instance, property, memoize);
    });
}

/**
 * Assigns new descriptor properties. Getter and Values will be wrapped in a memoize method
 * @param  {String}   property Property name
 * @param  {Function} memoize  How to memoize the result
 * no return value
 */
function assignDescriptorProperties(property, memoize) {
    var _this = this;

    var descriptor = Object.getOwnPropertyDescriptor(this.constructor.prototype, property);

    var attributes = OBJECT_PROPERTY_ATTRIBUTES.reduce(function (attributes, attribute) {
        switch (memoizer__typeof(descriptor[attribute])) {
            case 'undefined':

                // do nothing
                break;
            case 'function':
                if (SHOULD_MEMOISE.includes(attribute)) {
                    attributes[attribute] = function () {
                        return memoize(property + '$' + attribute, descriptor[attribute].bind(_this));
                    };
                } else {
                    attributes[attribute] = descriptor[attribute];
                }
                break;
            default:
                attributes[attribute] = descriptor[attribute];
                break;
        }

        return attributes;
    }, {});

    Object.defineProperty(this, property, attributes);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/env/__isBrowserLike/index.mjs
/**
 * @module isBrowserLike
 * @requires glob
 * @private
 * @since 2.3.1
 */



/**
 * Test whether the current environment is a browser-like environment or not.
 * @return {Boolean}
 */
var __isBrowserLike_isBrowserLike = function isBrowserLike() {
  return glob.document && typeof glob.document.createElement === 'function';
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/env/index.mjs
var env__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var env__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function env__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module env
 * @since 2.0.0
 * @requires glob
 * @requires resolve
 * @requires memoizer
 */






/**
 * @class Env
 * @augments Memoiser
 * @classdesc Figure out details regarding the runtime environment. Bridges server and browser
 * @property {Boolean} node        Is this environment a nodejs environment?
 * @property {Boolean} browser     Is this environment a browser or a browser-like environment?
 * @property {Boolean} development Is this environment defined as a development environment @alias dev
 * @property {Boolean} production  Is this environment defined as a testing environment @alias prod
 * @property {Boolean} testing     Is this environment defined as a testing environment @alias test
 * @property {Boolean} plike       Is this environment defined as a plike environment (production like)
 *
 * @example
 * window.app = {environment: 'production'};
 * env.prod // true
 *
 * export NODE_ENV=production; npm start
 * env.prod // true
 */

var env_Env = function () {
    function Env() {
        env__classCallCheck(this, Env);

        // getters and functions that should be memoised
        memoizer(this, 'node', 'browser', 'development', 'production', 'testing', 'plike', 'toString');
    }

    env__createClass(Env, [{
        key: 'toString',


        /**
         * @return {String} Value of environment set where applicable
         */
        value: function toString() {
            var env = this.browser ? resolve_resolve('app.environment') : resolve_resolve('process.env.NODE_ENV');

            return (env || '').toLowerCase();
        }
    }, {
        key: 'node',
        get: function get() {
            return Object.prototype.toString.call(typeof glob.process !== 'undefined' ? glob.process : 0) === '[object process]';
        }
    }, {
        key: 'browser',
        get: function get() {
            return __isBrowserLike_isBrowserLike() || !this.node && [typeof document === 'undefined' ? 'undefined' : env__typeof(document), typeof window === 'undefined' ? 'undefined' : env__typeof(window)].every(function (item) {
                return item !== 'undefined';
            });
        }
    }, {
        key: 'development',
        get: function get() {
            return this.toString().includes('dev');
        }
    }, {
        key: 'dev',
        get: function get() {
            return this.development;
        }
    }, {
        key: 'production',
        get: function get() {
            return this.toString().includes('prod');
        }
    }, {
        key: 'prod',
        get: function get() {
            return this.production;
        }
    }, {
        key: 'testing',
        get: function get() {
            return this.toString().includes('test');
        }
    }, {
        key: 'test',
        get: function get() {
            return this.testing;
        }
    }, {
        key: 'plike',
        get: function get() {
            return this.toString().includes('like');
        }
    }]);

    return Env;
}();

var env_env = new env_Env();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/emerge/index.mjs
/**
 * @module emerge
 * @since 2.0.0
 */



/**
 * Triggers a callback when an element "emerges", i.e. becomes visible on it's own or by inheritance
 * @param  {HTMLElement} element
 * @return {Promise} Promise resolves with given HTML element as an argument
 *
 * @example
 * emerge(document.querySelector('.my-content'))
 *   .then(() => { console.log('My content is visible'); })
 *   .catch((error) => { throw error; });
 */
var emerge_emerge = function emerge(element) {
    return new Promise(function (resolve, reject) {
        if (!env_env.browser) {
            reject('emerge can not be triggered from a non browser environment');
        }

        var hiddenContainer = getTraversedHidden(element);

        if (hiddenContainer === null) {
            resolve(element);
            return;
        }

        if (typeof MutationObserver === 'undefined') {
            // Unsupported. Pretend like you've emerged

            resolve(element);
            return;
        }

        var observer = new MutationObserver(function () {
            if (getTraversedHidden(element) === null) {
                resolve(element);
                observer.disconnect();
            }
        });

        observer.observe(hiddenContainer, { attributes: true });
    });
};

/**
 * Retrieve the first element which is set to display:none. Returns null when none are found
 * @private
 * @param  {HTMLElement} element
 * @return {HTMLElement|null}
 */
function getTraversedHidden(element) {
    var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;

    if (width !== 0 || height !== 0) {
        return null;
    }

    while (element) {
        if (element === document.body) {

            // Break the loop two iterations early
            return null;
        }

        if (window.getComputedStyle(element).display === 'none') {

            // Break iteration with retrieve "hidden" element
            return element;
        }

        element = element.parentElement;
    }

    return element;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/exposed/__rect/index.mjs
/**
 * @module rect
 * @private
 * @since 2.0.0
 */

/**
 * @typedef RectObject
 * @type     {Object}
 * @property {number} left   Y of left end
 * @property {number} top    X of top end
 * @property {number} right  Y of right end
 * @property {number} bottom X of bottom end
 * @property {number} width
 * @property {number} height
 */

/**
 * Get size object for relevant DOM element
 * @param  {DOMElement|Window|Document} element
 * @return {RectObject}
 */
function rect(element) {
    if (element instanceof Window || element instanceof HTMLDocument) {
        return {
            left: 0,
            top: 0,
            right: window.innerWidth,
            bottom: window.innerHeight,
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    var _element$getBoundingC = element.getBoundingClientRect(),
        left = _element$getBoundingC.left,
        top = _element$getBoundingC.top,
        right = _element$getBoundingC.right,
        bottom = _element$getBoundingC.bottom,
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;

    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        width: width,
        height: height
    };
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/exposed/index.mjs
var exposed__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * @module exposed
 * @since 1.7.0
 * @requires exposed/rect
 */



/**
 * Subtract first number from second
 * @private
 * @param  {number} a
 * @param  {number} b
 * @return {number}
 */
var sub = function sub(a, b) {
  return a - b;
};

/**
 * Subtract second number from first
 * @private
 * @param  {number} a
 * @param  {number} b
 * @return {number}
 */
var revSub = function revSub(a, b) {
  return b - a;
};

/**
 * @typedef  ExposedOptions
 * @type     {Object}
 * @property {DOMElement|Window} [container=window]
 * @property {number}            [percent=50]
 */

/**
 * Is element inside container. For the result to be true, the element must be exposed by the given percent (50% by default) on both axis X and Y.
 * @param  {DOMElement}     element
 * @param  {ExposedOptions} [options] <a href="#~ExposedOptions">ExposedOptions</a>
 * @return {boolean}
 *
 * @example
 * const container = document.querySelector('.my-slideshow-wrapper');
 * const element = container.querySelector('.slide');
 * exposed(
 *   element,
 *   {
 *       container,
 *       percent: 75
 *   }
 * );
 */
function exposed(element) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$container = _ref.container,
      container = _ref$container === undefined ? window : _ref$container,
      _ref$percent = _ref.percent,
      percent = _ref$percent === undefined ? 50 : _ref$percent;

  var inner = rect(element);
  var outer = rect(container);
  var fraction = percent / 100; // fraction of surface we want exposed

  /**
   * @typedef  SufficiantlyExposedArguments
   * @type     {Array}
   * @property {string}   0 [prop] - Property we're going to measure
   * @property {string}   1 [measurement] - Element's axis
   * @property {function} 2 [calculator] - Function for calculating the diff
   */

  /**
   * Element is sufficiently exposed (on 1 axis)
   * @param  {SufficiantlyExposedArguments} [argument] <a href="#~SufficiantlyExposedArguments">SufficiantlyExposedArguments</a>
   * @return {boolean}
   */
  var sufficiantlyExposed = function sufficiantlyExposed(_ref2) {
    var _ref3 = exposed__slicedToArray(_ref2, 3),
        prop = _ref3[0],
        measurement = _ref3[1],
        calculator = _ref3[2];

    return calculator(inner[prop], outer[prop]) + inner[measurement] >= inner[measurement] * fraction;
  };

  if (['width', 'height'].some(function (prop) {
    return inner[prop] === 0;
  })) {
    return false;
  }

  // Checks are performed ordered by likelihood of failure (most to least)
  //   considering some checks stop after one success
  return [['top', 'height', sub], ['left', 'width', sub], ['right', 'width', revSub], ['bottom', 'height', revSub]].every(sufficiantlyExposed);
}
// EXTERNAL MODULE: external {"commonjs":"lodash","commonjs2":"lodash","amd":"lodash","root":"_","var":"_"}
var external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var______ = __webpack_require__("PbPb");
var external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default = /*#__PURE__*/__webpack_require__.n(external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var______);

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/__alias/index.mjs
var __alias__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module alias
 * @private
 * @since 2.0.0
 */

/**
 * Check if a function exist on the global Fiverr object
 * @param  {String} name The function name
 * @return {Boolean}
 */
var available = function available(name) {
  return (typeof Fiverr === 'undefined' ? 'undefined' : __alias__typeof(Fiverr)) === 'object' && typeof Fiverr[name] === 'function' ? true : undefined;
};

/**
 * Creates a "safe" alias for a Fiverr function
 * @param  {string} name Function name
 * @return {Function}
 */
var alias = function alias(name) {
  return function () {
    var _Fiverr;

    return available(name) && (_Fiverr = Fiverr)[name].apply(_Fiverr, arguments);
  };
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/sendEvents/index.mjs
/**
 * @module sendEvents
 * @alias Fiverr.sendClientEvents
 * @since 2.0.0
 */



/**
 * Report BI events to server. Aliases Fiverr.sendClientEvents
 * @param  {...Object[]} event TBC
 * no return value
 *
 * @example
 * Fiverr.sendEvents(
 *   {...},
 *   {...},
 *   {...}
 * )
 */
var sendEvents = alias('sendClientEvents');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/sendGraph/index.mjs
/**
 * @module sendGraph
 * @alias Fiverr._logEventToGraphite
 * @since 2.0.0
 */



/**
 * @typedef   MonitoringObject
 * @type      {Object}
 * @property  {String} options.label            Key of the table
 * @property  {Number} [options.timing]         Value for timers in milliseconds
 * @property  {Number} [options.value]          Value for counters
 * @property  {Number} [options.percentage=5]   Percentage of events to actually send
 * @property  {Number} [options.ttl=300]        Time to delay between reports (milliseconds)
 */

/**
 * Report statistical data. Aliases Fiverr._logEventToGraphite
 * @param {MonitoringObject} options Data for the report
 * no return value
 *
 * @example
 * sendGraph({
 *   label: 'fe_events.flow_name.interaction',
 *   percentage: 100,
 * })
 *
 * sendGraph({
 *   label: 'fe_events.flow_name.process',
 *   timing: 2000,
 *   percentage: 100,
 * })
 */
var sendGraph = alias('_logEventToGraphite');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/__Storage/index.mjs
var __Storage__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function __Storage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module Storage
 * @private
 * @since 2.0.0
 * @requires memoizer
 * @requires env
 */




/**
 * Common interface for localStorage and sessionStorage
 */
var __Storage_Storage = function () {
    function Storage(key) {
        var _this = this;

        __Storage__classCallCheck(this, Storage);

        memoizer(this, 'available');

        this.storage = env_env.browser && window[key];

        ['get', 'set'].forEach(function (fn) {
            return _this[fn] = _this[fn].bind(_this);
        });
    }

    /**
     * available Is localStorage available
     * @type {Boolean}
     */


    __Storage__createClass(Storage, [{
        key: 'get',


        /**
         * S.get
         * @param  {String} key           Key name
         * @return {Any} Value. If value can be parsed as JSON it'll be parsed as JSON
         */
        value: function get(key) {
            if (!this.available) {
                return;
            }

            var value = this.storage.getItem(key);

            try {
                return JSON.parse(value);
            } catch (error) {
                return value;
            }
        }

        /**
         * S.set
         * @param  {String} key   Key name
         * @param  {Any}    value Value to store
         * @return {Promise}
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            var _this2 = this;

            if (!this.available) {
                return new Promise(function (resolve) {
                    return resolve;
                });
            }

            return new Promise(function (resolve, reject) {
                try {
                    _this2.storage.setItem(key, JSON.stringify(value));
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        }

        /**
         * S.remove
         * @param {String} key Key name
         * no return value
         */

    }, {
        key: 'remove',
        value: function remove(key) {
            this.available && this.storage.removeItem(key);
        }

        /**
         * S.size
         * @param  {...String} [keys] When omitted calculates all
         * @return {Object}           map of sizes. Includes "total"
         */

    }, {
        key: 'size',
        value: function size() {
            var _this3 = this;

            for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
                keys[_key] = arguments[_key];
            }

            var all = !keys.length;
            var total = 0;
            all && (keys = Array.from(Array(this.storage.length)).map(function (item, index) {
                return _this3.storage.key(index);
            }));

            var result = keys.reduce(function (result, key) {
                var length = (key + _this3.storage.getItem(key)).length;

                result[key] = length;
                all && (total += length);

                return result;
            }, {});

            all && Object.assign(result, { total: total });

            return result;
        }
    }, {
        key: 'available',
        get: function get() {
            if (!env_env.browser) {
                return false;
            }

            var key = Math.random().toString(36).substring(2);

            try {
                this.storage.setItem(key, true);
                this.storage.removeItem(key);
                return true;
            } catch (error) {
                return false;
            }
        }
    }]);

    return Storage;
}();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/localStorage/index.mjs


var localStorage = new __Storage_Storage('localStorage');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/sessionStorage/index.mjs


var sessionStorage = new __Storage_Storage('sessionStorage');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/storage/index.mjs
/**
 * @namespace storage
 * @since 2.0.0
 */




/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} localStorage  @see <a href="identifiers.html#storage-localstorage">localStorage</a>
 * @property {Function} sessionStorage  @see <a href="identifiers.html#storage-sessionstorage">sessionStorage</a>
 */
var storage = {
  localStorage: localStorage,
  sessionStorage: sessionStorage
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/jsonCopy/index.mjs
/**
 * @module jsonCopy
 * @since 2.0.0
 */

/**
 * Copies using JSON functionalities. Very performant, not a comprehensive copyier
 * @param   {Any} data
 * @returns {Any} Deep copy
 */
function jsonCopy(data) {
    try {
        return JSON.parse(JSON.stringify(data));
    } catch (error) {
        throw new SyntaxError("Data was expected to be valid for JSON. Got error: " + error);
    }
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/Impressionable/__CONSTANTS/index.mjs
/**
 * @module impressionable/__CONSTANTS
 * @private
 * @since 2.0.0
 */

/**
 * Throttle events like scroll and resize between DOM querying
 * @type {Number}
 */
var COLLECT_DELAY = 200;

/**
 * custom event that triggers impression collecting
 * @type {String}
 */
var CUSTOM_EVENT = 'collect-impressions';

/**
 * Throttle event report dispatches
 * @type {Number}
 */
var DISPATCH_DELAY = 500;

/**
 * @typedef LISTENER_OPTIONS @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @type {Object}
 * @property {Boolean} capture Dispatch to listener before child event targets
 * @property {Boolean} once    Listener should be removed once invoked
 * @property {Boolean} passive Listener can not call preventDefault()
 */

/**
 * LISTENER_OPTIONS
 * @type {LISTENER_OPTIONS}
 */
var LISTENER_OPTIONS = {
  capture: false,
  once: false,
  passive: false
};

/**
 * Impressionable's storage key
 * @type {String}
 */
var STORAGE_KEY = 'impressionable_events';

/**
 * DOM attribute for "impressed" elements
 * @type {String}
 */
var VIEWED_ATTRIBUTE = 'data-impression-collected';

/**
 * Window events we want to listen to
 * @private
 * @type {String[]}
 */
var WINDOW_LISTENERS = ['load', 'resize', 'scroll', 'touchmove'];
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/Impressionable/__dispatch/index.mjs
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @module dispatch
 * @private
 * @since 2.0.0
 */






/**
 * Empty events from localStorage and send them
 * no return value
 */
function dispatch() {
    var events = localStorage.get(STORAGE_KEY);

    if (!events) {
        return;
    }

    sendEvents.apply(undefined, _toConsumableArray(events));
    localStorage.set(STORAGE_KEY, []);
}

try {

    /**
     * Throttled run of dispatch
     * @type {Fucntion}
     */
    dispatch.throttled = external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.throttle(dispatch, DISPATCH_DELAY, { leading: false });

    // Report any pre stored events on load

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', dispatch, { once: true });
    } else {
        // interactive, complete
        dispatch();
    }

    window.addEventListener('beforeunload', dispatch, { once: true });
} catch (error) {

    // Fail silently ()probably non browser environment
}


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/Impressionable/index.mjs
var Impressionable__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Impressionable__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Impressionable__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Impressionable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module Impressionable
 * @since 2.0.0
 */












/**
 * @typedef ImpressionableOptions
 * @type {Object}
 * @property {Object[]}     [data=[]]                         Array of BI data objects. Each must have an identifier
 * @property {HTMLElement}  [container=window]                Container of the carousel
 * @property {String}       [DOMSelector=`[${DOMAttribute}]`] QuerySelector of the children
 * @property {String}       [DOMAttribute='id']               DOM attribute holding the item's identifier
 * @property {String}       [dataIdentifier='id']             Data member holding the item's identifier
 * @property {String}       [dataProperty]                      Data member representing the impression event
 * @property {EnrichLambda} [enrich]
 */

/**
 * A lambda expression width privileged access to the event data item. Is meant to mutate it (usually add properties)
 * @callback EnrichLambda
 * @param    {Object}                 data    The event data item (Mutable), enriched items: $index
 * @param    {HTMLElement}            [child] The element corresponding to the DOMSelector-DOMAttribute-dataIdentifier combination.
 * @returns  {Object|undefined|false}         Optionally: return a new event object. Returning false will prevent the send of the impression
 *
 * @example
 * // Add a new item to the event
 * new Impressionable({
 *   enrich: (event) => { event.source_url = window.location.href; }
 * })
 *
 * // Replace event
 * new Impressionable({
 *   enrich: (event, element) => Object.assign(
 *     {},
 *     event,
 *     {
 *       type: 'some_other_type',
 *       position: event.$index + 1,
 *       url: window.location.href,
 *       offsetTop: element.offsetTop,
 *     }
 *   )
 * })
 */

/**
 * Options defaults
 * @type {ImpressionableOptions}
 */
var defaults = {
    data: [],
    container: typeof window !== 'undefined' ? window : null,
    DOMAttribute: 'id',
    dataIdentifier: 'id'
};

/**
 * @class Impressionable
 * @classdesc an impression tracker. Using a container, a data collection and a child selector, the wrapper
 * @param  {ImpressionableOptions}   options
 * @property {ImpressionableOptions} options
 * @property {Array}                 impressed   Array representation of NodeList
 * @property {Array}                 unimpressed Array representation of NodeList
 * @property {Boolean}               retired     Whether this instance is retired or not.
 *
 * @example
 * const impressionable = new Impressionable({
 *   data: [{id: 0, name: 'a1vy', impression_data: {id: 0, group: 'event_group', type: 'event_type'}}],
 *   container: document.getElementById('my_container'),
 *   DOMSelector: '.card',
 *   DOMAttribute: 'data-impression-id',
 *   dataIdentifier: 'id',
 *   dataProperty: 'impression_data',
 *   enrich: (event, element) => Object.assign(event, {
 *     position: event.$index + 1,
 *     url: window.location.href,
 *     offsetTop: element.offsetTop,
 *   })
 * })
 *
 * // Triggering after custom scrolling
 * container.addEventListener('transitionend', () => container.dispatchEvent(new CustomEvent('collect-impressions')))
 * // - OR -
 * container.addEventListener('transitionend', impressionable.collect);
 * // - OR -
 * setTimeout(impressionable.collect, 400)
 */
var Impressionable_Impressionable = function () {
    function Impressionable() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        Impressionable__classCallCheck(this, Impressionable);

        if (!env_env.browser) {
            throw new Error('Impressionable can not be instantiated from a non browser environment');
        }

        this.options = Object.assign({}, defaults, options);

        // Other defaults
        this.options.DOMSelector = this.options.DOMSelector || '[' + this.options.DOMAttribute + ']';

        var _options = this.options,
            data = _options.data,
            container = _options.container,
            DOMSelector = _options.DOMSelector,
            dataProperty = _options.dataProperty,
            dataIdentifier = _options.dataIdentifier;


        if (!Array.isArray(data)) {
            throw new TypeError('Impressionable must receive a "data" array argument. Got ' + (typeof data === 'undefined' ? 'undefined' : Impressionable__typeof(data)));
        }

        var queryRoot = container === window ? document.body : container;
        if (!queryRoot) {
            throw new Error('Impressionable container (when passed) expects a DOM element. Got a ' + (typeof container === 'undefined' ? 'undefined' : Impressionable__typeof(container)));
        }
        var children = queryRoot.querySelectorAll(DOMSelector);

        Object.assign(this, {
            container: container,
            impressed: [],
            unimpressed: [].slice.call(children) // convert NodeList to Array
        });

        // Convert the data array to a key-value collection for faster lookup
        this.data = this.options.data.reduce(function (collector, item, $index) {
            if (item.hasOwnProperty(dataIdentifier)) {
                collector[item[dataIdentifier]] = Object.assign({ $index: $index }, // takes inferiority
                jsonCopy(dataProperty ? external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.get(item, dataProperty) : item));
            }

            return collector;
        }, {});

        this.collect = external___commonjs___lodash___commonjs2___lodash___amd___lodash___root_______var_______default.a.throttle(this.collect.bind(this), COLLECT_DELAY, { leading: false });

        this.live();
    }

    /**
     * - Collect the exposed elements' impression data
     * - Move them from "unimpressed" collection to "impressed"
     * - Mark them as "impressed"
     * no return value
     */


    Impressionable__createClass(Impressionable, [{
        key: 'collect',
        value: function collect() {
            var container = this.container;

            var fullyExposed = container === window || exposed(container, { percent: 100 });
            var events = [];

            // Reducing on a shallow copy. The reduction also mutates the array
            var index = this.unimpressed.length;

            while (index--) {
                var child = this.unimpressed[index];

                if (!exposed(child, { container: container })) {
                    continue;
                }

                // verify it's in the viewport
                if (!(fullyExposed || exposed(child))) {
                    continue;
                }

                var impressionData = this.getImpressionData(child);

                if (impressionData) {
                    events.push(impressionData);
                    child.setAttribute(VIEWED_ATTRIBUTE, 'true');
                } else {
                    child.setAttribute(VIEWED_ATTRIBUTE, 'error');
                }

                this.impress(index);
            }

            if (events.length) {
                this.storeImpressions.apply(this, events);
                dispatch.throttled();
            }

            return this;
        }

        /**
         * Move an item from "unimpressed" to "impressed" collection.
         * @param  {number} index Index in "unimpressed" collection.
         * no return value
         */

    }, {
        key: 'impress',
        value: function impress(index) {
            var _impressed;

            (_impressed = this.impressed).push.apply(_impressed, Impressionable__toConsumableArray(this.unimpressed.splice(index, 1)));
            if (!this.unimpressed.length) {
                this.retire();
            }
        }

        /**
         * Retrieve the data item with `id` matching the impression DOMAttribute
         * @param  {HTMLElement} child
         * @return {Object}
         */

    }, {
        key: 'getImpressionData',
        value: function getImpressionData(child) {
            var member = child.getAttribute(this.options.DOMAttribute);
            var data = this.data[member];

            // Enrich data if enrichment method was supplied
            if (typeof this.options.enrich === 'function') {
                var enriched = this.options.enrich(data, child);

                // If enrichment method returns an object, use it
                if ((typeof enriched === 'undefined' ? 'undefined' : Impressionable__typeof(enriched)) === 'object' || enriched === false) {
                    data = enriched;
                }
            }

            return data;
        }

        /**
         * Store impressions in storage (report immediately if unavailable)
         * @param  {...Object} events
         * no return value
         */

    }, {
        key: 'storeImpressions',
        value: function storeImpressions() {
            for (var _len = arguments.length, events = Array(_len), _key = 0; _key < _len; _key++) {
                events[_key] = arguments[_key];
            }

            if (!localStorage.available) {
                sendEvents.apply(undefined, events);

                return;
            }

            this.stored = events;
        }
    }, {
        key: 'live',


        /**
         * Attach throttled listeners to container and window events
         * no return value
         */
        value: function live() {
            var _this = this;

            this.containerEvents.forEach(function (event) {
                return _this.container.addEventListener(event, _this.collect, LISTENER_OPTIONS);
            });

            WINDOW_LISTENERS.forEach(function (event) {
                return window.addEventListener(event, _this.collect, LISTENER_OPTIONS);
            });

            emerge_emerge(this.container).then(this.collect).catch(function (error) {
                throw error;
            });
        }

        /**
         * Detach listeners from container and window events
         * no return value
         */

    }, {
        key: 'die',
        value: function die() {
            var _this2 = this;

            this.containerEvents.forEach(function (event) {
                return _this2.container.removeEventListener(event, _this2.collect, LISTENER_OPTIONS);
            });

            WINDOW_LISTENERS.forEach(function (event) {
                return window.removeEventListener(event, _this2.collect, LISTENER_OPTIONS);
            });
        }

        /**
         * Retires the instance, detaching all event listeneres, and clears out redundant references and properties.
         * no return value
         */

    }, {
        key: 'retire',
        value: function retire() {
            this.retired || Object.assign(this, {
                impressed: [],
                unimpressed: [],
                data: {},
                options: {},
                retired: true
            }).die();
        }
    }, {
        key: 'stored',
        get: function get() {
            return localStorage.get(STORAGE_KEY) || [];
        },
        set: function set(events) {
            var stored = this.stored;

            stored.push.apply(stored, Impressionable__toConsumableArray(events));
            localStorage.set(STORAGE_KEY, stored).catch(function () {
                sendEvents.apply(undefined, Impressionable__toConsumableArray(stored));
                localStorage.remove(STORAGE_KEY);
                sendGraph({
                    label: 'fe_events.error.impressionable.localstorage',
                    timing: localStorage.size(STORAGE_KEY)[STORAGE_KEY],
                    percentage: 100
                });
            });
        }

        /**
         * Expose the custom event name
         * @type string
         */

    }, {
        key: 'containerEvents',


        /**
         * A list of event to listen to on the container
         * @return {Array}
         */
        get: function get() {
            var events = [CUSTOM_EVENT];

            this.container !== window && events.push('scroll', 'touchmove');
            return events;
        }
    }], [{
        key: 'CUSTOM_EVENT',
        get: function get() {
            return CUSTOM_EVENT;
        }
    }]);

    return Impressionable;
}();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/element/index.mjs
/**
 * @namespace element
 * @since 2.0.0
 */





/**
 * array A collection of array related methods
 * @type     {Object}
 * @property {Class} emerge   @see <a href="identifiers.html#element-emerge">emerge</a>
 * @property {Class} exposed   @see <a href="identifiers.html#element-exposed">exposed</a>
 * @property {Class} Impressionable   @see <a href="identifiers.html#element-impressionable">Impressionable</a>
 */
var element_element = {
  emerge: emerge_emerge,
  exposed: exposed,
  Impressionable: Impressionable_Impressionable
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/event/multiEventListener/index.mjs
/**
 * @module multiEventListener
 * @since 2.0.0
 */

/**
 * Listens to multiple events, and executes a given function when said events are fired.
 * @param {String|String[]}    [events = []]   A list of events to listen to. Can be either an array or a string separated by spaces (a la jQuery).
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget.
 *
 * @param {Function} [callback = () => null]   The function to execute once a certain event fires.
 * @param {Object}   [options]                 An object of extra non-mandatory options.
 * @param {Boolean}  [options.once=false]      Should the callback fire once or not.
 * @param {Element}  [options.element=window}] The element to add the event listeners to.
 *
 * @example
 *
 * multiEventListener(['scroll', 'resize'], () => {console.log('Yo!')});
 *
 * @example
 *
 * multiEventListener(['scroll', 'resize'], () => {console.log('Yo!')}, { once: true });
 */
function multiEventListener() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$once = _ref.once,
      once = _ref$once === undefined ? false : _ref$once,
      _ref$element = _ref.element,
      element = _ref$element === undefined ? window : _ref$element;

  function execute() {
    callback() !== false && once && events.forEach(function (event) {
      return element.removeEventListener(event, execute);
    });
  }

  events = typeof events === 'string' ? events.split(' ') : events;

  events.forEach(function (event) {
    return element.addEventListener(event, execute);
  });
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/event/index.mjs
/**
 * @namespace event
 * @since 2.0.0
 */



/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} multiEventListener  @see <a href="identifiers.html#event-multieventlistener">multiEventListener</a>
 */
var event_event = {
  multiEventListener: multiEventListener
};

// EXTERNAL MODULE: external {"commonjs":"@fiverr/gofor","commonjs2":"@fiverr/gofor","amd":"@fiverr/gofor","root":"goforFactory","var":"goforFactory"}
var gofor___root___goforFactory___var___goforFactory__ = __webpack_require__("jPm4");
var gofor___root___goforFactory___var___goforFactory___default = /*#__PURE__*/__webpack_require__.n(gofor___root___goforFactory___var___goforFactory__);

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/gofor/index.mjs
/**
 * @exports gofor
 * @since 1.1.0
 */



/**
 * Get the default options for Fiverr's fetch requests
 * @private
 * @return {Object} default request params:
 *
 * @member {Object<String>} credentials Cross origin credentials
 * @member {Object<Object>} headers Headers:
 *   @member {String} 'X-CSRF-Token'     One time query, one place with the logic
 *   @member {String} 'X-Requested-With' Identify as XHR (this helps our server differentiate the requests from full page requests and take decisions based upon that knowledge)
 *   @member {String} 'Content-Type'     Declare content type JSON as default
 *   @member {String} 'Accept'           Requests JSON by default
 */
var getDefaults = function getDefaults() {
    var headers = defaultHeaders();

    var defaults = {
        credentials: 'same-origin',
        headers: headers
    };

    return defaults;
};

/**
 * Create the default Headers object
 * @return {Headers}
 */
function defaultHeaders() {
    var headers = new Headers();

    headers.append('X-Requested-With', 'XMLHttpRequest');
    headers.append('Content-Type', 'application/json; charset=utf-8');
    headers.append('Accept', 'application/json');

    try {
        headers.append('X-CSRF-Token', document.AUTH_TOKEN);
    } catch (e) {
        // Fail silently
    }

    return headers;
}

var gofor = gofor___root___goforFactory___var___goforFactory___default()(getDefaults);
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/mixin/index.mjs
/**
 * @namespace mixin
 * @since 2.0.0
 */



/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} memoizer  @see <a href="identifiers.html#mixin-memoizer">memoizer</a>
 */
var mixin = {
  memoizer: memoizer
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/number/commaSeparateNumber/index.mjs
/**
 * @exports commaSeparateNumber
 * @since 2.0.0
 */

/**
 * Convert a number to a string representation with commas separating thousands
 * @param  {Number|String} num The number want converted
 * @return {String} representing a number with commas separating thousands
 */
var commaSeparateNumber = function commaSeparateNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/number/index.mjs
/**
 * @namespace number
 * @since 2.0.0
 */



/**
 * number A collection of number related methods
 * @type     {Object}
 * @property {Function} commaSeparateNumber  @see <a href="identifiers.html#number-commaseparatenumber">commaSeparateNumber</a>
 */
var number = {
  commaSeparateNumber: commaSeparateNumber
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/object/deepAssign/index.mjs
var deepAssign__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module deepAssign
 * @since 1.7.0
 */

/**
 * Checks this object is an assignable object
 * @private
 * @param  {Object} target
 * @return {Boolean} is this object "assignable"
 */
var assignable = function assignable(target) {
  return isObject(target) && ![undefined, null].includes(target);
};

/**
 * Checks a target is an object, excludes null
 * @private
 * @param  {Any} target [description]
 * @return {Boolean} Is the target an object
 */
var isObject = function isObject(target) {
  return ['object', 'function'].includes(typeof target === 'undefined' ? 'undefined' : deepAssign__typeof(target)) && target !== null;
};

/**
 * Delegate to assign keys and symbols
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object from which to assign respective values
 * @return {Object} Original to, assigned
 */
function deepAssign_assign(to, from) {
  if (Array.isArray(to) && Array.isArray(from)) {
    assignArray(to, from);
    return to;
  }

  to = Object(to);
  from = Object(from);

  assignKeys(to, from);
  assignSymbols(to, from);

  return to;
}

/**
 * Assign second object keys to first
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object from which to assign respective values
 * no return value
 */
var assignKeys = function assignKeys(to, from) {
  return Object.keys(from).forEach(function (key) {
    return assignKey(to, from, key);
  });
};

/**
 * Assign second object symbols to first
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object from which to assign respective values
 * no return value
 */
var assignSymbols = function assignSymbols(to, from) {
  return getOwnPropertySymbols(from).forEach(function (symbol) {
    return assignKey(to, from, symbol);
  });
};

/**
 * Assign members of second array to first
 * @private
 * @param  {Array} to    Target array to assign to
 * @param  {Array} from  The array from which to assign respective values
 * no return value
 */
var assignArray = function assignArray(to, from) {
  return from.forEach(function (item, index) {
    return assignable(to[index]) && assignable(item) ? deepAssign_assign(to[index], item) : to.push(item);
  });
};

/**
 * Perform getOwnPropertySymbols when available
 * @private
 * @param  {Object} object
 * @return {Array} List of symbol keys (falls back to an empty array)
 */
var getOwnPropertySymbols = function getOwnPropertySymbols(object) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : [];
};

/**
 * assign one key from one object to the target
 * @private
 * @param  {Object} to   Target object to assign to
 * @param  {Object} from The object to assign value
 * @param  {String|Symbol} key
 * no return value
 */
function assignKey(to, from, key) {
  var easyAssign = !to.hasOwnProperty(key) || !assignable(from[key]);

  to[key] = easyAssign ? from[key] : deepAssign_assign(clone(to[key]), from[key]);
}

/**
 * Create a shallow clone of a given Object or Array
 * @private
 * @param  {Object|Array} instance Object or Array to clone
 * @return {Object|Array} (respectively) a shallow clone
 */
var clone = function clone(instance) {
  return Array.isArray(instance) ? instance.slice(0) : Object.assign({}, instance);
};

/**
 * Deep object assignment
 * @param  {Object}    target Target object to assign to
 * @param  {...Object} others The objects from which to deep assign respective values
 * @return {Object} Original target, assigned
 *
 * @example deepassign({hash: {a: 1}}, {hash: {b: 2, c: 0}}, {hash: {c: 3}}) // {hash: {a: 1, b:2, c: 3}}
 */
function deepAssign(target) {
  for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }

  assignable(target) && others.forEach(function (other) {
    return deepAssign_assign(target, other);
  });

  return target;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/object/select/index.mjs
/**
 * @module select
 * @since 1.3.0
 */

/**
 * Return an object's shallow copy filtering members based by a function
 *
 * @param  {Object} original key value pair
 * @param  {Function} condition function accepting key, value as parameters and returning a boolean
 * @return {Object} key value pair
 *
 * @example select({a:1, b:2, c:3, d:4}, (key, val) => val > 2);
 * // {c:3, d:4}
 */
function select_select(original) {
    var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return false;
    };

    var result = {};

    for (var key in original) {
        if (condition(key, original[key])) {
            result[key] = original[key];
        }
    }

    return result;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/object/index.mjs
/**
 * @namespace object
 * @since 2.0.0
 */




/**
 * object A collection of object related methods
 * @type     {Object}
 * @property {Function} deepAssign  @see <a href="identifiers.html#object-deepassign">deepAssign</a>
 * @property {Function} select  @see <a href="identifiers.html#object-select">select</a>
 */
var object = {
  deepAssign: deepAssign,
  select: select_select
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/random/uid/index.mjs
/**
 * @module uid
 * @since 2.1.0
 */

/**
 * Generate a pseudorandom namespaced id
 *
 * @param  {String}  namespace Optional namespace for ID
 * @return {String}  pseudorandom id derived from timestamp
 *
 * @example uid('Fiverr');
 * // Fiverr_9807528710537
 */

function uid() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var generatedString = ('' + Math.random()).slice(-8) + ('' + Date.now()).slice(8);
  var prefix = namespace ? namespace + '_' : '';
  return '' + prefix + generatedString;
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/random/index.mjs
/**
 * @namespace random
 * @since 2.1.0
 */



/**
 * A collection of randomizer functions
 * @type     {Object}
 * @property {Function} uid  Generates a pseudorandom namespaced uid
 */

var random = {
  uid: uid
};


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/regexp/stripOperators/index.mjs
/**
 * @module stripOperators
 * @since 1.6.0
 */

/**
 * Regex operators match
 * @private
 * @type {RegExp}
 */
var OPERATORS_MATCH = /[|\\{}()[\]^$+*?.]/g;

/**
 * return a string with stripped operators
 * @param  {String} string
 * @param  {String} [replacement='']
 * @return {String} a string safe for RegExp
 *
 * @example stripOperators('weird things)') // => 'weird things'
 */
var stripOperators = function stripOperators() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return string.replace(OPERATORS_MATCH, replacement);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/regexp/StrippedRegExp/index.mjs
function StrippedRegExp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StrippedRegExp__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StrippedRegExp__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @module StrippedRegExp
 * @since 1.5.0
 */



/**
 * @class StrippedRegExp
 * @extends RegExp
 * @classdesc Create a RegExp from string ignoring operators
 *
 * @example new StrippedRegExp('weird stuff)', 'g')
 */
var StrippedRegExp_StrippedRegExp = function (_RegExp) {
  StrippedRegExp__inherits(StrippedRegExp, _RegExp);

  /**
   * constructor
   * @param {String|RegExp} pattern
   * @param {String} [flags]
   * @returns {RegExp} a regex object ignoring operators
   */
  function StrippedRegExp() {
    var _ref;

    StrippedRegExp__classCallCheck(this, StrippedRegExp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') {
      args[0] = stripOperators(args[0]);
    }

    return StrippedRegExp__possibleConstructorReturn(this, (_ref = StrippedRegExp.__proto__ || Object.getPrototypeOf(StrippedRegExp)).call.apply(_ref, [this].concat(args)));
  }

  return StrippedRegExp;
}(RegExp);
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/regexp/index.mjs
/**
 * @namespace regexp
 * @since 2.0.0
 */




/**
 * regexp A collection of regexp related methods
 * @type     {Object}
 * @property {Function} stripOperators @see <a href="identifiers.html#regexp-stripoperators">stripOperators</a>
 * @property {Class}    StrippedRegExp @see <a href="identifiers.html#regexp-strippedregexp">StrippedRegExp</a>
 */
var regexp = {
  stripOperators: stripOperators,
  StrippedRegExp: StrippedRegExp_StrippedRegExp
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/safe/index.mjs
/**
 * @module safe
 * @since 1.0.0
 */

/**
 * No operation function accept anything
 * @private
 * @return {undefined} return nothing
 */
function noop() {} /* Do nothing */

/**
 * Perform a safe call on a method. Ignore other types
 *
 * @param  {Function|Any} fn          What may be a function to run
 * @param  {Object}       [context] The context to call the function on
 * @param  {...Any[]}     [args]    Other arguments to pass onto the function
 * @return {Any}
 *
 * @example
 * safe((a, b, c) => console.log(a + b + c), this, 'A', 'B', 'C');
 * // 'ABC'
 */
var safe = function safe(fn, context) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return (typeof fn === 'function' ? fn : noop).apply(context || null, args || []);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/sendError/index.mjs
/**
 * @module sendError
 * @alias Fiverr._logErrorToServer
 * @since 1.7.0
 */



/**
 * Report error to server. Aliases Fiverr._logErrorToServer
 * @param  {string} file
 * @param  {string} method
 * @param  {string} error
 * no return value
 *
 * @example
 * sendError('my_file.js', 'my_method_name', `expected argument to be string got ${typeof arguments[0]}`)
 */
var sendError = alias('_logErrorToServer');
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/send/index.mjs
/**
 * @namespace send
 * @since 2.0.0
 */





/**
 * object A collection of senders methods
 * @type     {Object}
 * @property {Function} sendError  @see <a href="identifiers.html#send-senderror">sendError</a>
 * @property {Function} sendEvents  @see <a href="identifiers.html#send-sendevents">sendEvents</a>
 * @property {Function} sendGraph  @see <a href="identifiers.html#send-sendgraph">sendGraph</a>
 */
var send = {
  sendError: sendError,
  sendEvents: sendEvents,
  sendGraph: sendGraph
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/string/capitalize/index.mjs
/**
 * @module capitalize
 * @since 1.4.0
 */

/**
 * Uppercase first character
 * @private
 * @param  {String} string Any string
 * @return {String} A string where the first character is uppercased
 */
var cap = function cap(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Uppercase first character of a sentence or each word in a string
 * @param  {String}  [string=''] A word or a sentence
 * @param  {Boolean} [all=false] Should capitalize every first letter of a word in a sentence
 * @return {String}
 *
 * @example
 * capitalize('martin prince') // 'Martin prince'
 * capitalize('martin prince', true) // 'Martin Prince'
 */
var capitalize = function capitalize() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return all ? string.split(' ').map(cap).join(' ') : cap(string);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/string/interpolator/index.mjs
var interpolator__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module interpolator
 * @since 1.9.0
 */

/**
 * Valid types of results for the interpolated string
 * @private
 * @type {Array}
 * @member {String|Number}
 */
var VALID_RESULT_TYPES = Object.seal(['string', 'number']);

/**
 * Create new interpolator method instance
 * @param  {...RegExp[]} replacers
 * @returns {Function} interpolate function instance
 *
 * @example const interpolate = interpolator(/\${([^{}]*)}/gm);
 *
 * interpolate('Hello, ${name}', {name: 'Martin'})
 */
var interpolator = function interpolator() {
  for (var _len = arguments.length, replacers = Array(_len), _key = 0; _key < _len; _key++) {
    replacers[_key] = arguments[_key];
  }

  return (

    /**
     * interpolate description
     * @param  {String} string Template
     * @param  {Object} data   Data for filling
     * @return {String}        Result
     */
    function interpolate() {
      var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments[1];

      if (typeof string !== 'string') {
        throw new TypeError('interpolator expects first argument to be a string, got a ' + (typeof string === 'undefined' ? 'undefined' : interpolator__typeof(string)));
      }

      if (!data) {
        return string;
      }

      /**
       * Replace method build with internal reference to the passed in data structure
       * @param  {String} haystack The full string match
       * @param  {String} needle   The content to identify as data member
       * @return {String}          Found value
       */
      function replace(haystack, needle) {
        var replacement = data[needle.trim()];

        return ~VALID_RESULT_TYPES.indexOf(typeof replacement === 'undefined' ? 'undefined' : interpolator__typeof(replacement)) ? replacement : haystack;
      }

      return replacers.reduce(function (string, replacer) {
        return string.replace(replacer, replace);
      }, string);
    }
  );
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/string/index.mjs
/**
 * @namespace string
 * @since 2.0.0
 */




/**
 * string A collection of string related methods
 * @type     {Object}
 * @property {Function} capitalize @see <a href="identifiers.html#string-capitalize">capitalize</a>
 * @property {Function} interpolator @see <a href="identifiers.html#string-interpolator">interpolator</a>
 */
var string_string = {
  capitalize: capitalize,
  interpolator: interpolator
};

// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/tab/index.mjs
var tab__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tab__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module tab
 * @since 2.1.0
 */



var ACTIVE_TAB = 'VdOMGFYWmxYM1JoWWc';
var FOCUS = 'focus';

/**
 * @class Tab
 * @classdesc Register most recently active tab in local storagae
 * @property {String}   uid             Current tab uid
 * @property {Set}      whenActive      Set containing functions to call when active
 * @property {Map}      focusHandlers   Map between callbacks and subscripion IDs
 * @property {Fucntion} setActiveTab    A bound instance of setActiveTab
 */

var tab_Tab = function () {
    function Tab() {
        tab__classCallCheck(this, Tab);

        if (!env_env.browser) {
            throw new Error('[fUtile][Tab][Constructor] Module should only be used in the browser');
        }

        this.uid = random.uid('TAB');
        this.setActiveTab = this.setActiveTab.bind(this);
        this.whenActive = new Set();
        this.focusHandlers = new Map();
        this.setActiveTab();
        this.onFocus(this.setActiveTab);
    }

    /**
     * @return {String} Current active tab value from local storage
     */


    tab__createClass(Tab, [{
        key: 'setActiveTab',


        /**
         * Sets the current tab as the active tab in localStorage
         */
        value: function setActiveTab() {
            if (this.isActive) {
                return;
            }
            localStorage.set(ACTIVE_TAB, this.uid);

            this.whenActive.forEach(function (callback) {
                return callback();
            });
        }

        /**
         * @return {Boolean} Is the current tab the active tab stored in localStoarge
         */

    }, {
        key: 'onSetActive',


        /**
         * Accepts a function to call when tab is set to active
         * @param {Function} callback a function to add to `whenActive` set
         * @example
         * tab().onSetActive(() => console.log('I\'m active now'))
         */
        value: function onSetActive(callback) {
            typeof callback === 'function' && this.whenActive.add(callback);
        }

        /**
         * Accepts a function to call when tab gets focused
         * @param {Function} callback a function to add to `focusHandlers` Map
         * @returns {String} subscription ID for unsubscribing
         * @example
         * tab().focusSubscribe(() => console.log('I\'m focused now'))
         */

    }, {
        key: 'focusSubscribe',
        value: function focusSubscribe(callback) {

            if (typeof callback !== 'function') {
                return null;
            }

            var subscriptionId = random.uid();
            this.onFocus(callback);
            this.focusHandlers.set(subscriptionId, callback);
            return subscriptionId;
        }

        /**
         * Unsubscribe a specific subscription from focus event
         * @param {String} subscriptionId subscription ID to remove from Map
         * @example
         * tab().focusUnsubscribe('2452435435')
         */

    }, {
        key: 'focusUnsubscribe',
        value: function focusUnsubscribe(subscriptionId) {
            window.removeEventListener(FOCUS, this.focusHandlers.get(subscriptionId));
        }

        /**
         * Binds `focus` event to a given callback
         */

    }, {
        key: 'onFocus',
        value: function onFocus(callback) {
            window.addEventListener(FOCUS, callback);
        }
    }, {
        key: 'activeTab',
        get: function get() {
            return localStorage.get(ACTIVE_TAB);
        }
    }, {
        key: 'isActive',
        get: function get() {
            return this.activeTab === this.uid;
        }
    }]);

    return Tab;
}();

var identifier = ACTIVE_TAB;

/**
 * consistently exports the same Tab instance
 * @returns {Tab} singleton instance of Tab
 * @example
 * if (tab().isActive) {
 *     shutDown();
 * }
 */
var tab_tab = function tab() {
    return glob[identifier] = glob[identifier] || new tab_Tab();
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/formDataIterable/index.mjs
/**
 * @module formDataIterable
 * @since 2.0.0
 */

/**
 * Generates an  iterable array member from a form element.
 * @param  {HTMLInputElement} field An HTML form input element.
 * @return {Array}
 */
var iteratize = function iteratize(field) {
    return [field.name, field.value];
};

/**
 * Generates an iterable array from a form element in a manner compliant with all browsers.
 * @param  {HTMLFormElement} formElement a <form> element.
 * @return {Array}                       An iterable array, similar to FormData.entries().
 */
function formDataIterable(formElement) {
    return [].reduce.call(formElement.elements, function (data, field) {
        switch (field.type) {
            case 'submit':
            case 'button':
            case 'reset':
            case 'file':
                break;
            case 'checkbox':
            case 'radio':
                field.checked && data.push(iteratize(field));
                break;
            case 'select-multiple':
                [].forEach.call(field.options, function (option) {
                    option.selected && data.push([field.name, option.value]);
                });
                break;
            default:
                data.push(iteratize(field));
                break;
        }

        return data;
    }, []);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/__validValue/index.mjs
/**
 * @module __validValue
 * @private
 * @since 1.4.0
 */

/**
 * Return valid values for a URL parameter's value
 * @param  {String} value The value
 * @return {String|Boolean} empty string is considered true, everything else gets URI decoded
 *
 * @example validValue('%2425');
 * // '$25'
 */
var validValue = function validValue(value) {
  return value === undefined ? true : decodeURIComponent(value);
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/__breakPair/index.mjs
var __breakPair__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module __breakPair
 * @private
 * @since 1.4.0
 */



/**
 * Break a query key=value pair to an array containing key and value respectively
 * @param  {String} item Representation of key value pair 'key=value'
 * @return {Object}
 *
 * @example breakPair('key=value') // {key: 'value'}
 */
function breakPair(item) {
  var _item$split = item.split('='),
      _item$split2 = __breakPair__slicedToArray(_item$split, 2),
      key = _item$split2[0],
      value = _item$split2[1];

  return key === '' ? {} : _defineProperty({}, key, validValue(value));
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/queryStringToObject/index.mjs
function queryStringToObject__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @module queryStringToObject
 * @description Convert query string structure to a Javascript object
 * @since 1.4.0
 */



/**
 * Convert query string to key value pairs object
 * @param  {String} string Complete query string (w/o the mod)
 * @return {Object}
 *
 * @example
 * queryStringToObject('param1=value1&param2=value2') // {param1: 'value1', param2: 'value2'}
 */
var queryStringToObject_queryStringToObject = function queryStringToObject() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Object.assign.apply(Object, queryStringToObject__toConsumableArray(string.split('&').map(breakPair)));
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/serializeObject/index.mjs
var serializeObject__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module serializeObject
 * @since 2.0.0
 */

var DEFAULT_DELIMITERS = {
    pair: '=',
    values: '&'
};

/**
 * Serializes an Object into a digestable string.
 * @param  {Object|Array[]} source    Either a flat object, or an entries array ([[k, v], [k, v]]).
 * @param  {Object} delimiters        A map of delimiters to join the string by.
 * @param  {String} delimiters.pair   A character to join pairs of key-value by.
 * @param  {String} delimiters.values A character to join values by.
 * @return {String}                   Serialized parameters string.
 * @example
 * var delimiters = {
 *  pair: ':',
 *  values: '|'
 * }
 *
 * serializeObject(object) // 'a=this&b=is%20cool'
 * serializeObject(object, delimiters) // 'a:this|b:is%20cool'
 */
function serializeObject(source, delimiters) {
    var isValid = (typeof source === 'undefined' ? 'undefined' : serializeObject__typeof(source)) === 'object';

    if (!isValid) {
        return null;
    }

    delimiters = Object.assign({}, DEFAULT_DELIMITERS, delimiters);
    var isObject = !Array.isArray(source);
    var entries = isObject ? Object.entries(source) : source;
    var queryString = Array.from(entries, function (param) {
        return param.map(encodeURIComponent).join(delimiters.pair);
    });

    return queryString.join(delimiters.values);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/serializeParams/index.mjs
var serializeParams__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @module serializeParams
 * @since 2.0.0
 *
 * @requires env
 * @requires serializeObject
 * @requires URI/formDataIterable
 */





/**
 * Serializes url params using URI encoding.
 * @param  {Object|HTMLFormElement} source Either a flat parameters object, or a <form> element.
 * @return {String}                        Serialized URL parameters string.
 * @example
 * var object = {
 *   a: 'this',
 *   b: 'is cool'
 * }
 *
 * serializeParams(object) // 'a=this&b=is%20cool'
 */
function serializeParams(source) {
  if (!source || (typeof source === 'undefined' ? 'undefined' : serializeParams__typeof(source)) !== 'object') {
    return null;
  }

  var isFormElement = env_env.browser && source instanceof HTMLFormElement;
  var formData = isFormElement ? formDataIterable(source) : Object.entries(source);
  return serializeObject(formData);
}
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/toQueryString/index.mjs
/**
 * @module toQueryString
 * @since 1.4.0
 */

/**
 * Return a valid URL param value, URI encoded value following the equal sign. Empty string returns nothing
 * @private
 * @param  {String} value A value for url param value
 * @return {String}
 *
 * @example
 * equals('Hello'); // '=Hello'
 * equals('$100'); // '=%24100'
 * equals(''); // ''
 */
var equals = function equals(value) {
  return value === true ? '' : '=' + encodeURIComponent(value);
};

/**
 * Convert object to a string with a URL params notation
 * @param  {Object} params Parameters object - Key value pair
 * @return {String}
 *
 * @example toQueryString({a: 1, b: true, c: 3}) // 'a=1&b&c=3'
 */
var toQueryString = function toQueryString() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(params).map(function (key) {
    return key + equals(params[key]);
  }).join('&');
};
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/__analyze/index.mjs
var __analyze__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function __analyze__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module __analyze
 * @private
 * @description Analyse parts of the href string
 * @since 1.4.0
 */

/**
 * Create RegExp match methods
 * @private
 * @param  {RegExp} pattern
 * @param  {Number} location in regex result to retrieve
 * @return {Function}
 */
function _regexGetter(pattern, location) {
  /**
   * Get match or empty string
   * @param  {String} string
   * @return {String}
   */
  return function (string) {
    var match = string.match(pattern);

    return match && match[location] || '';
  };
}

/**
 * _patterns regex getter methods storage
 * @private
 * @constant
 * @type {Object<RegExp>}
 */
var _patterns = {};

/**
 * @class Analyze
 * @classdesc Expose a collection of methods to get parts of a URI struct
 *
 * @example (new Analyze()).path('www.website.com/page?param1=1')
 * // www.website.com/page
 */

var Analyze = function () {
  function Analyze() {
    __analyze__classCallCheck(this, Analyze);
  }

  __analyze__createClass(Analyze, [{
    key: 'hash',


    /**
     * @type {Function}
     * @description
     * Get hash string from href
     * @example
     * hash('https://www.website.com/page/file.ext?param1=1#location'); // 'location'
     */
    get: function get() {
      return _patterns.hash = _patterns.hash || _regexGetter(/^.*[\#\!|\#](.*)/, 1); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get query string from href
     * @example
     * query('https://www.website.com/page/file.ext?param1=1#location'); // 'param1=1'
     */

  }, {
    key: 'query',
    get: function get() {
      return _patterns.query = _patterns.query || _regexGetter(/^.*\?(.*(?=#)|(.*(?=$)))/, 1); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get host string from href
     * @example
     * host('https://www.website.com/page/file.ext?param1=1#location'); // 'www.website.com'
     */

  }, {
    key: 'host',
    get: function get() {
      return _patterns.host = _patterns.host || _regexGetter(/^(.*:[\/]{2}|[\/]{2})?([\w|-|\.]*).*$/, 2); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get top level string from host
     * @example
     * top('www.website.com'); // 'website.com'
     */

  }, {
    key: 'top',
    get: function get() {
      return _patterns.top = _patterns.top || _regexGetter(/localhost$|[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/, 0); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get protocol string from href
     * @example
     * protocol('https://www.website.com/page/file.ext?param1=1#location'); // 'https:'
     */

  }, {
    key: 'protocol',
    get: function get() {
      return _patterns.protocol = _patterns.protocol || _regexGetter(/^(.*:)[\/]{2}|[\/]{2}?.*$/, 1); // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get path string from href
     * @example
     * path('https://www.website.com/page/file.ext?param1=1#location'); // 'https://www.website.com/page/file.ext'
     */

  }, {
    key: 'path',
    get: function get() {
      return _patterns.path = _patterns.path || function (href) {
        return href.replace(/[\?|#].*$/, '');
      }; // eslint-disable-line no-useless-escape
    }

    /**
     * @type {Function}
     * @description
     * Get pathname string from path and host
     * @example
     * pathname('https://www.website.com/page/file.ext', 'www.website.com'); // '/page/file.ext'
     */

  }, {
    key: 'pathname',
    get: function get() {
      return _patterns.pathname = _patterns.pathname || function (path, host) {
        return host ? path.replace(new RegExp('.*' + host), '') : path;
      };
    }
  }]);

  return Analyze;
}();

/**
 * instance exposed as interface
 * @type {Analyze}
 *
 * @example analyze.path('www.website.com/page?param1=1') // www.website.com/page
 */


var analyze = new Analyze();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/URI/index.mjs
var URI__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function URI__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function URI__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function URI__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module URI
 * @since 1.4.0
 */






/**
 * Key to use for stored calculated values of URI struct
 * @type {Symbol}
 */
var store = typeof Symbol === 'function' ? Symbol() : '_store';

/**
 * Map param types from symbols to names
 * @private
 * @type {Object}
 */
var QUERY_TYPE_DICTIONARY = {
    '#!': 'hashParams',
    '#': 'hashParams',
    '?': 'queryParams'
};

/**
 * Assign key value pair to Self store object, and recreate a frozen store
 * @private
 * @param  {URI}     self context
 * @param  {String}  prop Property to set
 * @param  {Any}     getter
 * @param  {Boolean} [force=true] should set even if the property exists
 * @return {URI}
 */
function _assign(self, prop, getter) {
    var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (force || !self.store.hasOwnProperty(prop)) {
        self[store] = Object.freeze(Object.assign({}, self.store, URI__defineProperty({}, prop, getter())));
    }

    return self;
}

/**
 * rebuild href string according to new parameters
 * @private
 * @param  {URI} self context
 * @param  {Strong[]} props Properties to use in the rebuilt solution (skip re calculation)
 * @return {URI}
 */
function _rebuild(self) {
    for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
    }

    self[store] = Object.freeze(Object.assign.apply(Object, URI__toConsumableArray([{
        href: [self.path, self.hasQueryParams() ? '?' + toQueryString(self.queryParams) : '', self.hasHashParams() ? '#' + toQueryString(self.hashParams) : ''].join('')
    }].concat(props.map(function (prop) {
        return URI__defineProperty({}, prop, self.store[prop]);
    })))));

    return self;
}

/**
 * @class URI
 * @classdesc URI parser with params manipulation
 *
 * @example const uri = new URI('website.com/page?param1=1');
 * uri.host;     // 'website.com'
 * uri.pathname; // '/page'
 * uri.params;   // {param1: '1'}
 * uri.params;   // {param1: '1', param2: '2'}
 */
var URI_URI = function () {
    /**
     * constructor
     * @param {String} href Full URI string
     */
    function URI(href) {
        URI__classCallCheck(this, URI);

        this[store] = Object.freeze({ href: href });
    }

    /**
     * a pointer to store property
     * @return {Object} store
     */


    URI__createClass(URI, [{
        key: 'toString',


        /**
         * Override native 'toString' function
         * @return {String} The full href string
         *
         * @example const uri = new URI('website.com/page?param1=1');
         * uri.toString(); // 'website.com/page?param1=1&param2=2'
         * '' + uri; // 'website.com/page?param1=1&param2=2'
         * `${uri}`; // 'website.com/page?param1=1&param2=2'
         */
        value: function toString() {
            return this.href;
        }

        /**
         * hasQueryParams
         * @return {Boolean} the query object has any members
         *
         * @example uri.hasQueryParams();
         */

    }, {
        key: 'hasQueryParams',
        value: function hasQueryParams() {
            return Object.keys(this.queryParams).length > 0;
        }

        /**
         * hasHashParams
         * @return {Boolean} the hash object has any members
         *
         * @example uri.hasHashParams();
         */

    }, {
        key: 'hasHashParams',
        value: function hasHashParams() {
            return Object.keys(this.hashParams).length > 0;
        }

        /**
         * add params to query or hash by interface
         * @param {Object} obj key value pairs
         * @param {String} mod which param set to address
         *
         * @example uri.addParams({key: 'value'});
         * uri.addParams({key: 'value'}, '?');
         */

    }, {
        key: 'addParams',
        value: function addParams(obj, mod) {
            this.params; // Should pre calculate

            var method = QUERY_TYPE_DICTIONARY[mod] || 'params';

            this[method] = obj;

            return this;
        }

        /**
         * @return {Boolean} Has any query or hash params
         *
         * @example uri.hasParams();
         */

    }, {
        key: 'hasParams',
        value: function hasParams() {
            return Object.keys(this.params).length > 0;
        }

        /**
         * remove params from query and hash
         * @param  {String[]} keys to remove
         * @return {Self}
         *
         * @example uri.removeParams('param_a', 'param_b');
         */

    }, {
        key: 'removeParams',
        value: function removeParams() {
            var _this = this;

            for (var _len2 = arguments.length, keys = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                keys[_key2] = arguments[_key2];
            }

            this.params; // Should pre calculate


            if (!keys.length) {

                // Remove all
                this[store] = Object.freeze(Object.assign.apply(Object, [{}, this.store, {
                    hashParams: {},
                    queryParams: {}
                }]));
            } else {
                this[store] = Object.freeze(Object.assign.apply(Object, URI__toConsumableArray([{}, this.store].concat(['hashParams', 'queryParams'].map(function (prop) {
                    return URI__defineProperty({}, prop, select_select(_this[prop], function (key) {
                        return !~keys.indexOf(key);
                    }));
                })))));
            }

            return _rebuild(this, 'queryParams', 'hashParams');
        }
    }, {
        key: 'store',
        get: function get() {
            return this[store];
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'href',
        get: function get() {
            return this.store.href;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'path',
        get: function get() {
            var _this2 = this;

            return _assign(this, 'path', function () {
                return analyze.path(_this2.href);
            }).store.path;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'pathname',
        get: function get() {
            var _this3 = this;

            this.path; // Should pre calculate
            this.host; // Should pre calculate

            return _assign(this, 'pathname', function () {
                return analyze.pathname(_this3.path, _this3.host);
            }).store.pathname;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'host',
        get: function get() {
            var _this4 = this;

            this.path; // Should pre calculate

            return _assign(this, 'host', function () {
                return analyze.host(_this4.path);
            }).store.host;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'top',
        get: function get() {
            var _this5 = this;

            this.host; // Should pre calculate

            return _assign(this, 'top', function () {
                return analyze.top(_this5.host);
            }).store.top;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'protocol',
        get: function get() {
            var _this6 = this;

            this.path; // Should pre calculate

            return _assign(this, 'protocol', function () {
                return analyze.protocol(_this6.path);
            }).store.protocol;
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'query',
        get: function get() {
            var _this7 = this;

            return _assign(this, 'query', function () {
                return analyze.query(_this7.href);
            }).store.query;
        }

        /**
         * @type {Object}
         */

    }, {
        key: 'queryParams',
        get: function get() {
            var _this8 = this;

            this.query; // Should pre calculate

            return _assign(this, 'queryParams', function () {
                return Object.freeze(queryStringToObject_queryStringToObject(_this8.query));
            }).store.queryParams;
        },
        set: function set(obj) {
            var _this9 = this;

            this.queryParams; // Should pre calculate

            _rebuild(_assign(this, 'queryParams', function () {
                return Object.assign({}, _this9.queryParams, obj);
            }, true), 'queryParams');
        }

        /**
         * @type {String}
         * @readonly
         */

    }, {
        key: 'hash',
        get: function get() {
            var _this10 = this;

            return _assign(this, 'hash', function () {
                return analyze.hash(_this10.href);
            }).store.hash;
        }

        /**
         * @type {Object}
         */

    }, {
        key: 'hashParams',
        get: function get() {
            var _this11 = this;

            this.hash; // Should pre calculate

            return _assign(this, 'hashParams', function () {
                return Object.freeze(queryStringToObject_queryStringToObject(_this11.hash));
            }).store.hashParams;
        },
        set: function set(obj) {
            var _this12 = this;

            this.hashParams; // Should pre calculate

            _rebuild(_assign(this, 'hashParams', function () {
                return Object.assign({}, _this12.hashParams, obj);
            }, true), 'hashParams');
        }

        /**
         * @type {Object}
         */

    }, {
        key: 'params',
        get: function get() {
            this.queryParams; // Should pre calculate
            this.hashParams; // Should pre calculate

            return Object.assign({}, this.queryParams, this.hashParams);
        },
        set: function set(obj) {
            this.params; // Should pre calculate

            var method = !this.hasQueryParams() && this.hasHashParams() ? 'hash' : 'query';

            this[method + 'Params'] = obj;
        }
    }]);

    return URI;
}();
// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/url/index.mjs
/**
 * @namespace url
 * @since 2.0.0
 */








/**
 * url A collection of url related methods
 * @type     {Object}
 * @property {Function} formDataIterable @see <a href="identifiers.html#url-formdataiterable">formDataIterable</a>
 * @property {Function} queryStringToObject @see <a href="identifiers.html#url-querystringtoobject">queryStringToObject</a>
 * @property {Function} serializeObject @see <a href="identifiers.html#url-serializeobject">serializeObject</a>
 * @property {Function} serializeParams @see <a href="identifiers.html#url-serializeparams">serializeParams</a>
 * @property {Function} toQueryString @see <a href="identifiers.html#url-toquerystring">toQueryString</a>
 * @property {Class}    URI @see <a href="identifiers.html#url-uri">URI</a>
 */
var url_url = {
    formDataIterable: formDataIterable,
    queryStringToObject: queryStringToObject_queryStringToObject,
    serializeObject: serializeObject,
    serializeParams: serializeParams,
    toQueryString: toQueryString,
    URI: URI_URI
};


// CONCATENATED MODULE: ./node_modules/@fiverr-private/futile/lib/index.mjs
/**
 * @module futile
 * @description This is the gateway to all exposed interfaces in the package
 * @since 2.0.0
 */





















// CONCATENATED MODULE: ./src/components/block_user/ModalWrapper/ModalBody/index.js
var ModalBody__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalBody__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalBody__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalBody__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ModalBody_ModalBody = function (_React$Component) {
    ModalBody__inherits(ModalBody, _React$Component);

    function ModalBody(props) {
        ModalBody__classCallCheck(this, ModalBody);

        var _this = ModalBody__possibleConstructorReturn(this, (ModalBody.__proto__ || Object.getPrototypeOf(ModalBody)).call(this, props));

        _this.blockReasons = ['abusive', 'provide', 'negative'];

        var reason = _this.blockReasons[0];
        var reasonText = i18n.t('seller_card.block_user.options.' + _this.defaultBlockReason);

        _this.reasonLength = 100;
        _this.specialChars = /[@^&*_+=\\[\]{};\\|<>\\/]/; // eslint-disable-line

        _this.state = {
            selectedReason: {
                reason: reason,
                reasonText: reasonText
            },
            confirmEnabled: _this.isValid(reason, reasonText)
        };

        var boundFunctions = ['confirmModal', 'changeReason', 'isValid'];
        boundFunctions.forEach(function (fn) {
            return _this[fn] = _this[fn].bind(_this);
        });
        return _this;
    }

    ModalBody__createClass(ModalBody, [{
        key: 'changeReason',
        value: function changeReason(reason, reasonText) {

            this.setState({
                selectedReason: {
                    reason: reason,
                    reasonText: reasonText
                },
                confirmEnabled: this.isValid(reason, reasonText)
            });
        }
    }, {
        key: 'isValid',
        value: function isValid(reason, reasonText) {
            var isValidLength = reasonText.length > 0 && reasonText.length < this.reasonLength,
                hasSpecialChart = this.specialChars.test(reasonText);

            var isValidText = isValidLength && !hasSpecialChart;
            return !(reason === 'other' && !isValidText);
        }
    }, {
        key: 'confirmModal',
        value: function confirmModal() {
            var _this2 = this;

            var _state$selectedReason = this.state.selectedReason,
                reason = _state$selectedReason.reason,
                reasonText = _state$selectedReason.reasonText;


            if (this.isValid(reason, reasonText)) {
                var url = '/users/' + this.props.userId + '/interaction_blocking/block';

                var data = {
                    reason: reasonText
                };

                this.setState({
                    confirmEnabled: false
                });

                gofor(url, {
                    method: 'POST',
                    body: JSON.stringify(data)
                }).then(function (response) {
                    return response.json();
                }).then(function (responseData) {
                    if (responseData.success) {
                        _this2.props.closeModal();
                        _this2.props.submitBlockTrigger();
                        _this2.setState({
                            confirmEnabled: true
                        });
                    }
                }).catch(function () {
                    _this2.setState({
                        confirmEnabled: true
                    });
                    _this2.props.closeModal();
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                closeModal = _props.closeModal,
                userName = _props.userName;


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'block-user-body modal-body' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'p',
                    null,
                    i18n.t('seller_card.block_user.description'),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'a',
                        { href: i18n.t('seller_card.block_user.learn_more_text') },
                        ' ',
                        i18n.t('seller_card.block_user.learn_more')
                    )
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'h4',
                    null,
                    i18n.t('seller_card.block_user.question', { userName: userName })
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(ModalBody_RadiosWrapper, { changeReason: this.changeReason,
                    blockReasons: this.blockReasons,
                    selectedReason: this.state.selectedReason }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'button-wrapper' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'button',
                        { className: 'btn-lrg-standard btn-white', onClick: closeModal },
                        i18n.t('seller_card.block_user.cancel')
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'button',
                        { disabled: !this.state.confirmEnabled, className: 'btn-lrg-standard', onClick: this.confirmModal },
                        i18n.t('seller_card.block_user.submit')
                    )
                )
            );
        }
    }]);

    return ModalBody;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.Component);

ModalBody_ModalBody.propTypes = {
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    submitBlockTrigger: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

ModalBody_ModalBody.defaultProps = {
    userName: '',
    userId: 0
};

/* harmony default export */ var ModalWrapper_ModalBody = (ModalBody_ModalBody);
// EXTERNAL MODULE: ./node_modules/@fiverr/modal/dist/index.css
var _fiverr_modal_dist = __webpack_require__("0Qmd");
var _fiverr_modal_dist_default = /*#__PURE__*/__webpack_require__.n(_fiverr_modal_dist);

// EXTERNAL MODULE: ./src/components/block_user/ModalWrapper/style.scss
var ModalWrapper_style = __webpack_require__("ZUpz");
var ModalWrapper_style_default = /*#__PURE__*/__webpack_require__.n(ModalWrapper_style);

// CONCATENATED MODULE: ./src/components/block_user/ModalWrapper/index.js








var ModalWrapper_ModalWrapper = function ModalWrapper(_ref) {
    var showBlockButton = _ref.showBlockButton,
        userId = _ref.userId,
        submitBlockTrigger = _ref.submitBlockTrigger,
        userName = _ref.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        modal_dist["Base"],
        { trigger: function trigger(_ref2) {
                var toggle = _ref2.toggle;
                return showBlockButton && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(ModalWrapper_BlockButton, { togglePopup: toggle });
            },
            header: i18n.t('seller_card.block_user.title') },
        function (_ref3) {
            var close = _ref3.close;
            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(ModalWrapper_ModalBody, { userId: userId, userName: userName, submitBlockTrigger: submitBlockTrigger, closeModal: close });
        }
    );
};

ModalWrapper_ModalWrapper.propTypes = {
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    showBlockButton: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    submitBlockTrigger: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

ModalWrapper_ModalWrapper.defaultProps = {
    userId: 0,
    userName: '',
    showBlockButton: false
};

/* harmony default export */ var block_user_ModalWrapper = (ModalWrapper_ModalWrapper);
// EXTERNAL MODULE: ./src/components/block_user/style.scss
var block_user_style = __webpack_require__("027T");
var block_user_style_default = /*#__PURE__*/__webpack_require__.n(block_user_style);

// CONCATENATED MODULE: ./src/components/block_user/index.js





var block_user_BlockUser = function BlockUser(_ref) {
    var showBlockButton = _ref.showBlockButton,
        userId = _ref.userId,
        submitBlockTrigger = _ref.submitBlockTrigger,
        userName = _ref.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(block_user_ModalWrapper, { showBlockButton: showBlockButton,
        userId: userId,
        submitBlockTrigger: submitBlockTrigger,
        userName: userName });
};

block_user_BlockUser.propTypes = {
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    showBlockButton: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    submitBlockTrigger: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

block_user_BlockUser.defaultProps = {
    userId: 0,
    showBlockButton: false,
    userName: ''
};

/* harmony default export */ var block_user = (block_user_BlockUser);
// EXTERNAL MODULE: ./src/components/description/style.scss
var description_style = __webpack_require__("R5aA");
var description_style_default = /*#__PURE__*/__webpack_require__.n(description_style);

// CONCATENATED MODULE: ./src/components/description/index.js
var description__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function description__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function description__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function description__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var xss = __webpack_require__("NG4M");

/**
 * @class
 * @name Description
 * @extends Component
 * @param {String} userDescription - the seller's description
 * Container for rendering markup of the seller description
 */

var description_Description = function (_Component) {
    description__inherits(Description, _Component);

    function Description(props) {
        description__classCallCheck(this, Description);

        var _this = description__possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).call(this, props));

        _this.onReadMoreClick = _this.onReadMoreClick.bind(_this);

        _this.state = {
            descExpanded: false
        };
        return _this;
    }

    description__createClass(Description, [{
        key: 'onReadMoreClick',
        value: function onReadMoreClick(e) {
            e.preventDefault();

            this.setState({
                descExpanded: !this.state.descExpanded
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var desc = '';

            try {
                desc = xss(replaceBreakTags(this.props.userDescription), {
                    whiteList: [],
                    stripIgnoreTag: true,
                    stripIgnoreTagBody: ['script', 'a']
                });
            } catch (error) {
                // fail silently
            }

            var showReadMore = desc.length > 120;

            // if we stripped all tags, the description might now be empty
            if (desc.length > 0) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'article',
                    { className: 'seller-desc ' + (this.state.descExpanded || !showReadMore ? 'expanded' : '') },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'h4',
                        { className: 'inner-title' },
                        i18n.t('seller_card.about_me')
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'div',
                        { className: 'inner' },
                        desc
                    ),
                    showReadMore && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'a',
                        { href: '#!', className: 'read-more', onClick: this.onReadMoreClick },
                        i18n.t('seller_card.read_more_text.' + (this.state.descExpanded ? 'less' : 'more'))
                    )
                );
            } else {
                return false;
            }
        }
    }]);

    return Description;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

description_Description.propTypes = {
    userDescription: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var description = (description_Description);
// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// EXTERNAL MODULE: ./src/index.scss
var src = __webpack_require__("iCOP");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/SellerCard.js
var SellerCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SellerCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SellerCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SellerCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var SellerCard_SellerCard = function (_PureComponent) {
    SellerCard__inherits(SellerCard, _PureComponent);

    function SellerCard(props) {
        SellerCard__classCallCheck(this, SellerCard);

        var _this = SellerCard__possibleConstructorReturn(this, (SellerCard.__proto__ || Object.getPrototypeOf(SellerCard)).call(this, props));

        i18n.add(translations_en_default.a);

        _this.state = {
            isOnline: false,
            isOnVacation: props.user.is_on_vacation,
            showBlockButton: false
        };

        var allowEditing = props.allowEditing,
            viewingAsBuyer = props.viewingAsBuyer,
            isLoggedIn = props.isLoggedIn;


        _this.renderBlockButton = !allowEditing && !viewingAsBuyer && isLoggedIn;

        _this.submitBlockTrigger = _this.submitBlockTrigger.bind(_this);
        _this.toggleVacation = _this.toggleVacation.bind(_this);
        return _this;
    }

    SellerCard__createClass(SellerCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (document) {
                document.addEventListener('popup_close', function () {
                    _this2.setState({
                        isOnVacation: false
                    });
                });

                document.addEventListener('unblock_user', function () {
                    _this2.setState({
                        showBlockButton: true
                    });
                });

                document.addEventListener('out_of_office_on', function () {
                    _this2.setState({
                        isOnVacation: true
                    });
                });
            }

            var user = this.props.user;

            // this has a lot of checking to ensure this fails silently
            // when running in static or dev mode

            gofor('/users/' + user.username + '/is_online', {
                method: 'GET'
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response) {
                    _this2.setState({
                        isOnline: response.is_online === true
                    });
                }
            }).catch(function (err) {
                throw err;
            });

            if (this.renderBlockButton) {
                gofor('/users/' + user.id + '/interaction_blocking').then(function (response) {
                    return response.json();
                }).then(function (response) {
                    if (response) {
                        _this2.setState({
                            showBlockButton: response.show_block_button
                        });
                    }
                }).catch(function (err) {
                    throw err;
                });
            }
        }
    }, {
        key: 'toggleVacation',
        value: function toggleVacation(e) {
            var _this3 = this;

            e.preventDefault();
            e.stopPropagation();

            var user = this.props.user;


            if (this.state.isOnVacation) {
                gofor('/users/' + user.username + '/vacations', {
                    method: 'delete'
                }).then(function (response) {
                    if (response) {
                        var event = new CustomEvent('open_popup', { detail: false });
                        document.dispatchEvent(event);
                        _this3.setState({
                            isOnVacation: false
                        });
                    }
                }).catch(function (err) {
                    throw err;
                });
            } else {
                var event = new CustomEvent('open_popup', { detail: true });
                document.dispatchEvent(event);
                this.setState({
                    isOnVacation: true
                });
            }
        }
    }, {
        key: 'submitBlockTrigger',
        value: function submitBlockTrigger() {
            var event = new CustomEvent('block_user', { detail: false });
            document.dispatchEvent(event);

            this.setState({
                showBlockButton: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var showReportUserButton = this.showReportUserButton,
                renderBlockButton = this.renderBlockButton;
            var _state = this.state,
                isOnline = _state.isOnline,
                isOnVacation = _state.isOnVacation,
                showBlockButton = _state.showBlockButton;
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing,
                viewingAsBuyer = _props.viewingAsBuyer,
                isMobileResponsive = _props.isMobileResponsive,
                isLoggedIn = _props.isLoggedIn,
                showDescription = _props.showDescription,
                showCustomOrder = _props.showCustomOrder,
                authToken = _props.authToken,
                inWhitingContactButton = _props.inWhitingContactButton,
                className = _props.className,
                profileImageSize = _props.profileImageSize,
                hideProList = _props.hideProList;


            var imageSize = profileImageSize;

            var neverLinkName = !showDescription,
                // when we're showing the description, we want to link the username as well
            allowEditingReal = allowEditing && !viewingAsBuyer,
                // if the user is in "buyer preview"-mode, editing is disabled
            showAmbassador = user.is_ambassador,
                showUserReportActions = showReportUserButton || showBlockButton,
                showNow = user.is_now_seller,
                proExp = user.is_pro_experience,
                showDescriptionReal = showDescription && user.description && user.description.length > 0,
                showPro = user.is_pro && user.pro_sub_categories && !!user.pro_sub_categories.length && !hideProList,
                classes = external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default()('user-main-info', className, { 'pro-exp': proExp && user.is_pro }),
                userReportActionsClasses = external___commonjs___classnames___commonjs2___classnames___amd___classnames___root___classNames___var___classNames___default()('user-report-actions', { 'with-divider': showReportUserButton && showBlockButton }),
                isWide = className && className.indexOf('seller-card-wide') !== -1;

            if (isWide && profileImageSize === undefined) {
                imageSize = 110;
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: classes },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(components_status, { isOnline: isOnline, userId: user.id, isOnVacation: isOnVacation }),
                (showAmbassador || showNow) && !isWide && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(badges, { userName: user.username, showAmbassador: showAmbassador, showNow: showNow }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'user-profile-info' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist_default.a, { user: user, allowEditing: allowEditingReal, authToken: authToken, fetchPolicyPath: '/attachments/policy', uploadPhotoPath: '/profiles/update_photo',
                        profileImageSize: imageSize }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'label',
                        { className: 'user-profile-label' },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'div',
                            { className: 'username-line' },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(profile_link, { userName: user.username, noLink: neverLinkName }),
                            (showAmbassador || showNow) && isWide && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(badges, { userName: user.username, showAmbassador: showAmbassador, showNow: showNow })
                        ),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(oneliner, { user: user, allowEditing: allowEditingReal, authToken: authToken }),
                        showUserReportActions && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'div',
                            { className: userReportActionsClasses },
                            showReportUserButton && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(report_user_dist_default.a, { user: user }),
                            renderBlockButton && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(block_user, { submitBlockTrigger: this.submitBlockTrigger, userId: user.id, userName: user.username, showBlockButton: showBlockButton })
                        ),
                        isWide && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(buttons, { user: user, isMobileResponsive: isMobileResponsive, allowEditing: allowEditingReal,
                            viewingAsBuyer: viewingAsBuyer, isLoggedIn: isLoggedIn,
                            showCustomOrder: showCustomOrder, inWhitingContactButton: inWhitingContactButton })
                    )
                ),
                !isWide && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(buttons, { user: user, isMobileResponsive: isMobileResponsive, allowEditing: allowEditingReal,
                    viewingAsBuyer: viewingAsBuyer, isLoggedIn: isLoggedIn, showCustomOrder: showCustomOrder,
                    inWhitingContactButton: inWhitingContactButton }),
                showPro && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(pro, { proExp: proExp, proCategories: user.pro_sub_categories }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'user-stats-desc' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(stats, { user: user, allowEditing: allowEditingReal, isOnVacation: isOnVacation,
                        toggleVacation: this.toggleVacation }),
                    showDescriptionReal && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(description, { userDescription: user.description })
                )
            );
        }
    }, {
        key: 'showReportUserButton',
        get: function get() {
            var _props2 = this.props,
                shouldShowReportUser = _props2.shouldShowReportUser,
                isLoggedIn = _props2.isLoggedIn,
                allowEditing = _props2.allowEditing,
                viewingAsBuyer = _props2.viewingAsBuyer;

            return shouldShowReportUser && isLoggedIn && !allowEditing && !viewingAsBuyer;
        }
    }]);

    return SellerCard;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

SellerCard_SellerCard.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    viewingAsBuyer: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    isMobileResponsive: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    isLoggedIn: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    showDescription: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    showCustomOrder: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    authToken: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    className: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    profileImageSize: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    shouldShowReportUser: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

SellerCard_SellerCard.defaultProps = {
    user: {},
    allowEditing: false,
    viewingAsBuyer: false,
    isMobileResponsive: false,
    isLoggedIn: false,
    showDescription: true,
    showCustomOrder: true,
    shouldShowReportUser: false,
    authToken: ''
};

/* harmony default export */ var src_SellerCard = (SellerCard_SellerCard);
// CONCATENATED MODULE: ./src/index.js




var componentElm = typeof document !== 'undefined' && document.getElementById('SellerCard-component');

if (componentElm) {
    var initialState = window.initialData.SellerCard;

    external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default.a.render(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_SellerCard, initialState), componentElm);
}

/* harmony default export */ var src_0 = __webpack_exports__["default"] = (src_SellerCard);

/***/ }),

/***/ "nl6y":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__("JgyH"),__webpack_require__("Jmof"),__webpack_require__("PbPb"),__webpack_require__("T9WB"),__webpack_require__("h4G9"),__webpack_require__("jPm4"),__webpack_require__("wLXD")):"function"===typeof define&&define.amd?define(["classnames","react","lodash","prop-types","@fiverr/i18n/singleton","@fiverr/gofor","react-dom"],t):"object"===typeof exports?exports.ReportUser=t(require("classnames"),require("react"),require("lodash"),require("prop-types"),require("@fiverr/i18n/singleton"),require("@fiverr/gofor"),require("react-dom")):e.ReportUser=t(e.classNames,e.React,e._,e.PropTypes,e.i18n,e.goforFactory,e.ReactDOM)}("undefined"!==typeof self?self:this,function(e,t,r,n,o,i,a){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr-private/report_user/",t(t.s="lVK7")}({"/cOS":function(e,t){function r(){var e={};return e["align-content"]=!1,e["align-items"]=!1,e["align-self"]=!1,e["alignment-adjust"]=!1,e["alignment-baseline"]=!1,e.all=!1,e["anchor-point"]=!1,e.animation=!1,e["animation-delay"]=!1,e["animation-direction"]=!1,e["animation-duration"]=!1,e["animation-fill-mode"]=!1,e["animation-iteration-count"]=!1,e["animation-name"]=!1,e["animation-play-state"]=!1,e["animation-timing-function"]=!1,e.azimuth=!1,e["backface-visibility"]=!1,e.background=!0,e["background-attachment"]=!0,e["background-clip"]=!0,e["background-color"]=!0,e["background-image"]=!0,e["background-origin"]=!0,e["background-position"]=!0,e["background-repeat"]=!0,e["background-size"]=!0,e["baseline-shift"]=!1,e.binding=!1,e.bleed=!1,e["bookmark-label"]=!1,e["bookmark-level"]=!1,e["bookmark-state"]=!1,e.border=!0,e["border-bottom"]=!0,e["border-bottom-color"]=!0,e["border-bottom-left-radius"]=!0,e["border-bottom-right-radius"]=!0,e["border-bottom-style"]=!0,e["border-bottom-width"]=!0,e["border-collapse"]=!0,e["border-color"]=!0,e["border-image"]=!0,e["border-image-outset"]=!0,e["border-image-repeat"]=!0,e["border-image-slice"]=!0,e["border-image-source"]=!0,e["border-image-width"]=!0,e["border-left"]=!0,e["border-left-color"]=!0,e["border-left-style"]=!0,e["border-left-width"]=!0,e["border-radius"]=!0,e["border-right"]=!0,e["border-right-color"]=!0,e["border-right-style"]=!0,e["border-right-width"]=!0,e["border-spacing"]=!0,e["border-style"]=!0,e["border-top"]=!0,e["border-top-color"]=!0,e["border-top-left-radius"]=!0,e["border-top-right-radius"]=!0,e["border-top-style"]=!0,e["border-top-width"]=!0,e["border-width"]=!0,e.bottom=!1,e["box-decoration-break"]=!0,e["box-shadow"]=!0,e["box-sizing"]=!0,e["box-snap"]=!0,e["box-suppress"]=!0,e["break-after"]=!0,e["break-before"]=!0,e["break-inside"]=!0,e["caption-side"]=!1,e.chains=!1,e.clear=!0,e.clip=!1,e["clip-path"]=!1,e["clip-rule"]=!1,e.color=!0,e["color-interpolation-filters"]=!0,e["column-count"]=!1,e["column-fill"]=!1,e["column-gap"]=!1,e["column-rule"]=!1,e["column-rule-color"]=!1,e["column-rule-style"]=!1,e["column-rule-width"]=!1,e["column-span"]=!1,e["column-width"]=!1,e.columns=!1,e.contain=!1,e.content=!1,e["counter-increment"]=!1,e["counter-reset"]=!1,e["counter-set"]=!1,e.crop=!1,e.cue=!1,e["cue-after"]=!1,e["cue-before"]=!1,e.cursor=!1,e.direction=!1,e.display=!0,e["display-inside"]=!0,e["display-list"]=!0,e["display-outside"]=!0,e["dominant-baseline"]=!1,e.elevation=!1,e["empty-cells"]=!1,e.filter=!1,e.flex=!1,e["flex-basis"]=!1,e["flex-direction"]=!1,e["flex-flow"]=!1,e["flex-grow"]=!1,e["flex-shrink"]=!1,e["flex-wrap"]=!1,e.float=!1,e["float-offset"]=!1,e["flood-color"]=!1,e["flood-opacity"]=!1,e["flow-from"]=!1,e["flow-into"]=!1,e.font=!0,e["font-family"]=!0,e["font-feature-settings"]=!0,e["font-kerning"]=!0,e["font-language-override"]=!0,e["font-size"]=!0,e["font-size-adjust"]=!0,e["font-stretch"]=!0,e["font-style"]=!0,e["font-synthesis"]=!0,e["font-variant"]=!0,e["font-variant-alternates"]=!0,e["font-variant-caps"]=!0,e["font-variant-east-asian"]=!0,e["font-variant-ligatures"]=!0,e["font-variant-numeric"]=!0,e["font-variant-position"]=!0,e["font-weight"]=!0,e.grid=!1,e["grid-area"]=!1,e["grid-auto-columns"]=!1,e["grid-auto-flow"]=!1,e["grid-auto-rows"]=!1,e["grid-column"]=!1,e["grid-column-end"]=!1,e["grid-column-start"]=!1,e["grid-row"]=!1,e["grid-row-end"]=!1,e["grid-row-start"]=!1,e["grid-template"]=!1,e["grid-template-areas"]=!1,e["grid-template-columns"]=!1,e["grid-template-rows"]=!1,e["hanging-punctuation"]=!1,e.height=!0,e.hyphens=!1,e.icon=!1,e["image-orientation"]=!1,e["image-resolution"]=!1,e["ime-mode"]=!1,e["initial-letters"]=!1,e["inline-box-align"]=!1,e["justify-content"]=!1,e["justify-items"]=!1,e["justify-self"]=!1,e.left=!1,e["letter-spacing"]=!0,e["lighting-color"]=!0,e["line-box-contain"]=!1,e["line-break"]=!1,e["line-grid"]=!1,e["line-height"]=!1,e["line-snap"]=!1,e["line-stacking"]=!1,e["line-stacking-ruby"]=!1,e["line-stacking-shift"]=!1,e["line-stacking-strategy"]=!1,e["list-style"]=!0,e["list-style-image"]=!0,e["list-style-position"]=!0,e["list-style-type"]=!0,e.margin=!0,e["margin-bottom"]=!0,e["margin-left"]=!0,e["margin-right"]=!0,e["margin-top"]=!0,e["marker-offset"]=!1,e["marker-side"]=!1,e.marks=!1,e.mask=!1,e["mask-box"]=!1,e["mask-box-outset"]=!1,e["mask-box-repeat"]=!1,e["mask-box-slice"]=!1,e["mask-box-source"]=!1,e["mask-box-width"]=!1,e["mask-clip"]=!1,e["mask-image"]=!1,e["mask-origin"]=!1,e["mask-position"]=!1,e["mask-repeat"]=!1,e["mask-size"]=!1,e["mask-source-type"]=!1,e["mask-type"]=!1,e["max-height"]=!0,e["max-lines"]=!1,e["max-width"]=!0,e["min-height"]=!0,e["min-width"]=!0,e["move-to"]=!1,e["nav-down"]=!1,e["nav-index"]=!1,e["nav-left"]=!1,e["nav-right"]=!1,e["nav-up"]=!1,e["object-fit"]=!1,e["object-position"]=!1,e.opacity=!1,e.order=!1,e.orphans=!1,e.outline=!1,e["outline-color"]=!1,e["outline-offset"]=!1,e["outline-style"]=!1,e["outline-width"]=!1,e.overflow=!1,e["overflow-wrap"]=!1,e["overflow-x"]=!1,e["overflow-y"]=!1,e.padding=!0,e["padding-bottom"]=!0,e["padding-left"]=!0,e["padding-right"]=!0,e["padding-top"]=!0,e.page=!1,e["page-break-after"]=!1,e["page-break-before"]=!1,e["page-break-inside"]=!1,e["page-policy"]=!1,e.pause=!1,e["pause-after"]=!1,e["pause-before"]=!1,e.perspective=!1,e["perspective-origin"]=!1,e.pitch=!1,e["pitch-range"]=!1,e["play-during"]=!1,e.position=!1,e["presentation-level"]=!1,e.quotes=!1,e["region-fragment"]=!1,e.resize=!1,e.rest=!1,e["rest-after"]=!1,e["rest-before"]=!1,e.richness=!1,e.right=!1,e.rotation=!1,e["rotation-point"]=!1,e["ruby-align"]=!1,e["ruby-merge"]=!1,e["ruby-position"]=!1,e["shape-image-threshold"]=!1,e["shape-outside"]=!1,e["shape-margin"]=!1,e.size=!1,e.speak=!1,e["speak-as"]=!1,e["speak-header"]=!1,e["speak-numeral"]=!1,e["speak-punctuation"]=!1,e["speech-rate"]=!1,e.stress=!1,e["string-set"]=!1,e["tab-size"]=!1,e["table-layout"]=!1,e["text-align"]=!0,e["text-align-last"]=!0,e["text-combine-upright"]=!0,e["text-decoration"]=!0,e["text-decoration-color"]=!0,e["text-decoration-line"]=!0,e["text-decoration-skip"]=!0,e["text-decoration-style"]=!0,e["text-emphasis"]=!0,e["text-emphasis-color"]=!0,e["text-emphasis-position"]=!0,e["text-emphasis-style"]=!0,e["text-height"]=!0,e["text-indent"]=!0,e["text-justify"]=!0,e["text-orientation"]=!0,e["text-overflow"]=!0,e["text-shadow"]=!0,e["text-space-collapse"]=!0,e["text-transform"]=!0,e["text-underline-position"]=!0,e["text-wrap"]=!0,e.top=!1,e.transform=!1,e["transform-origin"]=!1,e["transform-style"]=!1,e.transition=!1,e["transition-delay"]=!1,e["transition-duration"]=!1,e["transition-property"]=!1,e["transition-timing-function"]=!1,e["unicode-bidi"]=!1,e["vertical-align"]=!1,e.visibility=!1,e["voice-balance"]=!1,e["voice-duration"]=!1,e["voice-family"]=!1,e["voice-pitch"]=!1,e["voice-range"]=!1,e["voice-rate"]=!1,e["voice-stress"]=!1,e["voice-volume"]=!1,e.volume=!1,e["white-space"]=!1,e.widows=!1,e.width=!0,e["will-change"]=!1,e["word-break"]=!0,e["word-spacing"]=!0,e["word-wrap"]=!0,e["wrap-flow"]=!1,e["wrap-through"]=!1,e["writing-mode"]=!1,e["z-index"]=!1,e}function n(e,t,r){}function o(e,t,r){}function i(e,t){return a.test(t)?"":t}var a=/javascript\s*\:/gim;t.whiteList=r(),t.getDefaultWhiteList=r,t.onAttr=n,t.onIgnoreAttr=o,t.safeAttrValue=i},"0Qmd":function(e,t){},"0Zbq":function(e,t,r){function n(e,t){return new i(t).process(e)}var o=r("/cOS"),i=r("huvo");t=e.exports=n,t.FilterCSS=i;for(var a in o)t[a]=o[a];"undefined"!==typeof window&&(window.filterCSS=e.exports)},"5CFU":function(e,t,r){!function(t,n){e.exports=n(r("JgyH"),r("Jmof"),r("T9WB"),r("wLXD"))}("undefined"!==typeof self&&self,function(e,t,r,n){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/modal/",t(t.s="lVK7")}({"2KtJ":function(e,t){},JgyH:function(t,r){t.exports=e},Jmof:function(e,r){e.exports=t},Qwgx:function(e,t){},T9WB:function(e,t){e.exports=r},bepL:function(e,t,r){!function(t,n){e.exports=function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{enumerable:!0,get:n})},t.r=function(e){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,r){if(1&r&&(e=t(e)),8&r)return e;if(4&r&&"object"===typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(t.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&r&&"string"!=typeof e)for(var o in e)t.d(n,o,function(t){return e[t]}.bind(null,o));return n},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(t,r){t.exports=e},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function i(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return"function"===typeof e}r.r(t),r.d(t,"CLASS_NO_MODAL_CLICK",function(){return c});var u=r(0),s="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),c="modal-no-click",f=function(e){function t(e){n(this,t);var r=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.CLASS_NO_MODAL_CLICK=c,r.notPropagatingElements=new Set,r.open=function(){var e=function(){r.setState({isOpen:!0},function(){r.bindClickListener(),a(r.togglerDidOpen)&&r.togglerDidOpen()})};if(a(r.togglerWillOpen)){if(r.togglerWillOpen(e),!r.togglerWillOpen.length)return e()}else e()},r.close=function(){var e=function(){r.setState({isOpen:!1},function(){r.removeClickListener(),a(r.togglerDidClose)&&r.togglerDidClose()})};if(a(r.togglerWillClose)){if(r.togglerWillClose(e),!r.togglerWillClose.length)return e()}else e()},r.toggle=function(){return r.state.isOpen?r.close():r.open()},r.bindClickListener=function(){!1!==r.props.bindBodyClickListener&&document.body.addEventListener("click",r.onBodyClick)},r.removeClickListener=function(){return document.body.removeEventListener("click",r.onBodyClick)},r.shouldPreventPropagationByClassName=function(e){return!(!e||!e.classList)&&e.classList.contains(r.CLASS_NO_MODAL_CLICK)},r.shouldPreventPropagationByElement=function(e){if(!e)return!1;if(!e.contains)return!1;if(!r.notPropagatingElements.size)return!1;if(r.notPropagatingElements.has(e))return!0;var t=!0,n=!1,o=void 0;try{for(var i,a=r.notPropagatingElements[Symbol.iterator]();!(t=(i=a.next()).done);t=!0){var u=i.value;if(u.contains&&u.contains(e))return!0}}catch(e){n=!0,o=e}finally{try{!t&&a.return&&a.return()}finally{if(n)throw o}}return!1},r.preventCloseAction=function(e){if(e)return r.notPropagatingElements.has(e)?null:void r.notPropagatingElements.add(e)},r.onBodyClick=r.onBodyClick.bind(r),r.state={isOpen:e.defaultOpen||!1},r}return i(t,e),l(t,[{key:"componentWillMount",value:function(){this.state.isOpen&&this.bindClickListener()}},{key:"componentWillUnmount",value:function(){this.removeClickListener()}},{key:"onBodyClick",value:function(e){var t=e.target;return this.state.isOpen?a(this.shouldPreventCloseAction)&&!0===this.shouldPreventCloseAction(t)?null:this.shouldPreventPropagationByClassName(t)||this.shouldPreventPropagationByElement(t)?null:void this.close():null}},{key:"render",value:function(){var e=this.props.children,t="undefined"===typeof e?"undefined":s(e);if("undefined"!==t&&"function"!==t)throw new TypeError("Toggler: `children` must be a function");var r=this.close,n=this.open,o=this.toggle,i=this.CLASS_NO_MODAL_CLICK,a=this.preventCloseAction,u=this.state.isOpen,l=this.toggleContent?this.toggleContent.bind(this):e;return l?l({isOpen:u,close:r,open:n,toggle:o,CLASS_NO_MODAL_CLICK:i,preventCloseAction:a}):null}}]),t}(u.Component);f.defaultProps={defaultOpen:!1},t.default=f}])}(r("Jmof"))}(window)},f2ea:function(e,t){},ixLB:function(e,t){},lVK7:function(e,t,r){"use strict";function n(e){return"function"===typeof e}function o(e,t){return void 0===e||null===e?null:n(e)?e(t):e}function i(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function s(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function l(e){var t=e.children,r=e.hasCloseBtn,n=e.close;return y.a.createElement("header",{className:"MODAL__modal-content-header"},y.a.createElement("h2",{className:"MODAL__modal-content-header-body"},t),r&&y.a.createElement(j,{onClick:n}))}function c(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function f(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function p(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var d=r("Jmof"),y=r.n(d),h=r("wLXD"),g=r.n(h),m=r("T9WB"),v=r.n(m),b=r("JgyH"),_=r.n(b),w=r("bepL"),O=r.n(w),E=(r("zr3G"),function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()),S=function e(t,r,n){null===t&&(t=Function.prototype);var o=Object.getOwnPropertyDescriptor(t,r);if(void 0===o){var i=Object.getPrototypeOf(t);return null===i?void 0:e(i,r,n)}if("value"in o)return o.value;var a=o.get;return void 0!==a?a.call(n):void 0},x=function(e){function t(e){a(this,t);var r=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.__view=r.__view.bind(r),r.draw=r.draw.bind(r),r.onEscape=r.onEscape.bind(r),r}return s(t,e),E(t,[{key:"componentDidUpdate",value:function(){this.draw()}},{key:"componentWillUnmount",value:function(){S(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"componentWillUnmount",this).call(this),this.close()}},{key:"onEscape",value:function(e){27!==e.keyCode&&27!==e.which&&"Escape"!==e.code&&"Escape"!==e.key||this.close()}},{key:"togglerWillOpen",value:function(){this.target||(this.target=document.createElement("div"),this.target.className=this.targetClassName,document.body.appendChild(this.target),this.props.closeOnEscape&&window.addEventListener("keyup",this.onEscape),this.draw())}},{key:"togglerDidOpen",value:function(){var e=this;setTimeout(function(){return e.target.classList.add("shown")},0),n(this.props.onOpen)&&this.props.onOpen()}},{key:"togglerWillClose",value:function(e){var t=this;this.target&&(this.target.classList.remove("shown"),this.target.addEventListener("transitionend",function(){g.a.unmountComponentAtNode(t.target),document.body.removeChild(t.target),t.target=void 0,e()},{once:!0}),window.removeEventListener("keyup",this.onEscape))}},{key:"togglerDidClose",value:function(){n(this.props.onClose)&&this.props.onClose()}},{key:"__view",value:function(e){return this.props.children(e)}},{key:"draw",value:function(){this.target&&g.a.unstable_renderSubtreeIntoContainer(this,this.__view(this.modalProps),this.target)}},{key:"render",value:function(){return o(this.props.trigger,this.modalProps)}},{key:"targetClassName",get:function(){return _()("MODAL__modal",this.props.name)}},{key:"modalProps",get:function(){var e=this.open,t=this.close,r=this.toggle,n=this.preventCloseAction,o=this.state.isOpen,a=this.props,u=(a.trigger,a.children,i(a,["trigger","children"]));return Object.assign({},{open:e,close:t,toggle:r,preventCloseAction:n,isOpen:o},u)}}]),t}(O.a);x.propTypes={onOpen:v.a.func,onClose:v.a.func,closeOnEscape:v.a.bool,bindBodyClickListener:v.a.bool,trigger:v.a.func},x.defaultProps={closeOnEscape:!0,bindBodyClickListener:!0};var k=x,P=(r("m+lv"),function(e){var t=e.children,r=e.preventCloseAction;return e.isOpen?y.a.createElement("div",{className:"MODAL__modal-content",ref:r},t):null});P.propTypes={children:v.a.oneOfType([v.a.arrayOf(v.a.node),v.a.node]).isRequired};var C=P,A=(r("2KtJ"),function(e){var t=e.onClick;return y.a.createElement("button",{className:"MODAL__modal-content-close",onClick:t},y.a.createElement("span",null,"\xd7"))});A.propTypes={onClick:v.a.func.isRequired};var j=A;r("Qwgx"),l.propTypes={children:v.a.oneOfType([v.a.arrayOf(v.a.node),v.a.node]).isRequired},l.defaultProps={hasCloseBtn:!0};var T=l,M=(r("f2ea"),function(e){var t=e.children;return y.a.createElement("section",{className:"MODAL__modal-content-body"},t)});M.propTypes={children:v.a.oneOfType([v.a.arrayOf(v.a.node),v.a.node]).isRequired};var I=M,L=(r("zvIh"),function(e){var t=e.children;return y.a.createElement("footer",{className:"MODAL__modal-content-footer"},t)});L.propTypes={children:v.a.oneOfType([v.a.arrayOf(v.a.node),v.a.node]).isRequired};var N=L,R=(r("ixLB"),function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()),B=function(e){function t(){return c(this,t),f(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return p(t,e),R(t,[{key:"__view",value:function(e){var t=this.props,r=t.header,n=t.footer,i=t.children,a=t.hasCloseBtn;return y.a.createElement(C,e,r&&y.a.createElement(T,{hasCloseBtn:a,close:e.close},o(r,e)),i&&y.a.createElement(I,null,o(i,e)),n&&y.a.createElement(N,null,o(n,e)))}}]),t}(k);B.propTypes={header:v.a.any,footer:v.a.any,children:v.a.any,hasCloseBtn:v.a.bool};var F=B;r.d(t,"Base",function(){return F}),t.default=k},"m+lv":function(e,t){},wLXD:function(e,t){e.exports=n},zr3G:function(e,t){},zvIh:function(e,t){}})})},"90f2":function(e,t){},"9RYf":function(e,t){},FVwl:function(e,t,r){function n(e){return void 0===e||null===e}function o(e){var t=p.spaceIndex(e);if(-1===t)return{html:"",closing:"/"===e[e.length-2]};e=p.trim(e.slice(t+1,-1));var r="/"===e[e.length-1];return r&&(e=p.trim(e.slice(0,-1))),{html:e,closing:r}}function i(e){var t={};for(var r in e)t[r]=e[r];return t}function a(e){e=i(e||{}),e.stripIgnoreTag&&(e.onIgnoreTag&&console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'),e.onIgnoreTag=s.onIgnoreTagStripAll),e.whiteList=e.whiteList||s.whiteList,e.onTag=e.onTag||s.onTag,e.onTagAttr=e.onTagAttr||s.onTagAttr,e.onIgnoreTag=e.onIgnoreTag||s.onIgnoreTag,e.onIgnoreTagAttr=e.onIgnoreTagAttr||s.onIgnoreTagAttr,e.safeAttrValue=e.safeAttrValue||s.safeAttrValue,e.escapeHtml=e.escapeHtml||s.escapeHtml,this.options=e,!1===e.css?this.cssFilter=!1:(e.css=e.css||{},this.cssFilter=new u(e.css))}var u=r("0Zbq").FilterCSS,s=r("oz9r"),l=r("krhF"),c=l.parseTag,f=l.parseAttr,p=r("noAI");a.prototype.process=function(e){if(e=e||"",!(e=e.toString()))return"";var t=this,r=t.options,i=r.whiteList,a=r.onTag,u=r.onIgnoreTag,l=r.onTagAttr,d=r.onIgnoreTagAttr,y=r.safeAttrValue,h=r.escapeHtml,g=t.cssFilter;r.stripBlankChar&&(e=s.stripBlankChar(e)),r.allowCommentTag||(e=s.stripCommentTag(e));var m=!1;if(r.stripIgnoreTagBody){var m=s.StripTagBody(r.stripIgnoreTagBody,u);u=m.onIgnoreTag}var v=c(e,function(e,t,r,s,c){var m={sourcePosition:e,position:t,isClosing:c,isWhite:i.hasOwnProperty(r)},v=a(r,s,m);if(!n(v))return v;if(m.isWhite){if(m.isClosing)return"</"+r+">";var b=o(s),_=i[r],w=f(b.html,function(e,t){var o=-1!==p.indexOf(_,e),i=l(r,e,t,o);if(!n(i))return i;if(o)return t=y(r,e,t,g),t?e+'="'+t+'"':e;var i=d(r,e,t,o);return n(i)?void 0:i}),s="<"+r;return w&&(s+=" "+w),b.closing&&(s+=" /"),s+=">"}var v=u(r,s,m);return n(v)?h(s):v},h);return m&&(v=m.remove(v)),v},e.exports=a},Jc4e:function(e,t){e.exports={firstStepId:"intro",lastStepId:"feedback",steps:[{id:"intro",header:{title:"intro.header.title"},body:{title:"intro.body.title",subtitle:"intro.body.subtitle",components:{radioGroup:{name:"report_type",validations:[{type:"required",value:!0}],options:[{label:"intro.body.misleading_profile",value:"misleading",nextStep:"misleading_profile"},{label:"intro.body.inappropriate_content",value:"inappropriate",nextStep:"inappropriate_content"},{label:"intro.body.spam",value:"spam"},{label:"intro.body.other",value:"other",toggle:{name:"reason",placeholder:"intro.body.add_details"}}]}}},footer:{primaryButton:{label:"general.next"}}},{id:"misleading_profile",header:{title:"misleading_profile.header.title"},body:{title:"misleading_profile.body.title",components:{radioGroup:{name:"report_sub_type",validations:[{type:"required",value:!0}],options:[{label:"misleading_profile.body.profile_image",value:"profile_image"},{label:"misleading_profile.body.description",value:"description"},{label:"misleading_profile.body.skills",value:"skills"},{label:"misleading_profile.body.other",value:"other"}]},textBox:{name:"reason",header:"misleading_profile.body.add_info"}}},footer:{primaryButton:{label:"general.submit"},secondaryButton:{label:"general.back"}}},{id:"inappropriate_content",header:{title:"inappropriate_content.header.title"},body:{title:"inappropriate_content.body.title",components:{textBox:{name:"report_sub_type",validations:[{type:"required",value:!0},{type:"minLength",value:5}]}}},footer:{primaryButton:{label:"general.submit"},secondaryButton:{label:"general.back"}}},{id:"feedback",header:{title:"feedback.header.title"},body:{title:"feedback.body.title",description:"feedback.body.description"},footer:{primaryButton:{label:"general.close"}}}]}},JgyH:function(t,r){t.exports=e},Jmof:function(e,r){e.exports=t},NG4M:function(e,t,r){function n(e,t){return new a(t).process(e)}var o=r("oz9r"),i=r("krhF"),a=r("FVwl");t=e.exports=n,t.FilterXSS=a;for(var u in o)t[u]=o[u];for(var u in i)t[u]=i[u];"undefined"!==typeof window&&(window.filterXSS=e.exports),function(){return"undefined"!==typeof self&&"undefined"!==typeof DedicatedWorkerGlobalScope&&self instanceof DedicatedWorkerGlobalScope}()&&(self.filterXSS=e.exports)},PbPb:function(e,t){e.exports=r},T9WB:function(e,t){e.exports=n},"Uo+f":function(e,t,r){function n(e,t){function r(){if(!i){var r=o.trim(e.slice(a,u)),n=r.indexOf(":");if(-1!==n){var l=o.trim(r.slice(0,n)),c=o.trim(r.slice(n+1));if(l){var f=t(a,s.length,l,c,r);f&&(s+=f+"; ")}}}a=u+1}e=o.trimRight(e),";"!==e[e.length-1]&&(e+=";");for(var n=e.length,i=!1,a=0,u=0,s="";u<n;u++){var l=e[u];if("/"===l&&"*"===e[u+1]){var c=e.indexOf("*/",u+2);if(-1===c)break;u=c+1,a=u+1,i=!1}else"("===l?i=!0:")"===l?i=!1:";"===l?i||r():"\n"===l&&r()}return o.trim(s)}var o=r("jCb9");e.exports=n},YUIh:function(e,t,r){!function(t,r){e.exports=r()}("undefined"!=typeof self&&self,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=6)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.reduceArrayToMap=t.isType=t.getSize=t.findValInArrayOrString=t.findArrayValuesInMapKeys=t.findArrayValuesInArray=t.expectType=void 0;var o=r(20),i=n(o),a=r(21),u=n(a),s=r(22),l=n(s),c=r(23),f=n(c),p=r(24),d=n(p),y=r(25),h=n(y),g=r(26),m=n(g);t.expectType=i.default,t.findArrayValuesInArray=u.default,t.findArrayValuesInMapKeys=l.default,t.findValInArrayOrString=f.default,t.getSize=d.default,t.isType=h.default,t.reduceArrayToMap=m.default},function(e,t,r){"use strict";function n(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t.default=e,t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(9),i=n(o),a=r(10),u=n(a);t.default={Errors:i,Modules:u},e.exports=t.default},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.runtimeError=void 0;var n=r(5),o=function(e){return e&&e.__esModule?e:{default:e}}(n);t.runtimeError=o.default},function(e,t,r){"use strict";function n(e,t,r,n){if("function"!=typeof n[t])return"function"==typeof r[t]&&r[t](e);var o=r[t];return n[t](e,o)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),i=t.WARN="warn",a=t.FAIL="fail",u=[i,a],s=function(){function e(t){n(this,e),this.name=t,this.hasValidationErrors=!1,this.hasValidationWarnings=!1,this.failCount=0,this.warnCount=0,this.testCount=0,this.testsPerformed={},this.validationErrors={},this.validationWarnings={},this.skipped=[]}return o(e,[{key:"initFieldCounters",value:function(e){return this.testsPerformed[e]?this:(this.testsPerformed[e]={testCount:0,failCount:0,warnCount:0},this)}},{key:"bumpTestCounter",value:function(e){return this.testsPerformed[e]?(this.testsPerformed[e].testCount++,this.testCount++,this):this}},{key:"bumpTestWarning",value:function(e,t){this.hasValidationWarnings=!0,this.validationWarnings[e]=this.validationWarnings[e]||[],this.validationWarnings[e].push(t),this.warnCount++,this.testsPerformed[e].warnCount++}},{key:"bumpTestError",value:function(e,t){this.hasValidationErrors=!0,this.validationErrors[e]=this.validationErrors[e]||[],this.validationErrors[e].push(t),this.failCount++,this.testsPerformed[e].failCount++}},{key:"fail",value:function(e,t,r){return this.testsPerformed[e]?((r&&u.includes(r)?r:a)===i?this.bumpTestWarning(e,t):this.bumpTestError(e,t),this):this}},{key:"addToSkipped",value:function(e){return!this.skipped.includes(e)&&this.skipped.push(e),this}},{key:"getErrors",value:function(e){return e?this.validationErrors[e]?this.validationErrors[e]:[]:this.validationErrors}},{key:"getWarnings",value:function(e){return e?this.validationWarnings[e]?this.validationWarnings[e]:[]:this.validationWarnings}}]),e}();t.default=s},function(e,t,r){"use strict";function n(e,t){return"["+a.Modules.PASSABLE+"]: Failed to execute '"+e+"': "+t}function o(e,t,r){return"Unexpected '"+e+"'. Expected `"+t+"` at position "+r+". See documentation for more info."}function i(e){switch(e){case a.Errors.INVALID_FORM_NAME:return new TypeError(n(u,"Unexpected '"+(arguments.length<=1?void 0:arguments[1])+"', expected string."));case a.Errors.ENFORCE_FAILED:return new Error(n(a.Modules.ENFORCE,(arguments.length<=1?void 0:arguments[1])+" - invalid "+(arguments.length<=2?void 0:arguments[2])+" value."));case a.Errors.EXPECT_TYPE_FAILURE:var t=Array.isArray(arguments.length<=2?void 0:arguments[2])?JSON.stringify(arguments.length<=2?void 0:arguments[2]):arguments.length<=2?void 0:arguments[2];return new TypeError(n(arguments.length<=1?void 0:arguments[1],"expected "+t+" to be a "+(arguments.length<=3?void 0:arguments[3])+"."));case a.Errors.MISSING_ARGUMENT_TESTS:return new TypeError(n(u,o(arguments.length<=1?void 0:arguments[1],"tests",1)));case a.Errors.UNEXPECTED_ARGUMENT_SPECIFIC:return new TypeError(n(u,o(arguments.length<=1?void 0:arguments[1],"specific",2)));case a.Errors.VALIDATE_UNEXPECTED_TEST:return new TypeError(n(a.Modules.VALIDATE,"Expected "+(arguments.length<=1?void 0:arguments[1])+" `test` to be a function."));default:return new Error(n(a.Modules.PASSABLE,"General exception."))}}Object.defineProperty(t,"__esModule",{value:!0});var a=r(1),u=a.Modules.PASSABLE+" constructor";t.default=i,e.exports=t.default},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t,r){return new a.default(e,t,r)}Object.defineProperty(t,"__esModule",{value:!0});var i=r(7),a=n(i),u=r(12),s=n(u),l=r(45),c=n(l),f=r(4),p=r(46);o.VERSION=p.version,o.enforce=u.enforce,o.Enforce=s.default,o.validate=c.default,o.WARN=f.WARN,o.FAIL=f.FAIL,t.default=o,e.exports=t.default},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},a=r(8),u=n(a),s=r(4),l=n(s),c=r(2),f=r(11),p=n(f),d=r(1),y=function e(t,r,n){var a=this;if(o(this,e),this.test=function(e,t,r,n){if(a.specific.excludes(e))return void a.res.addToSkipped(e);a.res.initFieldCounters(e),"function"==typeof r&&((0,u.default)(r)||a.res.fail(e,t,n),a.res.bumpTestCounter(e))},"string"!=typeof t)throw(0,c.runtimeError)(d.Errors.INVALID_FORM_NAME,void 0===t?"undefined":i(t));if("function"!=typeof r)throw(0,c.runtimeError)(d.Errors.MISSING_ARGUMENT_TESTS,void 0===r?"undefined":i(r));return this.specific=new p.default(n),this.res=new l.default(t),r(this.test),this.res};t.default=y,e.exports=t.default},function(e,t,r){"use strict";function n(e){var t=null;if("function"!=typeof e)return!1;try{var r=e();t=void 0!==r&&null!==r&&r.hasOwnProperty("valid")?r.valid:"boolean"!=typeof r||r||!1}catch(e){t=!1}return!!t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n,e.exports=t.default},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.INVALID_FORM_NAME="0",t.ENFORCE_FAILED="1",t.EXPECT_TYPE_FAILURE="2",t.MISSING_ARGUMENT_TESTS="3",t.UNEXPECTED_ARGUMENT_SPECIFIC="4",t.VALIDATE_UNEXPECTED_TEST="5"},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.PASSABLE="Passable",t.ENFORCE="Enforce",t.VALIDATE="Validate"},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),a=r(2),u=r(1),s=function(){function e(t){if(n(this,e),t){if(!e.is(t))throw(0,a.runtimeError)(u.Errors.UNEXPECTED_ARGUMENT_SPECIFIC,void 0===t?"undefined":o(t));if("string"==typeof t||Array.isArray(t)){if(0===t.length)return;return void(this.only=this.populateGroup(this.only,t))}t.only&&(this.only=this.populateGroup(this.only,t.only)),t.not&&(this.not=this.populateGroup(this.not,t.not))}}return i(e,[{key:"populateGroup",value:function(e,t){return e=e||{},"string"==typeof t?e[t]=!0:Array.isArray(t)&&t.forEach(function(t){return e[t]=!0}),e}},{key:"excludes",value:function(e){return!(!this.only||this.only[e])||!(!this.not||!this.not[e])}}],[{key:"is",value:function(e){return Array.isArray(e)?e.every(function(e){return"string"==typeof e}):"string"==typeof e||!(null===e||"object"!==(void 0===e?"undefined":o(e))||!e.hasOwnProperty("only")&&!e.hasOwnProperty("not"))}}]),e}();t.default=s,e.exports=t.default},function(e,t,r){"use strict";function n(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t.default=e,t}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.enforce=void 0;var i=r(13),a=n(i),u=r(39),s=n(u),l=r(42),c=function(e){return e&&e.__esModule?e:{default:e}}(l),f=function e(){var t=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return o(this,e),this.enforce=function(e){var r=(0,c.default)(t.allRunnables,{get:function(n,o){return t.rules.hasOwnProperty(o)&&"function"==typeof t.rules[o]?function(){for(var n=arguments.length,i=Array(n),a=0;a<n;a++)i[a]=arguments[a];return s.rule.apply(s,[t.rules[o],e].concat(i)),r}:a.compounds.hasOwnProperty(o)&&"function"==typeof a.compounds[o]?function(n){return s.compound(t.rules,a.compounds[o],e,n),r}:n[o]}});return r},this.rules=Object.assign({},a.rules,r),this.allRunnables=Object.assign({},a.compounds,this.rules),this.enforce},p=new f({});t.default=f,t.enforce=p},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.rules=t.compounds=void 0;var o=r(14),i=n(o),a=r(18),u=n(a);t.compounds=i.default,t.rules=u.default},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=r(15),i=n(o),a=r(16),u=n(a),s=r(17),l=n(s);t.default={allOf:i.default,anyOf:u.default,noneOf:l.default},e.exports=t.default},function(e,t,r){"use strict";function n(e,t,r){var n=Object.keys(t);return 0!==n.length&&n.every(function(n){return!0===(0,i.default)(e,n,t,r)})}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var o=r(3),i=function(e){return e&&e.__esModule?e:{default:e}}(o);e.exports=t.default},function(e,t,r){"use strict";function n(e,t,r){return Object.keys(t).some(function(n){return!0===(0,i.default)(e,n,t,r)})}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var o=r(3),i=function(e){return e&&e.__esModule?e:{default:e}}(o);e.exports=t.default},function(e,t,r){"use strict";function n(e,t,r){var n=Object.keys(t);return 0!==n.length&&n.every(function(n){return!0!==(0,i.default)(e,n,t,r)})}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var o=r(3),i=function(e){return e&&e.__esModule?e:{default:e}}(o);e.exports=t.default},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=r(19),i=n(o),a=r(27),u=n(a),s=r(28),l=n(s),c=r(29),f=n(c),p=r(30),d=n(p),y=r(31),h=n(y),g=r(32),m=n(g),v=r(33),b=n(v),_=r(34),w=n(_),O=r(35),E=n(O),S=r(36),x=n(S),k=r(37),P=n(k),C=r(38),A=n(C),j={isArray:i.default,isNumber:u.default,isString:l.default,matches:f.default,inside:d.default,isNumeric:h.default,isEmpty:m.default,largerThan:w.default,smallerThan:E.default,smallerThanOrEquals:x.default,largerThanOrEquals:P.default,sizeEquals:b.default};t.default=(0,A.default)(j),e.exports=t.default},function(e,t,r){"use strict";function n(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return(0,o.expectType)(t,"boolean","isArray"),(0,o.isType)(e,"array")===t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="isNotArray",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t,r){if(!(0,o.isType)(e,t))throw(0,i.runtimeError)(a.Errors.EXPECT_TYPE_FAILURE,r,e,t);return!0}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0),i=r(2),a=r(1);t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){var r=(0,o.reduceArrayToMap)(t);return(0,o.findArrayValuesInMapKeys)(e,r)}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return!!t&&e.every(function(e){return t&&t.has(e)})}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return t.indexOf(e)>-1}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){return e?"number"!=typeof e||isNaN(e)?e.hasOwnProperty("length")?e.length:"object"===(void 0===e?"undefined":o(e))?Object.keys(e).length:0:e:0}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];return r.some(function(t){return"array"===t?Array.isArray(e):(void 0===e?"undefined":o(e))===t})}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){return e.reduce(function(e,t){return e.set(t,!0),e},new Map)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return(0,o.expectType)(t,"boolean","isNumber"),(0,o.isType)(e,"number")===t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="isNotNumber",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return(0,o.expectType)(t,"boolean","isString"),(0,o.isType)(e,"string")===t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="isNotString",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return t instanceof RegExp?t.test(e):!!(0,o.isType)(t,"string")&&new RegExp(t).test(e)}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="notMatches",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){if(Array.isArray(t)){if((0,o.isType)(e,"string","number","boolean"))return(0,o.findValInArrayOrString)(e,t);if(Array.isArray(e))return(0,o.findArrayValuesInArray)(e,t)}return!(!(0,o.isType)(t,"string")||!(0,o.isType)(e,"string"))&&(0,o.findValInArrayOrString)(e,t)}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="notInside",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return(0,o.expectType)(t,"boolean","isNumeric"),(!isNaN(parseFloat(e))&&isFinite(e))===t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="isNotNumeric",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return(0,o.expectType)(t,"boolean","isEmpty"),0===(0,o.getSize)(e)===t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="isNotEmpty",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return(0,o.getSize)(e)===t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);n.negativeForm="sizeNotEquals",t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return(0,o.getSize)(e)>t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return(0,o.getSize)(e)<t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return(0,o.getSize)(e)<=t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e,t){return(0,o.getSize)(e)>=t}Object.defineProperty(t,"__esModule",{value:!0});var o=r(0);t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){for(var t in e)!function(t){var r=e[t].negativeForm;r&&(e[r]=function(){return!e[t].apply(e,arguments)})}(t);return e}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.rule=t.compound=void 0;var o=r(40),i=n(o),a=r(41),u=n(a);t.compound=i.default,t.rule=u.default},function(e,t,r){"use strict";function n(e,t,r,n){if("function"==typeof t&&!0!==t(r,n,e))throw(0,a.runtimeError)(i.Errors.ENFORCE_FAILED,t.name,void 0===r?"undefined":o(r))}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=r(1),a=r(2);t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function o(e,t){if("function"==typeof e){for(var r=arguments.length,o=Array(r>2?r-2:0),s=2;s<r;s++)o[s-2]=arguments[s];if(!0!==e.apply(void 0,[t].concat(n(o))))throw(0,u.runtimeError)(a.Errors.ENFORCE_FAILED,e.name,void 0===t?"undefined":i(t))}}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},a=r(1),u=r(2);t.default=o,e.exports=t.default},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return s.default.Proxy?new Proxy(e,t):new((0,a.default)())(e,t)}Object.defineProperty(t,"__esModule",{value:!0});var i=r(43),a=n(i),u=r(44),s=n(u);t.default=o,e.exports=t.default},function(e,t,r){"use strict";var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};e.exports=function(){function e(e){return!!e&&("object"===(void 0===e?"undefined":n(e))||"function"==typeof e)}var t=null,r=void 0;return r=function(r,n){if(!e(r)||!e(n))throw new TypeError("Cannot create proxy with a non-object as target or handler");var o=function(){};t=function(){o=function(e){throw new TypeError("Cannot perform '"+e+"' on a proxy that has been revoked")}};var i=n;n={get:null,set:null,apply:null,construct:null};for(var a in i){if(!(a in n))throw new TypeError("Proxy polyfill does not support trap '"+a+"'");n[a]=i[a]}"function"==typeof i&&(n.apply=i.apply.bind(i));var u=this,s=!1,l=!1;"function"==typeof r?(u=function(){var e=this&&this.constructor===u,t=Array.prototype.slice.call(arguments);return o(e?"construct":"apply"),e&&n.construct?n.construct.call(this,r,t):!e&&n.apply?n.apply(r,this,t):e?(t.unshift(r),new(r.bind.apply(r,t))):r.apply(this,t)},s=!0):r instanceof Array&&(u=[],l=!0);var c=n.get?function(e){return o("get"),n.get(this,e,u)}:function(e){return o("get"),this[e]},f=n.set?function(e,t){o("set"),n.set(this,e,t,u)}:function(e,t){o("set"),this[e]=t},p=Object.getOwnPropertyNames(r),d={};p.forEach(function(e){if(!((s||l)&&e in u)){var t=Object.getOwnPropertyDescriptor(r,e),n={enumerable:!!t.enumerable,get:c.bind(r,e),set:f.bind(r,e)};Object.defineProperty(u,e,n),d[e]=!0}});var y=!0;if(Object.setPrototypeOf?Object.setPrototypeOf(u,Object.getPrototypeOf(r)):u.__proto__?u.__proto__=r.__proto__:y=!1,n.get||!y)for(var h in r)d[h]||Object.defineProperty(u,h,{get:c.bind(r,h)});return Object.seal(r),Object.seal(u),u},r.revocable=function(e,n){return{proxy:new r(e,n),revoke:t}},r}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=void 0;try{n=function(){}.constructor("return this")()}catch(e){n=window}t.default=n,e.exports=t.default},function(e,t,r){"use strict";function n(e){if("function"!=typeof e)throw(0,a.default)(u.Errors.VALIDATE_UNEXPECTED_TEST,void 0===e?"undefined":o(e));try{return!1!==e()}catch(e){return!1}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=r(5),a=function(e){return e&&e.__esModule?e:{default:e}}(i),u=r(1);t.default=n,e.exports=t.default},function(e,t){e.exports={version:"6.0.6"}}])})},eIBB:function(e,t){e.exports={report_user:{general:{report:"Report",next:"Next",back:"Back",close:"Close",submit:"Submit",other:"Other"},intro:{header:{title:"Report User"},body:{title:"Why would you like to report %{username}?",subtitle:"Your report will be kept anonymous",misleading_profile:"The user\u2019s profile is misleading",inappropriate_content:"The user\u2019s content and/or behavior is inappropriate",spam:"The user sends me spam messages",add_details:"Please elaborate in detail"}},misleading_profile:{header:{title:"Report Misleading Profile"},body:{title:"What is misleading about %{username}\u2019s profile?",profile_image:"Profile Image",description:"Description",skills:"Skills",others:"other",add_info:"Additional Information (optional)"}},inappropriate_content:{header:{title:"Report Inappropriate User Behavior"},body:{title:"Please describe %{username}\u2019s inappropriate behavior in detail."}},feedback:{header:{title:"Thanks For Reporting"},body:{description:'We\u2019re sorry you\u2019ve had this experience. Our Trust and Safety Team will review your report shortly and take the required actions. Refer to our <a href="https://www.fiverr.com/privacy-policy" target="_blank">Privacy Policy</a> for more information on how we handle policy violations. <br><br>If you have any questions or concerns, please contact us <a href="https://www.fiverr.com/support" target="_blank">here</a>.'}}}}},h4G9:function(e,t){e.exports=o},huvo:function(e,t,r){function n(e){return void 0===e||null===e}function o(e){var t={};for(var r in e)t[r]=e[r];return t}function i(e){e=o(e||{}),e.whiteList=e.whiteList||a.whiteList,e.onAttr=e.onAttr||a.onAttr,e.onIgnoreAttr=e.onIgnoreAttr||a.onIgnoreAttr,e.safeAttrValue=e.safeAttrValue||a.safeAttrValue,this.options=e}var a=r("/cOS"),u=r("Uo+f");r("jCb9");i.prototype.process=function(e){if(e=e||"",!(e=e.toString()))return"";var t=this,r=t.options,o=r.whiteList,i=r.onAttr,a=r.onIgnoreAttr,s=r.safeAttrValue;return u(e,function(e,t,r,u,l){var c=o[r],f=!1;if(!0===c?f=c:"function"===typeof c?f=c(u):c instanceof RegExp&&(f=c.test(u)),!0!==f&&(f=!1),u=s(r,u)){var p={position:t,sourcePosition:e,source:l,isWhite:f};if(f){var d=i(r,u,p);return n(d)?r+":"+u:d}var d=a(r,u,p);return n(d)?void 0:d}})},e.exports=i},iB1M:function(e,t){},iCOP:function(e,t){},jCb9:function(e,t){e.exports={indexOf:function(e,t){var r,n;if(Array.prototype.indexOf)return e.indexOf(t);for(r=0,n=e.length;r<n;r++)if(e[r]===t)return r;return-1},forEach:function(e,t,r){var n,o;if(Array.prototype.forEach)return e.forEach(t,r);for(n=0,o=e.length;n<o;n++)t.call(r,e[n],n,e)},trim:function(e){return String.prototype.trim?e.trim():e.replace(/(^\s*)|(\s*$)/g,"")},trimRight:function(e){return String.prototype.trimRight?e.trimRight():e.replace(/(\s*$)/g,"")}}},jPm4:function(e,t){e.exports=i},krhF:function(e,t,r){function n(e){var t=f.spaceIndex(e);if(-1===t)var r=e.slice(1,-1);else var r=e.slice(1,t+1);return r=f.trim(r).toLowerCase(),"/"===r.slice(0,1)&&(r=r.slice(1)),"/"===r.slice(-1)&&(r=r.slice(0,-1)),r}function o(e){return"</"===e.slice(0,2)}function i(e,t,r){"user strict";var i="",a=0,u=!1,s=!1,l=0,c=e.length,f="",p="";for(l=0;l<c;l++){var d=e.charAt(l);if(!1===u){if("<"===d){u=l;continue}}else if(!1===s){if("<"===d){i+=r(e.slice(a,l)),u=l,a=l;continue}if(">"===d){i+=r(e.slice(a,u)),p=e.slice(u,l+1),f=n(p),i+=t(u,i.length,f,p,o(p)),a=l+1,u=!1;continue}if(('"'===d||"'"===d)&&"="===e.charAt(l-1)){s=d;continue}}else if(d===s){s=!1;continue}}return a<e.length&&(i+=r(e.substr(a))),i}function a(e,t){"user strict";function r(e,r){if(e=f.trim(e),e=e.replace(p,"").toLowerCase(),!(e.length<1)){var n=t(e,r||"");n&&o.push(n)}}for(var n=0,o=[],i=!1,a=e.length,l=0;l<a;l++){var d,y,h=e.charAt(l);if(!1!==i||"="!==h)if(!1===i||l!==n||'"'!==h&&"'"!==h||"="!==e.charAt(l-1))if(/\s|\n|\t/.test(h)){if(e=e.replace(/\s|\n|\t/g," "),!1===i){if(-1===(y=u(e,l))){d=f.trim(e.slice(n,l)),r(d),i=!1,n=l+1;continue}l=y-1;continue}if(-1===(y=s(e,l-1))){d=f.trim(e.slice(n,l)),d=c(d),r(i,d),i=!1,n=l+1;continue}}else;else{if(-1===(y=e.indexOf(h,l+1)))break;d=f.trim(e.slice(n+1,y)),r(i,d),i=!1,l=y,n=l+1}else i=e.slice(n,l),n=l+1}return n<e.length&&(!1===i?r(e.slice(n)):r(i,c(f.trim(e.slice(n))))),f.trim(o.join(" "))}function u(e,t){for(;t<e.length;t++){var r=e[t];if(" "!==r)return"="===r?t:-1}}function s(e,t){for(;t>0;t--){var r=e[t];if(" "!==r)return"="===r?t:-1}}function l(e){return'"'===e[0]&&'"'===e[e.length-1]||"'"===e[0]&&"'"===e[e.length-1]}function c(e){return l(e)?e.substr(1,e.length-2):e}var f=r("noAI"),p=/[^a-zA-Z0-9_:\.\-]/gim;t.parseTag=i,t.parseAttr=a},lVK7:function(e,t,r){"use strict";function n(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e){function t(e,t){return r[e]=r.hasOwnProperty(e)?r[e]:t()}for(var r={},n=arguments.length,o=Array(n>1?n-1:0),i=1;i<n;i++)o[i-1]=arguments[i];o.forEach(function(r){return a.call(e,r,t)})}function a(e,t){var r=this,n=Object.getOwnPropertyDescriptor(this.constructor.prototype,e),o=ge.reduce(function(o,i){switch(he(n[i])){case"undefined":break;case"function":me.includes(i)?o[i]=function(){return t(e+"$"+i,n[i].bind(r))}:o[i]=n[i];break;default:o[i]=n[i]}return o},{});Object.defineProperty(this,e,o)}function u(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments[2];if(!e||"string"!==typeof e)throw new Error(Se+" route missing");if(0===e.indexOf(Pe))return console.warn(Se,"Using dev only route. Make sure to replace it before going live."),ke;var n=void 0;try{n=fiverrRoutes[e]}catch(e){if(Oe.prod)return ke;throw new Error(Se+" missing global routes object")}var o=[];if(n=n.replace(Ee,function(e,r,n){var i=t[n];return i?""+r+i:("("!==e[0]&&o.push(n),"")}),o.length)throw new Error(Se+" required params missing:\n"+o.join(",\n"));return r?xe+n:n}function l(){var e=new Headers;e.append("X-Requested-With","XMLHttpRequest"),e.append("Content-Type","application/json; charset=utf-8"),e.append("Accept","application/json");try{e.append("X-CSRF-Token",document.AUTH_TOKEN)}catch(e){}return e}function c(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function f(e,t){var r=qe[e];if(!r)throw new Error("invalid validation type - "+e);return c({},e,r(t))}function p(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!We()(e))throw new TypeError("Invalid fields object");return Ie()("reportUserForm",function(r){Object.values(e).forEach(function(e){return(e.validations||[]).forEach(function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=n.type,i=n.value,a=f(o,i);return r(e.name,o,function(){Object(Me.enforce)(t[e.name]).allOf(a)})})})})}function d(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function y(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function h(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function g(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function m(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var v=r("Jmof"),b=r.n(v),_=r("wLXD"),w=r.n(_),O=r("PbPb"),E=r.n(O),S=r("T9WB"),x=r.n(S),k=(r("h4G9"),r("iB1M"),function(e){var t=e.options,r=e.name,n=e.selectedValue,o=e.onChange;return b.a.createElement("radiogroup",null,t.map(function(e,t){return b.a.createElement("label",{key:t,className:"fake-radio-green radio-text"},i18n.t("report_user."+e.label),b.a.createElement("input",{type:"radio",name:r,checked:n===e.value,value:e.value,onChange:function(){return o(r,e.value,e.nextStep)}}),b.a.createElement("span",{className:"radio-img"}),e.toggle&&b.a.createElement("div",{className:"toggle"},b.a.createElement(I,{name:e.toggle.name,nextStep:e.nextStep,onChange:o})))}))});k.PropTypes={name:x.a.string,onChange:x.a.func,selectedValue:x.a.oneOf([x.a.string,x.a.number]),options:x.a.arrayOf(x.a.shape({value:x.a.string,label:x.a.string,nextStep:x.a.string,toggle:x.a.object}))},k.defaultProps={onChange:function(){return null}};var P=k,C=r("5CFU"),A=(r("0Qmd"),r("nJV9"),function(e){var t=e.trigger,r=e.header,n=e.footer,o=e.children;return b.a.createElement(C.Base,{trigger:t,header:r,footer:n},o)});A.PropTypes={trigger:x.a.func.isRequired,header:x.a.func,footer:x.a.func,children:x.a.func};var j=A,T=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},M=function(e){var t=e.nextStep,r=e.name,o=e.onChange,i=n(e,["nextStep","name","onChange"]);return b.a.createElement("textarea",T({},i,{name:r,onChange:function(e){return o(r,e.target.value,t)}}))};M.PropTypes={placeholder:x.a.string,value:x.a.string,name:x.a.string.isRequired,nextStep:x.a.string,onChange:x.a.func},M.defaultProps={onChange:function(){return null}};var I=M,L=function(e){var t=e.title,r=e.subtitle;return b.a.createElement("h3",null,t,r&&b.a.createElement("small",null,r))};L.PropTypes={title:x.a.string,subtitle:x.a.string};var N=L,R=r("JgyH"),B=r.n(R),F=(r("90f2"),Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}),D=function(e){var t=e.type,r=e.disabled,n=e.onClick,i=e.children,a=o(e,["type","disabled","onClick","children"]),u=B()("btn-standard","btn-"+t,{"btn-green-grad":"primary"===t,disabled:r});return b.a.createElement("button",F({className:u,onClick:n},a),i)};D.PropTypes={type:x.a.oneOf(["primary","secondary"]),disabled:x.a.bool,onClick:x.a.func.isRequired,children:x.a.oneOf([x.a.node,x.a.arrayOf(x.a.node)])},D.defaultProps={type:"primary"};var q=D,V=r("NG4M"),W=r.n(V),U=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},G=function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return function(){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];return t.forEach(function(e){return e&&e.apply(void 0,r)})}},z={stripIgnoreTag:!0},X=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return W()(e,U({},z,t))},H="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},J=function(e){return"object"===("undefined"===typeof Fiverr?"undefined":H(Fiverr))&&"function"===typeof Fiverr[e]||void 0},K=function(e){return function(){var t;return J(e)&&(t=Fiverr)[e].apply(t,arguments)}},Y=K("_logErrorToServer"),Q=(K("sendClientEvents"),K("_logEventToGraphite"),Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}),Z=x.a.shape({name:x.a.string.isRequired,validations:x.a.arrayOf(x.a.shape({type:x.a.string.isRequired,value:x.a.any}))}),$=x.a.shape(Q({},Z,{options:x.a.arrayOf(x.a.shape({label:x.a.string.isRequired,value:x.a.any.isRequired,nextStep:x.a.string}))})),ee=x.a.shape(Q({},Z,{header:x.a.string})),te=x.a.shape({id:x.a.string.isRequired,header:{title:x.a.string.isRequired,description:x.a.string},body:{title:x.a.string,description:x.a.string,components:{radioGroup:$,textBox:ee}},footer:{title:x.a.string.isRequired,description:x.a.string.isRequired}}),re={PropTypes:{formState:x.a.object,layout:te.isRequired,onChange:x.a.func,user:x.a.shape({username:x.a.string})},defaultProps:{formState:{},onChange:function(){return null}}},ne=function(e){var t=e.layout,r=e.user,n=e.formState,o=e.onChange,i=r.username,a=t.body,u=a.title,s=a.subtitle,l=t.body.components.radioGroup,c=n[l.name];return b.a.createElement("div",{className:"intro"},b.a.createElement(N,{title:i18n.t("report_user."+u,{username:i}),subtitle:i18n.t("report_user."+s)}),b.a.createElement(P,{options:l.options,selectedValue:c,name:l.name,onChange:o}))};Object.assign(ne,re);var oe=ne,ie=(r("9RYf"),function(e){var t=e.layout,r=e.user,n=e.formState,o=e.onChange,i=r.username,a=t.body.title,u=t.body.components.radioGroup,s=t.body.components.textBox,l=n[u.name],c=n[s.name];return b.a.createElement("div",{className:"misleading-profile"},b.a.createElement(N,{title:i18n.t("report_user."+a,{username:i})}),b.a.createElement(P,{options:u.options,selectedValue:l,name:u.name,onChange:o}),b.a.createElement(N,{title:i18n.t("report_user."+s.header)}),b.a.createElement(I,{name:s.name,value:c,onChange:o}))});Object.assign(ie,re);var ae=ie,ue=(r("mG7U"),function(e){var t=e.layout;return b.a.createElement("div",{className:"feedback"},b.a.createElement("p",{dangerouslySetInnerHTML:{__html:i18n.t("report_user."+t.body.description)}}))});Object.assign(ue,re);var se=ue,le=function(e){var t=e.layout,r=e.user,n=e.formState,o=e.onChange,i=r.username,a=t.body.title,u=t.body.components.textBox,s=n[u.name];return b.a.createElement("div",{className:"inappropriate-content"},b.a.createElement(N,{title:i18n.t("report_user."+a,{username:i})}),b.a.createElement(I,{name:u.name,value:s,rows:4,onChange:o}))};Object.assign(le,re);var ce=le,fe="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},pe="object"===("undefined"===typeof window?"undefined":fe(window))&&window.window===window&&window||"object"===("undefined"===typeof GLOBAL?"undefined":fe(GLOBAL))&&GLOBAL.GLOBAL===GLOBAL&&GLOBAL||"object"===("undefined"===typeof self?"undefined":fe(self))&&self.self===self&&self,de="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},ye=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:pe;return e.split(".").reduce(function(e,t){return"object"===("undefined"===typeof e?"undefined":de(e))?e[t]:e},t)},he="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},ge=["get","value","set","configurable","enumerable","writable"],me=["get","value"],ve=function(){return pe.document&&"function"===typeof pe.document.createElement},be="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"===typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},_e=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),we=function(){function e(){u(this,e),i(this,"node","browser","development","production","testing","plike","toString")}return _e(e,[{key:"toString",value:function(){return(ye(this.browser?"app.environment":"process.env.NODE_ENV")||"").toLowerCase()}},{key:"node",get:function(){return"[object process]"===Object.prototype.toString.call("undefined"!==typeof pe.process?pe.process:0)}},{key:"browser",get:function(){return ve()||!this.node&&["undefined"===typeof document?"undefined":be(document),"undefined"===typeof window?"undefined":be(window)].every(function(e){return"undefined"!==e})}},{key:"development",get:function(){return this.toString().includes("dev")}},{key:"dev",get:function(){return this.development}},{key:"production",get:function(){return this.toString().includes("prod")}},{key:"prod",get:function(){return this.production}},{key:"testing",get:function(){return this.toString().includes("test")}},{key:"test",get:function(){return this.testing}},{key:"plike",get:function(){return this.toString().includes("like")}}]),e}(),Oe=new we,Ee=/\(?([^(]?):(\w+)\)?/g,Se="[pathFinder]:",xe="https://www.fiverr.com",ke="/",Pe="__dev__",Ce=r("jPm4"),Ae=r.n(Ce),je=function(){return{credentials:"same-origin",headers:l()}},Te=Ae()(je),Me=r("YUIh"),Ie=r.n(Me),Le=r("q16o"),Ne=r.n(Le),Re=function(e){return!Ne()(e)},Be=function(){return Re},Fe=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return function(t){return!(!Re(t)||!t.hasOwnProperty("length"))&&t.length>=e}},De={required:Be,minLength:Fe},qe=De,Ve=r("yCNF"),We=r.n(Ve),Ue=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),Ge=Symbol(),ze=function(){function e(t,r){if(d(this,e),!t)throw new TypeError("json arg is required");if(!r)throw new TypeError("user arg is required");this.json=t,this.user=r,this.model=E.a.cloneDeep(t)}return Ue(e,[{key:"getStepById",value:function(e){return this.model.steps.find(function(t){return t.id===e})}},{key:"submitForm",value:function(e){var t=this[Ge](e),r={method:"POST",body:JSON.stringify(t)};return Te(this.submissionPath,r).then(function(e){return e.json()})}},{key:Ge,value:function(e){var t={},r=this.user,n=r.id,o=r.username;for(var i in e)for(var a in e[i])t[a]=X(e[i][a]);return{reported_user_id:n,reported_user_name:o,report:t}}},{key:"validate",value:function(e,t){var r=e.body.components,n=void 0===r?{}:r,o=p(n,t);return window.__DEV__&&o.hasValidationErrors&&console.log(o.validationErrors),{hasValidationErrors:o.hasValidationErrors}}},{key:"firstStepId",get:function(){return this.model.firstStepId}},{key:"lastStepId",get:function(){return this.model.lastStepId}},{key:"submissionPath",get:function(){return s("user_report_user_index",{user_id:this.user.id})}}]),e}(),Xe=ze,He=r("eIBB"),Je=r.n(He),Ke=r("Jc4e"),Ye=r.n(Ke),Qe=(r("iCOP"),Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}),Ze=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),$e=function(e){function t(e){h(this,t);var r=g(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return i18n.add(Je.a),r.reportModel=new Xe(Ye.a,e.user),r.state=r.initialState,["renderModalHeader","renderModalBody","renderModalFooter","handleFormChange","handleStepSubmit","navigateBack","resetState"].forEach(function(e){return r[e]=r[e].bind(r)}),r}return m(t,e),Ze(t,[{key:"handleFormChange",value:function(e,t,r){var n=this.currentStepId,o=this.state.submissionData[n],i=void 0===o?{}:o;i[e]=t;var a=Object.assign({},this.state.submissionData,y({},n,i));this.setState({submissionData:a,nextStepId:r})}},{key:"handleStepSubmit",value:function(){var e=this.state,t=e.nextStepId,r=e.steps;this.isInLastStep?this.submitReport():this.setState({steps:r.concat(t)})}},{key:"navigateBack",value:function(){var e=this.currentStepId,t=this.state.steps.slice(0,-1),r=Qe({},this.state.submissionData);delete r[this.currentStepId],this.setState({steps:t,submissionData:r,nextStepId:e})}},{key:"submitReport",value:function(){var e=this,t=this.state.submissionData,r=this.reportModel.lastStepId;return this.reportModel.submitForm(t).catch(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};Y("ReportUser.js","submitReport()",e.message)}).then(function(){var t=e.state.steps.concat(r);e.setState({steps:t,isReportSubmitted:!0})})}},{key:"resetState",value:function(){this.setState(this.initialState)}},{key:"renderTriggerButton",value:function(e){var t=e.open;return b.a.createElement(q,{className:"modal-trigger",onClick:t},b.a.createElement("i",{className:"fa fa-flag"}),i18n.t("report_user.general.report"))}},{key:"renderModalHeader",value:function(){return i18n.t("report_user."+this.currentStep.header.title)}},{key:"renderModalBody",value:function(){var e=this.currentStep,t=this.handleFormChange,r=this.currentStepId,n=this.stepComponent,o=this.state.submissionData,i=this.props.user,a={user:i,formState:o[r],layout:e,onChange:t};return b.a.createElement("div",{className:"report-user-modal-body"},b.a.createElement(n,a))}},{key:"renderModalFooter",value:function(e){var t=e.close,r=this.currentStepId,n=this.currentStep,o=this.state,i=o.submissionData,a=o.isReportSubmitted,u=n.footer,s=u.primaryButton,l=u.secondaryButton,c=this.reportModel.validate(n,i[r]),f=c.hasValidationErrors,p=a?G(t,E.a.debounce(this.resetState,100)):this.handleStepSubmit,d=this.navigateBack;return b.a.createElement("aside",{className:"report-user-modal-footer"},l&&b.a.createElement(q,{type:"secondary",onClick:d},i18n.t("report_user."+l.label)),b.a.createElement(q,{type:"primary",disabled:f,onClick:p},i18n.t("report_user."+s.label)))}},{key:"render",value:function(){return b.a.createElement("div",{className:"report-user-package"},b.a.createElement(j,{trigger:this.renderTriggerButton,header:this.renderModalHeader,footer:this.renderModalFooter},this.renderModalBody))}},{key:"initialState",get:function(){return{submissionData:{},nextStepId:null,isReportSubmitted:!1,steps:[this.reportModel.firstStepId]}}},{key:"currentStepId",get:function(){var e=this.state.steps;return e[e.length-1]}},{key:"currentStep",get:function(){return this.reportModel.getStepById(this.currentStepId)}},{key:"stepComponent",get:function(){var e;return(e={},y(e,"intro",oe),y(e,"misleading_profile",ae),y(e,"inappropriate_content",ce),y(e,"feedback",se),e)[this.currentStepId]}},{key:"isInLastStep",get:function(){return!this.state.nextStepId}}]),t}(v.PureComponent);$e.propTypes={user:x.a.shape({username:x.a.string,id:x.a.number})};var et=$e,tt="undefined"!==typeof document&&document.getElementById("ReportUser-component");if(tt){var rt=window.initialData.ReportUser;w.a.render(b.a.createElement(et,rt),tt)}t.default=et},mG7U:function(e,t){},nJV9:function(e,t){},noAI:function(e,t){e.exports={indexOf:function(e,t){var r,n;if(Array.prototype.indexOf)return e.indexOf(t);for(r=0,n=e.length;r<n;r++)if(e[r]===t)return r;return-1},forEach:function(e,t,r){var n,o;if(Array.prototype.forEach)return e.forEach(t,r);for(n=0,o=e.length;n<o;n++)t.call(r,e[n],n,e)},trim:function(e){return String.prototype.trim?e.trim():e.replace(/(^\s*)|(\s*$)/g,"")},spaceIndex:function(e){var t=/\s|\n|\t/,r=t.exec(e);return r?r.index:-1}}},oz9r:function(e,t,r){function n(){return{a:["target","href","title"],abbr:["title"],address:[],area:["shape","coords","href","alt"],article:[],aside:[],audio:["autoplay","controls","loop","preload","src"],b:[],bdi:["dir"],bdo:["dir"],big:[],blockquote:["cite"],br:[],caption:[],center:[],cite:[],code:[],col:["align","valign","span","width"],colgroup:["align","valign","span","width"],dd:[],del:["datetime"],details:["open"],div:[],dl:[],dt:[],em:[],font:["color","size","face"],footer:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],header:[],hr:[],i:[],img:["src","alt","title","width","height"],ins:["datetime"],li:[],mark:[],nav:[],ol:[],p:[],pre:[],s:[],section:[],small:[],span:[],sub:[],sup:[],strong:[],table:["width","border","align","valign"],tbody:["align","valign"],td:["width","rowspan","colspan","align","valign"],tfoot:["align","valign"],th:["width","rowspan","colspan","align","valign"],thead:["align","valign"],tr:["rowspan","align","valign"],tt:[],u:[],ul:[],video:["autoplay","controls","loop","preload","src","height","width"]}}function o(e,t,r){}function i(e,t,r){}function a(e,t,r){}function u(e,t,r){}function s(e){return e.replace(x,"&lt;").replace(k,"&gt;")}function l(e,t,r,n){if(r=h(r),"href"===t||"src"===t){if("#"===(r=E.trim(r)))return"#";if("http://"!==r.substr(0,7)&&"https://"!==r.substr(0,8)&&"mailto:"!==r.substr(0,7)&&"tel:"!==r.substr(0,4)&&"#"!==r[0]&&"/"!==r[0])return""}else if("background"===t){if(M.lastIndex=0,M.test(r))return""}else if("style"===t){if(I.lastIndex=0,I.test(r))return"";if(L.lastIndex=0,L.test(r)&&(M.lastIndex=0,M.test(r)))return"";!1!==n&&(n=n||S,r=n.process(r))}return r=g(r)}function c(e){return e.replace(P,"&quot;")}function f(e){return e.replace(C,'"')}function p(e){return e.replace(A,function(e,t){return"x"===t[0]||"X"===t[0]?String.fromCharCode(parseInt(t.substr(1),16)):String.fromCharCode(parseInt(t,10))})}function d(e){return e.replace(j,":").replace(T," ")}function y(e){for(var t="",r=0,n=e.length;r<n;r++)t+=e.charCodeAt(r)<32?" ":e.charAt(r);return E.trim(t)}function h(e){return e=f(e),e=p(e),e=d(e),e=y(e)}function g(e){return e=c(e),e=s(e)}function m(){return""}function v(e,t){function r(t){return!!n||-1!==E.indexOf(e,t)}"function"!==typeof t&&(t=function(){});var n=!Array.isArray(e),o=[],i=!1;return{onIgnoreTag:function(e,n,a){if(r(e)){if(a.isClosing){var u="[/removed]",s=a.position+u.length;return o.push([!1!==i?i:a.position,s]),i=!1,u}return i||(i=a.position),"[removed]"}return t(e,n,a)},remove:function(e){var t="",r=0;return E.forEach(o,function(n){t+=e.slice(r,n[0]),r=n[1]}),t+=e.slice(r)}}}function b(e){return e.replace(N,"")}function _(e){var t=e.split("");return t=t.filter(function(e){var t=e.charCodeAt(0);return 127!==t&&(!(t<=31)||(10===t||13===t))}),t.join("")}var w=r("0Zbq").FilterCSS,O=r("0Zbq").getDefaultWhiteList,E=r("noAI"),S=new w,x=/</g,k=/>/g,P=/"/g,C=/&quot;/g,A=/&#([a-zA-Z0-9]*);?/gim,j=/&colon;?/gim,T=/&newline;?/gim,M=/((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/gi,I=/e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi,L=/u\s*r\s*l\s*\(.*/gi,N=/<!--[\s\S]*?-->/g;t.whiteList=n(),t.getDefaultWhiteList=n,t.onTag=o,t.onIgnoreTag=i,t.onTagAttr=a,t.onIgnoreTagAttr=u,t.safeAttrValue=l,t.escapeHtml=s,t.escapeQuote=c,t.unescapeQuote=f,t.escapeHtmlEntities=p,t.escapeDangerHtml5Entities=d,t.clearNonPrintableCharacter=y,t.friendlyAttrValue=h,t.escapeAttrValue=g,t.onIgnoreTagStripAll=m,t.StripTagBody=v,t.stripCommentTag=b,t.stripBlankChar=_,t.cssFilter=S,t.getDefaultCSSWhiteList=O},q16o:function(e,t){function r(e){return null==e}e.exports=r},wLXD:function(e,t){e.exports=a},yCNF:function(e,t){function r(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}e.exports=r}})});
//# sourceMappingURL=index.4c53c19cd288f99f9290.js.map

/***/ }),

/***/ "noAI":
/***/ (function(module, exports) {

module.exports = {
  indexOf: function(arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function(arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function(str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  }
};


/***/ }),

/***/ "oz9r":
/***/ (function(module, exports, __webpack_require__) {

/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = __webpack_require__("0Zbq").FilterCSS;
var getDefaultCSSWhiteList = __webpack_require__("0Zbq").getDefaultWhiteList;
var _ = __webpack_require__("noAI");

function getDefaultWhiteList() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: ["autoplay", "controls", "loop", "preload", "src"],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height"],
    ins: ["datetime"],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: ["autoplay", "controls", "loop", "preload", "src", "height", "width"]
  };
}

var defaultCSSFilter = new FilterCSS();

/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onTag(tag, html, options) {
  // do nothing
}

/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onIgnoreTag(tag, html, options) {
  // do nothing
}

/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onIgnoreTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default escapeHtml function
 *
 * @param {String} html
 */
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}

/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */
function safeAttrValue(tag, name, value, cssFilter) {
  // unescape attribute value firstly
  value = friendlyAttrValue(value);

  if (name === "href" || name === "src") {
    // filter `href` and `src` attribute
    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
    value = _.trim(value);
    if (value === "#") return "#";
    if (
      !(
        value.substr(0, 7) === "http://" ||
        value.substr(0, 8) === "https://" ||
        value.substr(0, 7) === "mailto:" ||
        value.substr(0, 4) === "tel:" ||
        value[0] === "#" ||
        value[0] === "/"
      )
    ) {
      return "";
    }
  } else if (name === "background") {
    // filter `background` attribute (maybe no use)
    // `javascript:`
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name === "style") {
    // `expression()`
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    // `url()`
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }

  // escape `<>"` before returns
  value = escapeAttrValue(value);
  return value;
}

// RegExp list
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;

/**
 * escape doube quote
 *
 * @param {String} str
 * @return {String} str
 */
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}

/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}

/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
    return code[0] === "x" || code[0] === "X"
      ? String.fromCharCode(parseInt(code.substr(1), 16))
      : String.fromCharCode(parseInt(code, 10));
  });
}

/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeDangerHtml5Entities(str) {
  return str
    .replace(REGEXP_ATTR_VALUE_COLON, ":")
    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}

/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i = 0, len = str.length; i < len; i++) {
    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
  }
  return _.trim(str2);
}

/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}

/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}

/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */
function onIgnoreTagStripAll() {
  return "";
}

/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */
function StripTagBody(tags, next) {
  if (typeof next !== "function") {
    next = function() {};
  }

  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag) return true;
    return _.indexOf(tags, tag) !== -1;
  }

  var removeList = [];
  var posStart = false;

  return {
    onIgnoreTag: function(tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next(tag, html, options);
      }
    },
    remove: function(html) {
      var rethtml = "";
      var lastPos = 0;
      _.forEach(removeList, function(pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    }
  };
}

/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */
function stripCommentTag(html) {
  return html.replace(STRIP_COMMENT_TAG_REGEXP, "");
}
var STRIP_COMMENT_TAG_REGEXP = /<!--[\s\S]*?-->/g;

/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function(char) {
    var c = char.charCodeAt(0);
    if (c === 127) return false;
    if (c <= 31) {
      if (c === 10 || c === 13) return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}

exports.whiteList = getDefaultWhiteList();
exports.getDefaultWhiteList = getDefaultWhiteList;
exports.onTag = onTag;
exports.onIgnoreTag = onIgnoreTag;
exports.onTagAttr = onTagAttr;
exports.onIgnoreTagAttr = onIgnoreTagAttr;
exports.safeAttrValue = safeAttrValue;
exports.escapeHtml = escapeHtml;
exports.escapeQuote = escapeQuote;
exports.unescapeQuote = unescapeQuote;
exports.escapeHtmlEntities = escapeHtmlEntities;
exports.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
exports.clearNonPrintableCharacter = clearNonPrintableCharacter;
exports.friendlyAttrValue = friendlyAttrValue;
exports.escapeAttrValue = escapeAttrValue;
exports.onIgnoreTagStripAll = onIgnoreTagStripAll;
exports.StripTagBody = StripTagBody;
exports.stripCommentTag = stripCommentTag;
exports.stripBlankChar = stripBlankChar;
exports.cssFilter = defaultCSSFilter;
exports.getDefaultCSSWhiteList = getDefaultCSSWhiteList;


/***/ }),

/***/ "wLXD":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.3719e85d08422b145e41.js